msgid ""
msgstr ""
"POT-Creation-Date: 2025-06-21 23:16+0200\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: en\n"
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Plural-Forms: \n"

#. placeholder {0}: call.name
#. placeholder {1}: call.summary
#: src/share/components/chat/ChatMessage.tsx
msgid "{0} — {1}"
msgstr "{0} — {1}"

#. placeholder {0}: fixedFormat(item.volume ?? 0)
#. placeholder {1}: item.count ?? 0
#. placeholder {2}: displayDate(new Date(item.since ?? '')) ?? ''
#: src/timber/components/provider/ProviderDetail/ProviderAttentionList.tsx
msgid "{0} m³ in {1} pieces has been standing since {2}."
msgstr "{0} m³ in {1} pieces has been standing since {2}."

#. placeholder {0}: file.row_count
#: src/share/components/chat/ChatFileList.tsx
msgid "{0} row(s)"
msgstr "{0} row(s)"

#. placeholder {0}: call.name
#: src/share/components/chat/ChatMessage.tsx
msgid "{0} running…"
msgstr "{0} running…"

#: src/share/components/layout/Layout/Layout.tsx
msgid "+ Add column"
msgstr "+ Add column"

#: src/share/components/gdpr/CookieConsent.tsx
msgid "Accept"
msgstr "Accept"

#: src/pages/ActivationPage.tsx
msgid "Access token is valid"
msgstr "Access token is valid"

#: src/timber/components/accountingUser/AccountingUserDetail/AccountingUserDetail.tsx
#: src/timber/pages/accountingUser/AccountingUserEntityPage.tsx
msgid "Accounting User"
msgstr "Accounting User"

#: src/timber/hooks/useAccountingUser.ts
msgid "Accounting User add error: "
msgstr "Accounting User add error: "

#: src/timber/hooks/useAccountingUser.ts
msgid "Accounting User delete error: "
msgstr "Accounting User delete error: "

#: src/timber/hooks/useAccountingUser.ts
msgid "Accounting User deleted"
msgstr "Accounting User deleted"

#: src/timber/hooks/useAccountingUser.ts
msgid "Accounting User update error: "
msgstr "Accounting User update error: "

#: src/timber/hooks/useAccountingUser.ts
msgid "Accounting User updated"
msgstr "Accounting User updated"

#: src/app/mappers.tsx
#: src/auth/components/user/UserDetail/UserTabs.tsx
#: src/timber/components/accountingUser/AccountingUserList/AccountingUserListHeader.tsx
#: src/timber/pages/listItems.tsx
msgid "Accounting Users"
msgstr "Accounting Users"

#: src/timber/components/cordwoodHistory/CordwoodHistoryDetail/CordwoodHistoryDetail.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryForm/CordwoodHistoryAddForm.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListItem.tsx
#: src/timber/components/history/HistoryList/HistoryListItem.tsx
#: src/timber/components/history/HistoryList/HistoryListSearch.tsx
#: src/timber/components/logHistory/LogHistoryDetail/LogHistoryDetail.tsx
#: src/timber/components/logHistory/LogHistoryForm/LogHistoryAddForm.tsx
#: src/timber/components/logHistory/LogHistoryForm/LogHistoryUpdateForm.tsx
#: src/timber/components/logHistory/LogHistoryList/LogHistoryListItem.tsx
#: src/timber/components/shipmentHistory/ShipmentHistoryDetail/ShipmentHistoryDetail.tsx
#: src/timber/components/shipmentHistory/ShipmentHistoryForm/ShipmentHistoryAddForm.tsx
#: src/timber/components/shipmentHistory/ShipmentHistoryList/ShipmentHistoryListItem.tsx
msgid "Action"
msgstr "Action"

#: src/timber/components/cordwoodHistory/CordwoodHistoryForm/CordwoodHistoryAddForm.tsx
#: src/timber/components/logHistory/LogHistoryForm/LogHistoryAddForm.tsx
#: src/timber/components/logHistory/LogHistoryForm/LogHistoryUpdateForm.tsx
#: src/timber/components/shipmentHistory/ShipmentHistoryForm/ShipmentHistoryAddForm.tsx
msgid "Action is required"
msgstr "Action is required"

#: src/pages/ActivationPage.tsx
msgid "Activate"
msgstr "Activate"

#: src/auth/components/user/UserDetail/UserDetail.tsx
#: src/auth/components/user/UserForm/UserAddForm.tsx
#: src/auth/components/user/UserForm/UserUpdateForm.tsx
#: src/auth/components/user/UserList/UserListItem.tsx
msgid "Activated"
msgstr "Activated"

#: src/pages/ActivationPage.tsx
msgid "Activation"
msgstr "Activation"

#: src/pages/ActivationPage.tsx
msgid "Activation code is required"
msgstr "Activation code is required"

#: src/pages/ActivationPage.tsx
msgid "Activation Token"
msgstr "Activation Token"

#: src/timber/components/cutting/CuttingList/ActiveCuttings.tsx
#: src/timber/components/provider/ProviderDetail/ProviderSummaryCards.tsx
#: src/timber/components/provider/ProviderList/ProviderListItem.tsx
msgid "Active cuttings"
msgstr "Active cuttings"

#: src/address/components/address/AddressForm/AddressAddFormProvider.tsx
#: src/address/components/address/AddressList/AddressListHeader.tsx
#: src/address/components/userAddress/UserAddressForm/UserAddressAddFormProvider.tsx
#: src/address/components/userAddress/UserAddressList/UserAddressListHeader.tsx
#: src/auth/components/membersGroup/MembersGroupForm/MembersGroupAddFormProvider.tsx
#: src/auth/components/membersGroup/MembersGroupList/MembersGroupListHeader.tsx
#: src/auth/components/membersGroupUser/MembersGroupUserForm/MembersGroupUserAddFormProvider.tsx
#: src/auth/components/membersGroupUser/MembersGroupUserList/MembersGroupUserListHeader.tsx
#: src/auth/components/role/RoleForm/RoleAddFormProvider.tsx
#: src/auth/components/role/RoleList/RoleListHeader.tsx
#: src/auth/components/roleAssignment/RoleAssignmentForm/RoleAssignmentAddFormProvider.tsx
#: src/auth/components/roleAssignment/RoleAssignmentList/RoleAssignmentListHeader.tsx
#: src/auth/components/rolePermission/RolePermissionForm/RolePermissionAddFormProvider.tsx
#: src/auth/components/rolePermission/RolePermissionList/RolePermissionListHeader.tsx
#: src/auth/components/scopeGroup/ScopeGroupForm/ScopeGroupAddFormProvider.tsx
#: src/auth/components/scopeGroup/ScopeGroupList/ScopeGroupListHeader.tsx
#: src/auth/components/user/UserForm/UserAddFormProvider.tsx
#: src/auth/components/user/UserList/UserListHeader.tsx
#: src/auth/components/userSession/UserSessionForm/UserSessionAddFormProvider.tsx
#: src/auth/components/userSession/UserSessionList/UserSessionListHeader.tsx
#: src/location/components/location/LocationForm/LocationAddFormProvider.tsx
#: src/location/components/location/LocationList/LocationListHeader.tsx
#: src/share/components/breadcrumbs/RouterBreadcrumbs.tsx
#: src/timber/components/accountingUser/AccountingUserForm/AccountingUserAddFormProvider.tsx
#: src/timber/components/accountingUser/AccountingUserList/AccountingUserListHeader.tsx
#: src/timber/components/buyer/BuyerForm/BuyerAddFormProvider.tsx
#: src/timber/components/buyer/BuyerList/BuyerListHeader.tsx
#: src/timber/components/buyerUser/BuyerUserForm/BuyerUserAddFormProvider.tsx
#: src/timber/components/buyerUser/BuyerUserList/BuyerUserListHeader.tsx
#: src/timber/components/contractor/ContractorForm/ContractorAddFormProvider.tsx
#: src/timber/components/contractor/ContractorList/ContractorListHeader.tsx
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserAddFormProvider.tsx
#: src/timber/components/contractorUser/ContractorUserList/ContractorUserListHeader.tsx
#: src/timber/components/cordwood/CordwoodForm/CordwoodAddFormProvider.tsx
#: src/timber/components/cordwood/CordwoodList/CordwoodListHeader.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryForm/CordwoodHistoryAddFormProvider.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListHeader.tsx
#: src/timber/components/cutting/CuttingForm/CuttingAddFormProvider.tsx
#: src/timber/components/cutting/CuttingList/CuttingListHeader.tsx
#: src/timber/components/forestOwner/ForestOwnerForm/ForestOwnerAddFormProvider.tsx
#: src/timber/components/forestOwner/ForestOwnerList/ForestOwnerListHeader.tsx
#: src/timber/components/log/LogForm/LogAddFormProvider.tsx
#: src/timber/components/log/LogList/LogListHeader.tsx
#: src/timber/components/logHistory/LogHistoryForm/LogHistoryAddFormProvider.tsx
#: src/timber/components/logHistory/LogHistoryList/LogHistoryListHeader.tsx
#: src/timber/components/price/PriceForm/PriceAddFormProvider.tsx
#: src/timber/components/price/PriceList/PriceListHeader.tsx
#: src/timber/components/pricingProfile/PricingProfileForm/PricingProfileAddFormProvider.tsx
#: src/timber/components/pricingProfile/PricingProfileList/PricingProfileListHeader.tsx
#: src/timber/components/provider/ProviderForm/ProviderAddFormProvider.tsx
#: src/timber/components/provider/ProviderList/ProviderListHeader.tsx
#: src/timber/components/providerUser/ProviderUserForm/ProviderUserAddFormProvider.tsx
#: src/timber/components/providerUser/ProviderUserList/ProviderUserListHeader.tsx
#: src/timber/components/roadCarrier/RoadCarrierForm/RoadCarrierAddFormProvider.tsx
#: src/timber/components/roadCarrier/RoadCarrierList/RoadCarrierListHeader.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentAddFormProvider.tsx
#: src/timber/components/shipment/ShipmentList/ShipmentListHeader.tsx
#: src/timber/components/shipmentHistory/ShipmentHistoryForm/ShipmentHistoryAddFormProvider.tsx
#: src/timber/components/shipmentHistory/ShipmentHistoryList/ShipmentHistoryListHeader.tsx
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassAddFormProvider.tsx
#: src/timber/components/thicknessClass/ThicknessClassList/ThicknessClassListHeader.tsx
#: src/timber/components/timberClass/TimberClassForm/TimberClassAddFormProvider.tsx
#: src/timber/components/timberClass/TimberClassList/TimberClassListHeader.tsx
#: src/timber/components/timberStorage/TimberStorageForm/TimberStorageAddFormProvider.tsx
#: src/timber/components/timberStorage/TimberStorageList/TimberStorageListHeader.tsx
#: src/timber/components/timberType/TimberTypeForm/TimberTypeAddFormProvider.tsx
#: src/timber/components/timberType/TimberTypeList/TimberTypeListHeader.tsx
#: src/timber/components/treeMarking/TreeMarkingForm/TreeMarkingAddFormProvider.tsx
#: src/timber/components/treeMarking/TreeMarkingList/TreeMarkingListHeader.tsx
msgid "Add"
msgstr "Add"

#: src/timber/components/accountingUser/AccountingUserForm/AccountingUserFormSelect.tsx
#: src/timber/pages/accountingUser/AccountingUserAddEditPage.tsx
msgid "Add Accounting User"
msgstr "Add Accounting User"

#: src/address/components/address/AddressForm/AddressFormSelect.tsx
#: src/address/pages/address/AddressAddEditPage.tsx
msgid "Add Address"
msgstr "Add Address"

#: src/timber/components/buyer/BuyerForm/BuyerFormSelect.tsx
#: src/timber/pages/buyer/BuyerAddEditPage.tsx
msgid "Add Buyer"
msgstr "Add Buyer"

#: src/timber/components/buyerUser/BuyerUserForm/BuyerUserFormSelect.tsx
#: src/timber/pages/buyerUser/BuyerUserAddEditPage.tsx
msgid "Add Buyer User"
msgstr "Add Buyer User"

#: src/timber/components/contractor/ContractorForm/ContractorFormSelect.tsx
#: src/timber/pages/contractor/ContractorAddEditPage.tsx
msgid "Add Contractor"
msgstr "Add Contractor"

#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserFormSelect.tsx
#: src/timber/pages/contractorUser/ContractorUserAddEditPage.tsx
msgid "Add Contractor User"
msgstr "Add Contractor User"

#: src/timber/components/cordwood/CordwoodForm/CordwoodFormSelect.tsx
#: src/timber/pages/cordwood/CordwoodAddEditPage.tsx
msgid "Add Cordwood"
msgstr "Add Cordwood"

#: src/timber/components/cordwoodHistory/CordwoodHistoryForm/CordwoodHistoryFormSelect.tsx
#: src/timber/pages/cordwoodHistory/CordwoodHistoryAddEditPage.tsx
msgid "Add Cordwood History"
msgstr "Add Cordwood History"

#: src/timber/components/cutting/CuttingForm/CuttingFormSelect.tsx
#: src/timber/pages/cutting/CuttingAddEditPage.tsx
msgid "Add Cutting"
msgstr "Add Cutting"

#: src/timber/pages/driver/DriverAddEditPage.tsx
#~ msgid "Add Driver"
#~ msgstr "Add Driver"

#: src/address/hooks/useAddress.ts
#: src/address/hooks/useUserAddress.ts
#: src/auth/hooks/useMembersGroup.ts
#: src/auth/hooks/useMembersGroupUser.ts
#: src/auth/hooks/useRole.ts
#: src/auth/hooks/useRoleAssignment.ts
#: src/auth/hooks/useRolePermission.ts
#: src/auth/hooks/useScopeGroup.ts
#: src/auth/hooks/useUser.ts
#: src/auth/hooks/useUserSession.ts
#: src/location/hooks/useLocation.ts
#: src/timber/hooks/useAccountingUser.ts
#: src/timber/hooks/useBuyer.ts
#: src/timber/hooks/useBuyerUser.ts
#: src/timber/hooks/useContractor.ts
#: src/timber/hooks/useContractorUser.ts
#: src/timber/hooks/useCordwood.ts
#: src/timber/hooks/useCordwoodHistory.ts
#: src/timber/hooks/useCutting.ts
#: src/timber/hooks/useForestOwner.ts
#: src/timber/hooks/useLog.ts
#: src/timber/hooks/useLogHistory.ts
#: src/timber/hooks/usePrice.ts
#: src/timber/hooks/usePricingProfile.ts
#: src/timber/hooks/useProvider.ts
#: src/timber/hooks/useProviderUser.ts
#: src/timber/hooks/useRoadCarrier.ts
#: src/timber/hooks/useShipment.ts
#: src/timber/hooks/useShipmentHistory.ts
#: src/timber/hooks/useThicknessClass.ts
#: src/timber/hooks/useTimberClass.ts
#: src/timber/hooks/useTimberStorage.ts
#: src/timber/hooks/useTimberType.ts
#: src/timber/hooks/useTreeMarking.ts
msgid "Add error: "
msgstr "Add error: "

#: src/timber/components/forestOwner/ForestOwnerForm/ForestOwnerFormSelect.tsx
#: src/timber/pages/forestOwner/ForestOwnerAddEditPage.tsx
msgid "Add Forest Owner"
msgstr "Add Forest Owner"

#: src/location/components/location/LocationForm/LocationFormSelect.tsx
#: src/location/pages/location/LocationAddEditPage.tsx
msgid "Add Location"
msgstr "Add Location"

#: src/timber/components/log/LogForm/LogFormSelect.tsx
#: src/timber/pages/log/LogAddEditPage.tsx
msgid "Add Log"
msgstr "Add Log"

#: src/timber/components/logHistory/LogHistoryForm/LogHistoryFormSelect.tsx
#: src/timber/pages/logHistory/LogHistoryAddEditPage.tsx
msgid "Add Log History"
msgstr "Add Log History"

#: src/auth/components/membersGroup/MembersGroupForm/MembersGroupFormSelect.tsx
#: src/auth/pages/membersGroup/MembersGroupAddEditPage.tsx
msgid "Add Members Group"
msgstr "Add Members Group"

#: src/auth/components/membersGroupUser/MembersGroupUserForm/MembersGroupUserFormSelect.tsx
#: src/auth/pages/membersGroupUser/MembersGroupUserAddEditPage.tsx
msgid "Add Members Group User"
msgstr "Add Members Group User"

#: src/timber/components/price/PriceForm/PriceFormSelect.tsx
#: src/timber/pages/price/PriceAddEditPage.tsx
msgid "Add Price"
msgstr "Add Price"

#: src/timber/components/pricingProfile/PricingProfileForm/PricingProfileFormSelect.tsx
#: src/timber/pages/pricingProfile/PricingProfileAddEditPage.tsx
msgid "Add Pricing Profile"
msgstr "Add Pricing Profile"

#: src/timber/components/provider/ProviderForm/ProviderFormSelect.tsx
#: src/timber/pages/provider/ProviderAddEditPage.tsx
msgid "Add Provider"
msgstr "Add Provider"

#: src/timber/components/providerUser/ProviderUserForm/ProviderUserFormSelect.tsx
#: src/timber/pages/providerUser/ProviderUserAddEditPage.tsx
msgid "Add Provider User"
msgstr "Add Provider User"

#: src/timber/components/roadCarrier/RoadCarrierForm/RoadCarrierFormSelect.tsx
#: src/timber/pages/roadCarrier/RoadCarrierAddEditPage.tsx
msgid "Add Road Carrier"
msgstr "Add Road Carrier"

#: src/auth/components/role/RoleForm/RoleFormSelect.tsx
#: src/auth/pages/role/RoleAddEditPage.tsx
msgid "Add Role"
msgstr "Add Role"

#: src/auth/components/roleAssignment/RoleAssignmentForm/RoleAssignmentFormSelect.tsx
#: src/auth/pages/roleAssignment/RoleAssignmentAddEditPage.tsx
msgid "Add Role Assignment"
msgstr "Add Role Assignment"

#: src/auth/components/rolePermission/RolePermissionForm/RolePermissionFormSelect.tsx
#: src/auth/pages/rolePermission/RolePermissionAddEditPage.tsx
msgid "Add Role Permission"
msgstr "Add Role Permission"

#: src/auth/components/scopeGroup/ScopeGroupForm/ScopeGroupFormSelect.tsx
#: src/auth/pages/scopeGroup/ScopeGroupAddEditPage.tsx
msgid "Add Scope Group"
msgstr "Add Scope Group"

#: src/timber/components/shipment/ShipmentForm/ShipmentFormSelect.tsx
#: src/timber/pages/shipment/ShipmentAddEditPage.tsx
msgid "Add Shipment"
msgstr "Add Shipment"

#: src/timber/components/shipmentHistory/ShipmentHistoryForm/ShipmentHistoryFormSelect.tsx
#: src/timber/pages/shipmentHistory/ShipmentHistoryAddEditPage.tsx
msgid "Add Shipment History"
msgstr "Add Shipment History"

#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassFormSelect.tsx
#: src/timber/pages/thicknessClass/ThicknessClassAddEditPage.tsx
msgid "Add Thickness Class"
msgstr "Add Thickness Class"

#: src/timber/components/timberClass/TimberClassForm/TimberClassFormSelect.tsx
#: src/timber/pages/timberClass/TimberClassAddEditPage.tsx
msgid "Add Timber Class"
msgstr "Add Timber Class"

#: src/timber/components/timberStorage/TimberStorageForm/TimberStorageFormSelect.tsx
#: src/timber/pages/timberStorage/TimberStorageAddEditPage.tsx
msgid "Add Timber Storage"
msgstr "Add Timber Storage"

#: src/timber/components/timberType/TimberTypeForm/TimberTypeFormSelect.tsx
#: src/timber/pages/timberType/TimberTypeAddEditPage.tsx
msgid "Add Timber Type"
msgstr "Add Timber Type"

#: src/timber/components/shipment/ShipmentRegulator/CordwoodDetail.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogDetail.tsx
msgid "Add to shipment"
msgstr "Add to shipment"

#: src/timber/components/treeMarking/TreeMarkingForm/TreeMarkingFormSelect.tsx
#: src/timber/pages/treeMarking/TreeMarkingAddEditPage.tsx
msgid "Add Tree Marking"
msgstr "Add Tree Marking"

#: src/auth/components/user/UserForm/UserFormSelect.tsx
#: src/auth/pages/user/UserAddEditPage.tsx
msgid "Add User"
msgstr "Add User"

#: src/address/components/userAddress/UserAddressForm/UserAddressFormSelect.tsx
#: src/address/pages/userAddress/UserAddressAddEditPage.tsx
msgid "Add User Address"
msgstr "Add User Address"

#: src/auth/components/userSession/UserSessionForm/UserSessionFormSelect.tsx
#: src/auth/pages/userSession/UserSessionAddEditPage.tsx
msgid "Add User Session"
msgstr "Add User Session"

#: src/address/components/address/AddressDetail/AddressDetail.tsx
#: src/address/components/address/AddressForm/AddressAddForm.tsx
#: src/address/components/address/AddressForm/AddressUpdateForm.tsx
#: src/address/components/address/AddressList/AddressListItem.tsx
#: src/address/components/userAddress/UserAddressDetail/UserAddressDetail.tsx
#: src/address/components/userAddress/UserAddressForm/UserAddressAddForm.tsx
#: src/address/components/userAddress/UserAddressList/UserAddressListItem.tsx
#: src/address/pages/address/AddressEntityPage.tsx
#: src/location/components/location/LocationDetail/LocationDetail.tsx
#: src/location/components/location/LocationForm/LocationAddForm.tsx
#: src/location/components/location/LocationForm/LocationUpdateForm.tsx
#: src/location/components/location/LocationList/LocationListItem.tsx
#: src/timber/components/buyer/BuyerDetail/BuyerDetail.tsx
#: src/timber/components/buyer/BuyerForm/BuyerAddForm.tsx
#: src/timber/components/buyer/BuyerForm/BuyerUpdateForm.tsx
#: src/timber/components/contractor/ContractorDetail/ContractorDetail.tsx
#: src/timber/components/contractor/ContractorForm/ContractorAddForm.tsx
#: src/timber/components/contractor/ContractorForm/ContractorUpdateForm.tsx
#: src/timber/components/forestOwner/ForestOwnerDetail/ForestOwnerDetail.tsx
#: src/timber/components/forestOwner/ForestOwnerForm/ForestOwnerAddForm.tsx
#: src/timber/components/forestOwner/ForestOwnerForm/ForestOwnerUpdateForm.tsx
#: src/timber/components/provider/ProviderDetail/ProviderDetail.tsx
#: src/timber/components/provider/ProviderForm/ProviderAddForm.tsx
#: src/timber/components/provider/ProviderForm/ProviderUpdateForm.tsx
#: src/timber/components/roadCarrier/RoadCarrierDetail/RoadCarrierDetail.tsx
#: src/timber/components/roadCarrier/RoadCarrierForm/RoadCarrierAddForm.tsx
#: src/timber/components/roadCarrier/RoadCarrierForm/RoadCarrierUpdateForm.tsx
msgid "Address"
msgstr "Address"

#: src/address/hooks/useAddress.ts
msgid "Address add error: "
msgstr "Address add error: "

#: src/address/hooks/useAddress.ts
msgid "Address delete error: "
msgstr "Address delete error: "

#: src/address/hooks/useAddress.ts
msgid "Address deleted"
msgstr "Address deleted"

#: src/address/components/userAddress/UserAddressForm/UserAddressAddForm.tsx
#~ msgid "Address Id is required"
#~ msgstr "Address Id is required"

#: src/address/components/userAddress/UserAddressForm/UserAddressAddForm.tsx
msgid "Address is required"
msgstr "Address is required"

#: src/address/hooks/useAddress.ts
msgid "Address update error: "
msgstr "Address update error: "

#: src/address/hooks/useAddress.ts
msgid "Address updated"
msgstr "Address updated"

#: src/address/components/address/AddressList/AddressListHeader.tsx
#: src/address/pages/listItems.tsx
#: src/app/mappers.tsx
msgid "Addresses"
msgstr "Addresses"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx
msgid "Adjust prices to the target total amount"
msgstr "Adjust prices to the target total amount"

#: src/app/App.tsx
#: src/timber/types/models/UserType.d.ts
msgid "Admin"
msgstr "Admin"

#: src/share/components/chat/ChatHeader.tsx
msgid "AI Assistant"
msgstr "AI Assistant"

#: src/share/components/chat/serverErrors.ts
#: src/share/components/chat/useChat.ts
msgid "AI chat is restricted to admin, providerAdmin or providerUser."
msgstr "AI chat is restricted to admin, providerAdmin or providerUser."

#: src/timber/components/history/HistoryList/HistoryListSearch.tsx
msgid "All"
msgstr "All"

#: src/timber/components/cutting/CuttingDetail/CuttingDetail.tsx
#: src/timber/components/cutting/CuttingForm/CuttingAddForm.tsx
#: src/timber/components/cutting/CuttingForm/CuttingUpdateForm.tsx
msgid "Allows Multi Storage Shipments"
msgstr "Allows Multi Storage Shipments"

#: src/pages/LoginPage.tsx
msgid "and"
msgstr "and"

#. placeholder {0}: group.items.length - ITEMS_PER_GROUP
#: src/timber/components/provider/ProviderDetail/ProviderAttentionList.tsx
msgid "and {0} more"
msgstr "and {0} more"

#: src/share/components/form/FormDateTime/FormDateRange.tsx
msgid "Apply"
msgstr "Apply"

#: src/share/components/chat/ChatThread.tsx
msgid "Ask about logs, shipments, buyers, or other timber data"
msgstr "Ask about logs, shipments, buyers, or other timber data"

#: src/auth/pages/scopeGroup/ScopeGroupDetailPage.tsx
msgid "Assign"
msgstr "Assign"

#: src/timber/components/generic/report/GenericRootShipments.tsx
#: src/timber/components/shipment/ShipmentList/ShipmentListItem.tsx
msgid "at"
msgstr "at"

#: src/auth/pages/listItems.tsx
msgid "Auth"
msgstr "Auth"

#: src/address/pages/address/AddressAddEditPage.tsx
#: src/address/pages/address/AddressDetailPage.tsx
#: src/address/pages/address/AddressUpdateEditPage.tsx
#: src/address/pages/userAddress/UserAddressAddEditPage.tsx
#: src/address/pages/userAddress/UserAddressDetailPage.tsx
#: src/address/pages/userAddress/UserAddressUpdateEditPage.tsx
#: src/auth/pages/membersGroup/MembersGroupAddEditPage.tsx
#: src/auth/pages/membersGroup/MembersGroupDetailPage.tsx
#: src/auth/pages/membersGroup/MembersGroupUpdateEditPage.tsx
#: src/auth/pages/membersGroupUser/MembersGroupUserAddEditPage.tsx
#: src/auth/pages/membersGroupUser/MembersGroupUserDetailPage.tsx
#: src/auth/pages/membersGroupUser/MembersGroupUserUpdateEditPage.tsx
#: src/auth/pages/role/RoleAddEditPage.tsx
#: src/auth/pages/role/RoleDetailPage.tsx
#: src/auth/pages/role/RoleUpdateEditPage.tsx
#: src/auth/pages/roleAssignment/RoleAssignmentAddEditPage.tsx
#: src/auth/pages/roleAssignment/RoleAssignmentDetailPage.tsx
#: src/auth/pages/roleAssignment/RoleAssignmentUpdateEditPage.tsx
#: src/auth/pages/rolePermission/RolePermissionAddEditPage.tsx
#: src/auth/pages/rolePermission/RolePermissionDetailPage.tsx
#: src/auth/pages/rolePermission/RolePermissionUpdateEditPage.tsx
#: src/auth/pages/scopeGroup/ScopeGroupAddEditPage.tsx
#: src/auth/pages/scopeGroup/ScopeGroupDetailPage.tsx
#: src/auth/pages/scopeGroup/ScopeGroupUpdateEditPage.tsx
#: src/auth/pages/user/UserAddEditPage.tsx
#: src/auth/pages/user/UserDetailPage.tsx
#: src/auth/pages/user/UserUpdateEditPage.tsx
#: src/auth/pages/userSession/UserSessionAddEditPage.tsx
#: src/auth/pages/userSession/UserSessionDetailPage.tsx
#: src/auth/pages/userSession/UserSessionUpdateEditPage.tsx
#: src/location/pages/location/LocationAddEditPage.tsx
#: src/location/pages/location/LocationDetailPage.tsx
#: src/location/pages/location/LocationUpdateEditPage.tsx
#: src/timber/pages/accountingUser/AccountingUserAddEditPage.tsx
#: src/timber/pages/accountingUser/AccountingUserDetailPage.tsx
#: src/timber/pages/accountingUser/AccountingUserUpdateEditPage.tsx
#: src/timber/pages/buyer/BuyerAddEditPage.tsx
#: src/timber/pages/buyer/BuyerDetailPage.tsx
#: src/timber/pages/buyer/BuyerUpdateEditPage.tsx
#: src/timber/pages/buyerUser/BuyerUserAddEditPage.tsx
#: src/timber/pages/buyerUser/BuyerUserDetailPage.tsx
#: src/timber/pages/buyerUser/BuyerUserUpdateEditPage.tsx
#: src/timber/pages/contractor/ContractorAddEditPage.tsx
#: src/timber/pages/contractor/ContractorDetailPage.tsx
#: src/timber/pages/contractor/ContractorUpdateEditPage.tsx
#: src/timber/pages/contractorUser/ContractorUserAddEditPage.tsx
#: src/timber/pages/contractorUser/ContractorUserDetailPage.tsx
#: src/timber/pages/contractorUser/ContractorUserUpdateEditPage.tsx
#: src/timber/pages/cordwood/CordwoodAddEditPage.tsx
#: src/timber/pages/cordwood/CordwoodDetailPage.tsx
#: src/timber/pages/cordwood/CordwoodUpdateEditPage.tsx
#: src/timber/pages/cordwoodHistory/CordwoodHistoryAddEditPage.tsx
#: src/timber/pages/cordwoodHistory/CordwoodHistoryDetailPage.tsx
#: src/timber/pages/cordwoodHistory/CordwoodHistoryUpdateEditPage.tsx
#: src/timber/pages/cutting/CuttingAddEditPage.tsx
#: src/timber/pages/cutting/CuttingDetailPage.tsx
#: src/timber/pages/cutting/CuttingUpdateEditPage.tsx
#: src/timber/pages/forestOwner/ForestOwnerAddEditPage.tsx
#: src/timber/pages/forestOwner/ForestOwnerDetailPage.tsx
#: src/timber/pages/forestOwner/ForestOwnerUpdateEditPage.tsx
#: src/timber/pages/log/LogAddEditPage.tsx
#: src/timber/pages/log/LogDetailPage.tsx
#: src/timber/pages/log/LogUpdateEditPage.tsx
#: src/timber/pages/logHistory/LogHistoryAddEditPage.tsx
#: src/timber/pages/logHistory/LogHistoryDetailPage.tsx
#: src/timber/pages/logHistory/LogHistoryUpdateEditPage.tsx
#: src/timber/pages/price/PriceAddEditPage.tsx
#: src/timber/pages/price/PriceDetailPage.tsx
#: src/timber/pages/price/PriceUpdateEditPage.tsx
#: src/timber/pages/pricingProfile/PricingProfileAddEditPage.tsx
#: src/timber/pages/pricingProfile/PricingProfileDetailPage.tsx
#: src/timber/pages/pricingProfile/PricingProfileUpdateEditPage.tsx
#: src/timber/pages/provider/ProviderAddEditPage.tsx
#: src/timber/pages/provider/ProviderDetailPage.tsx
#: src/timber/pages/provider/ProviderUpdateEditPage.tsx
#: src/timber/pages/providerUser/ProviderUserAddEditPage.tsx
#: src/timber/pages/providerUser/ProviderUserDetailPage.tsx
#: src/timber/pages/providerUser/ProviderUserUpdateEditPage.tsx
#: src/timber/pages/roadCarrier/RoadCarrierAddEditPage.tsx
#: src/timber/pages/roadCarrier/RoadCarrierDetailPage.tsx
#: src/timber/pages/roadCarrier/RoadCarrierUpdateEditPage.tsx
#: src/timber/pages/shipment/ShipmentAddEditPage.tsx
#: src/timber/pages/shipment/ShipmentDetailPage.tsx
#: src/timber/pages/shipment/ShipmentUpdateEditPage.tsx
#: src/timber/pages/shipmentHistory/ShipmentHistoryAddEditPage.tsx
#: src/timber/pages/shipmentHistory/ShipmentHistoryDetailPage.tsx
#: src/timber/pages/shipmentHistory/ShipmentHistoryUpdateEditPage.tsx
#: src/timber/pages/thicknessClass/ThicknessClassAddEditPage.tsx
#: src/timber/pages/thicknessClass/ThicknessClassDetailPage.tsx
#: src/timber/pages/thicknessClass/ThicknessClassUpdateEditPage.tsx
#: src/timber/pages/timberClass/TimberClassAddEditPage.tsx
#: src/timber/pages/timberClass/TimberClassDetailPage.tsx
#: src/timber/pages/timberClass/TimberClassUpdateEditPage.tsx
#: src/timber/pages/timberStorage/TimberStorageAddEditPage.tsx
#: src/timber/pages/timberStorage/TimberStorageDetailPage.tsx
#: src/timber/pages/timberStorage/TimberStorageUpdateEditPage.tsx
#: src/timber/pages/timberType/TimberTypeAddEditPage.tsx
#: src/timber/pages/timberType/TimberTypeDetailPage.tsx
#: src/timber/pages/timberType/TimberTypeUpdateEditPage.tsx
#: src/timber/pages/treeMarking/TreeMarkingAddEditPage.tsx
#: src/timber/pages/treeMarking/TreeMarkingDetailPage.tsx
#: src/timber/pages/treeMarking/TreeMarkingUpdateEditPage.tsx
#~ msgid "Back"
#~ msgstr "Back"

#: src/pages/ForgotPasswordPage.tsx
msgid "Back to Login"
msgstr "Back to Login"

#: src/timber/components/buyer/BuyerDetail/BuyerDetail.tsx
#: src/timber/components/buyer/BuyerForm/BuyerAddForm.tsx
#: src/timber/components/buyer/BuyerForm/BuyerUpdateForm.tsx
#: src/timber/components/contractor/ContractorDetail/ContractorDetail.tsx
#: src/timber/components/contractor/ContractorForm/ContractorAddForm.tsx
#: src/timber/components/contractor/ContractorForm/ContractorUpdateForm.tsx
#: src/timber/components/forestOwner/ForestOwnerDetail/ForestOwnerDetail.tsx
#: src/timber/components/forestOwner/ForestOwnerForm/ForestOwnerAddForm.tsx
#: src/timber/components/forestOwner/ForestOwnerForm/ForestOwnerUpdateForm.tsx
#: src/timber/components/provider/ProviderDetail/ProviderDetail.tsx
#: src/timber/components/provider/ProviderForm/ProviderAddForm.tsx
#: src/timber/components/provider/ProviderForm/ProviderUpdateForm.tsx
msgid "Bank"
msgstr "Bank"

#: src/auth/components/user/UserDetail/UserDetail.tsx
#: src/auth/components/user/UserForm/UserAddForm.tsx
#: src/auth/components/user/UserForm/UserUpdateForm.tsx
#: src/auth/components/user/UserList/UserListItem.tsx
msgid "Banned"
msgstr "Banned"

#: src/timber/components/log/LogDetail/LogDetail.tsx
#: src/timber/components/log/LogForm/LogAddForm.tsx
#: src/timber/components/log/LogForm/LogUpdateForm.tsx
#: src/timber/components/logHistory/LogHistoryDetail/LogHistoryDetail.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogDetail.tsx
msgid "Bark Thickness"
msgstr "Bark Thickness"

#: src/timber/components/buyer/BuyerDetail/BuyerDetail.tsx
#: src/timber/components/buyerUser/BuyerUserDetail/BuyerUserDetail.tsx
#: src/timber/components/buyerUser/BuyerUserForm/BuyerUserAddForm.tsx
#: src/timber/components/generic/report/GenericRootShipments.tsx
#: src/timber/components/history/HistoryList/HistoryListItemRow.tsx
#: src/timber/components/shipment/ShipmentDetail/ShipmentDetail.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx
#: src/timber/components/shipment/ShipmentList/ShipmentListItem.tsx
#: src/timber/components/shipment/ShipmentList/ShipmentListSearch.tsx
#: src/timber/components/shipmentHistory/ShipmentHistoryDetail/ShipmentHistoryDetail.tsx
#: src/timber/components/shipmentHistory/ShipmentHistoryList/ShipmentHistoryListItem.tsx
#: src/timber/pages/buyer/BuyerEntityPage.tsx
#: src/timber/pages/listItems.tsx
msgid "Buyer"
msgstr "Buyer"

#: src/timber/hooks/useBuyer.ts
msgid "Buyer add error: "
msgstr "Buyer add error: "

#: src/timber/hooks/useBuyer.ts
msgid "Buyer delete error: "
msgstr "Buyer delete error: "

#: src/timber/hooks/useBuyer.ts
msgid "Buyer deleted"
msgstr "Buyer deleted"

#: src/timber/components/buyerUser/BuyerUserForm/BuyerUserAddForm.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx
#~ msgid "Buyer Id is required"
#~ msgstr "Buyer Id is required"

#: src/timber/components/buyerUser/BuyerUserForm/BuyerUserAddForm.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx
msgid "Buyer is required"
msgstr "Buyer is required"

#: src/timber/hooks/useBuyer.ts
msgid "Buyer update error: "
msgstr "Buyer update error: "

#: src/timber/hooks/useBuyer.ts
msgid "Buyer updated"
msgstr "Buyer updated"

#: src/timber/components/buyerUser/BuyerUserDetail/BuyerUserDetail.tsx
#: src/timber/pages/buyerUser/BuyerUserEntityPage.tsx
msgid "Buyer User"
msgstr "Buyer User"

#: src/timber/hooks/useBuyerUser.ts
msgid "Buyer User add error: "
msgstr "Buyer User add error: "

#: src/timber/hooks/useBuyerUser.ts
msgid "Buyer User delete error: "
msgstr "Buyer User delete error: "

#: src/timber/hooks/useBuyerUser.ts
msgid "Buyer User deleted"
msgstr "Buyer User deleted"

#: src/timber/hooks/useBuyerUser.ts
msgid "Buyer User update error: "
msgstr "Buyer User update error: "

#: src/timber/hooks/useBuyerUser.ts
msgid "Buyer User updated"
msgstr "Buyer User updated"

#: src/app/mappers.tsx
#: src/auth/components/user/UserDetail/UserTabs.tsx
#: src/timber/components/buyer/BuyerDetail/BuyerTabs.tsx
#: src/timber/components/buyerUser/BuyerUserList/BuyerUserListHeader.tsx
msgid "Buyer Users"
msgstr "Buyer Users"

#: src/app/mappers.tsx
#: src/timber/components/buyer/BuyerList/BuyerListHeader.tsx
#: src/timber/pages/listItems.tsx
#: src/timber/types/models/Split.ts
msgid "Buyers"
msgstr "Buyers"

#: src/pages/LoginPage.tsx
msgid "By logging in you agree to our"
msgstr "By logging in you agree to our"

#: src/pages/TermsPage.tsx
msgid "By using this application, you agree to use it in accordance with applicable laws and our policies. You are responsible for maintaining the security of your account."
msgstr "By using this application, you agree to use it in accordance with applicable laws and our policies. You are responsible for maintaining the security of your account."

#: src/timber/components/cordwood/CordwoodList/CordwoodListItem.tsx
#: src/timber/components/log/LogList/LogListItem.tsx
#: src/timber/components/shipment/ShipmentRegulator/CordwoodListItemForShipment.tsx
#: src/timber/components/shipment/ShipmentRegulator/CordwoodListItemFromHistory.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogListItemForShipment.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogListItemFromHistory.tsx
msgid "C"
msgstr "C"

#: src/address/components/address/AddressForm/AddressFormSelect.tsx
#: src/address/components/userAddress/UserAddressForm/UserAddressFormSelect.tsx
#: src/address/pages/address/AddressAddEditPage.tsx
#: src/address/pages/address/AddressUpdateEditPage.tsx
#: src/address/pages/userAddress/UserAddressAddEditPage.tsx
#: src/address/pages/userAddress/UserAddressUpdateEditPage.tsx
#: src/auth/components/membersGroup/MembersGroupForm/MembersGroupFormSelect.tsx
#: src/auth/components/membersGroup/MembersGroupList/MembersGroupListSearch.tsx
#: src/auth/components/membersGroupUser/MembersGroupUserForm/MembersGroupUserFormSelect.tsx
#: src/auth/components/membersGroupUser/MembersGroupUserList/MembersGroupUserListSearch.tsx
#: src/auth/components/role/RoleForm/RoleFormSelect.tsx
#: src/auth/components/role/RoleList/RoleListSearch.tsx
#: src/auth/components/roleAssignment/RoleAssignmentForm/RoleAssignmentFormSelect.tsx
#: src/auth/components/roleAssignment/RoleAssignmentList/RoleAssignmentListSearch.tsx
#: src/auth/components/rolePermission/RolePermissionForm/RolePermissionFormSelect.tsx
#: src/auth/components/rolePermission/RolePermissionList/RolePermissionListSearch.tsx
#: src/auth/components/scopeGroup/ScopeGroupForm/ScopeGroupFormSelect.tsx
#: src/auth/components/scopeGroup/ScopeGroupList/ScopeGroupListSearch.tsx
#: src/auth/components/user/UserForm/UserFormSelect.tsx
#: src/auth/components/userSession/UserSessionForm/UserSessionFormSelect.tsx
#: src/auth/pages/membersGroup/MembersGroupAddEditPage.tsx
#: src/auth/pages/membersGroup/MembersGroupUpdateEditPage.tsx
#: src/auth/pages/membersGroupUser/MembersGroupUserAddEditPage.tsx
#: src/auth/pages/membersGroupUser/MembersGroupUserUpdateEditPage.tsx
#: src/auth/pages/role/RoleAddEditPage.tsx
#: src/auth/pages/role/RoleUpdateEditPage.tsx
#: src/auth/pages/roleAssignment/RoleAssignmentAddEditPage.tsx
#: src/auth/pages/roleAssignment/RoleAssignmentUpdateEditPage.tsx
#: src/auth/pages/rolePermission/RolePermissionAddEditPage.tsx
#: src/auth/pages/rolePermission/RolePermissionUpdateEditPage.tsx
#: src/auth/pages/scopeGroup/ScopeGroupAddEditPage.tsx
#: src/auth/pages/scopeGroup/ScopeGroupUpdateEditPage.tsx
#: src/auth/pages/user/UserAddEditPage.tsx
#: src/auth/pages/user/UserUpdateEditPage.tsx
#: src/auth/pages/userSession/UserSessionAddEditPage.tsx
#: src/auth/pages/userSession/UserSessionUpdateEditPage.tsx
#: src/location/components/location/LocationForm/LocationFormSelect.tsx
#: src/location/components/location/LocationList/LocationListSearch.tsx
#: src/location/pages/location/LocationAddEditPage.tsx
#: src/location/pages/location/LocationUpdateEditPage.tsx
#: src/share/components/chat/ChatMessage.tsx
#: src/share/components/dialog/DeleteDialog/DeleteDialog.tsx
#: src/share/components/dialog/PasswordDialog/PasswordDialog.tsx
#: src/share/components/form/FormDateTime/FormDate.tsx
#: src/share/components/form/FormDateTime/FormDateTime.tsx
#: src/timber/components/accountingUser/AccountingUserForm/AccountingUserFormSelect.tsx
#: src/timber/components/buyer/BuyerForm/BuyerFormSelect.tsx
#: src/timber/components/buyerUser/BuyerUserForm/BuyerUserFormSelect.tsx
#: src/timber/components/contractor/ContractorForm/ContractorFormSelect.tsx
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserFormSelect.tsx
#: src/timber/components/cordwood/CordwoodForm/CordwoodFormSelect.tsx
#: src/timber/components/cordwood/CordwoodList/CordwoodListSearch.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryForm/CordwoodHistoryFormSelect.tsx
#: src/timber/components/cutting/CuttingForm/CuttingFormSelect.tsx
#: src/timber/components/cutting/CuttingList/CuttingListSearch.tsx
#: src/timber/components/forestOwner/ForestOwnerForm/ForestOwnerFormSelect.tsx
#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx
#: src/timber/components/log/LogForm/LogFormSelect.tsx
#: src/timber/components/log/LogList/LogListSearch.tsx
#: src/timber/components/logHistory/LogHistoryForm/LogHistoryFormSelect.tsx
#: src/timber/components/price/PriceForm/PriceFormSelect.tsx
#: src/timber/components/price/PriceList/PriceListSearch.tsx
#: src/timber/components/pricingProfile/PricingProfileForm/PricingProfileFormSelect.tsx
#: src/timber/components/provider/ProviderForm/ProviderFormSelect.tsx
#: src/timber/components/providerUser/ProviderUserForm/ProviderUserFormSelect.tsx
#: src/timber/components/roadCarrier/RoadCarrierForm/RoadCarrierFormSelect.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentFormSelect.tsx
#: src/timber/components/shipment/ShipmentList/ShipmentListSearch.tsx
#: src/timber/components/shipmentHistory/ShipmentHistoryForm/ShipmentHistoryFormSelect.tsx
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassFormSelect.tsx
#: src/timber/components/timberClass/TimberClassForm/TimberClassFormSelect.tsx
#: src/timber/components/timberStorage/TimberStorageForm/TimberStorageFormSelect.tsx
#: src/timber/components/timberStorage/TimberStorageList/TimberStorageListSearch.tsx
#: src/timber/components/timberType/TimberTypeForm/TimberTypeFormSelect.tsx
#: src/timber/components/treeMarking/TreeMarkingForm/TreeMarkingFormSelect.tsx
#: src/timber/components/treeMarking/TreeMarkingList/TreeMarkingListSearch.tsx
#: src/timber/pages/accountingUser/AccountingUserAddEditPage.tsx
#: src/timber/pages/accountingUser/AccountingUserUpdateEditPage.tsx
#: src/timber/pages/buyer/BuyerAddEditPage.tsx
#: src/timber/pages/buyer/BuyerUpdateEditPage.tsx
#: src/timber/pages/buyerUser/BuyerUserAddEditPage.tsx
#: src/timber/pages/buyerUser/BuyerUserUpdateEditPage.tsx
#: src/timber/pages/contractor/ContractorAddEditPage.tsx
#: src/timber/pages/contractor/ContractorUpdateEditPage.tsx
#: src/timber/pages/contractorUser/ContractorUserAddEditPage.tsx
#: src/timber/pages/contractorUser/ContractorUserUpdateEditPage.tsx
#: src/timber/pages/cordwood/CordwoodAddEditPage.tsx
#: src/timber/pages/cordwood/CordwoodUpdateEditPage.tsx
#: src/timber/pages/cordwoodHistory/CordwoodHistoryAddEditPage.tsx
#: src/timber/pages/cordwoodHistory/CordwoodHistoryUpdateEditPage.tsx
#: src/timber/pages/cutting/CuttingAddEditPage.tsx
#: src/timber/pages/cutting/CuttingUpdateEditPage.tsx
#: src/timber/pages/forestOwner/ForestOwnerAddEditPage.tsx
#: src/timber/pages/forestOwner/ForestOwnerUpdateEditPage.tsx
#: src/timber/pages/log/LogAddEditPage.tsx
#: src/timber/pages/log/LogUpdateEditPage.tsx
#: src/timber/pages/logHistory/LogHistoryAddEditPage.tsx
#: src/timber/pages/logHistory/LogHistoryUpdateEditPage.tsx
#: src/timber/pages/price/PriceAddEditPage.tsx
#: src/timber/pages/price/PriceUpdateEditPage.tsx
#: src/timber/pages/pricingProfile/PricingProfileAddEditPage.tsx
#: src/timber/pages/pricingProfile/PricingProfileUpdateEditPage.tsx
#: src/timber/pages/provider/ProviderAddEditPage.tsx
#: src/timber/pages/provider/ProviderUpdateEditPage.tsx
#: src/timber/pages/providerUser/ProviderUserAddEditPage.tsx
#: src/timber/pages/providerUser/ProviderUserUpdateEditPage.tsx
#: src/timber/pages/roadCarrier/RoadCarrierAddEditPage.tsx
#: src/timber/pages/roadCarrier/RoadCarrierUpdateEditPage.tsx
#: src/timber/pages/shipment/ShipmentAddEditPage.tsx
#: src/timber/pages/shipment/ShipmentUpdateEditPage.tsx
#: src/timber/pages/shipmentHistory/ShipmentHistoryAddEditPage.tsx
#: src/timber/pages/shipmentHistory/ShipmentHistoryUpdateEditPage.tsx
#: src/timber/pages/thicknessClass/ThicknessClassAddEditPage.tsx
#: src/timber/pages/thicknessClass/ThicknessClassUpdateEditPage.tsx
#: src/timber/pages/timberClass/TimberClassAddEditPage.tsx
#: src/timber/pages/timberClass/TimberClassUpdateEditPage.tsx
#: src/timber/pages/timberStorage/TimberStorageAddEditPage.tsx
#: src/timber/pages/timberStorage/TimberStorageUpdateEditPage.tsx
#: src/timber/pages/timberType/TimberTypeAddEditPage.tsx
#: src/timber/pages/timberType/TimberTypeUpdateEditPage.tsx
#: src/timber/pages/treeMarking/TreeMarkingAddEditPage.tsx
#: src/timber/pages/treeMarking/TreeMarkingUpdateEditPage.tsx
msgid "Cancel"
msgstr "Cancel"

#: src/timber/types/models/ShipmentState.d.ts
msgid "Cancelled"
msgstr "Cancelled"

#: src/timber/components/history/HistoryList/HistoryListSearch.tsx
#: src/timber/types/models/MergedHistory.ts
msgid "Cancelled from Shipment"
msgstr "Cancelled from Shipment"

#: src/app/App.tsx
#: src/pages/ChangePasswordPage.tsx
msgid "Change Password"
msgstr "Change Password"

#: src/share/components/chat/useChat.ts
msgid "Chat failed"
msgstr "Chat failed"

#: src/address/components/address/AddressDetail/AddressDetail.tsx
#: src/address/components/address/AddressForm/AddressAddForm.tsx
#: src/address/components/address/AddressForm/AddressUpdateForm.tsx
#: src/address/components/address/AddressList/AddressListItem.tsx
#: src/location/components/location/LocationDetail/LocationDetail.tsx
#: src/location/components/location/LocationForm/LocationAddForm.tsx
#: src/location/components/location/LocationForm/LocationUpdateForm.tsx
#: src/location/components/location/LocationList/LocationListItem.tsx
msgid "City"
msgstr "City"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx
#: src/timber/components/generic/report/GenericRootTable.tsx
#: src/timber/components/shipment/ShipmentRegulator/CordwoodDetail.tsx
#: src/timber/components/shipment/ShipmentRegulator/CordwoodListItemForShipment.tsx
#: src/timber/components/shipment/ShipmentRegulator/CordwoodListItemFromHistory.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogDetail.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogListItemForShipment.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogListItemFromHistory.tsx
msgid "Class"
msgstr "Class"

#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx
#: src/timber/components/cordwood/CordwoodForm/CordwoodUpdateForm.tsx
#: src/timber/components/log/LogForm/LogAddForm.tsx
#: src/timber/components/log/LogForm/LogUpdateForm.tsx
#: src/timber/components/price/PriceForm/PriceAddForm.tsx
#: src/timber/components/price/PriceForm/PriceUpdateForm.tsx
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassAddForm.tsx
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassUpdateForm.tsx
#~ msgid "Class Id is required"
#~ msgstr "Class Id is required"

#: src/timber/components/history/HistoryList/HistoryListSearch.tsx
msgid "Clear"
msgstr "Clear"

#: src/share/components/chat/ConversationList.tsx
msgid "Clear search"
msgstr "Clear search"

#: src/share/components/form/FormDateTime/FormDateRange.tsx
#: src/timber/components/generic/report/GenericRootReportPdfDialog.tsx
#: src/timber/components/shipment/ShipmentRegulator/CordwoodListPdfDialog.tsx
#: src/timber/components/shipment/ShipmentRegulator/CordwoodShipmentReportPdfDialog.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogListPdfDialog.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogShipmentReportPdfDialog.tsx
msgid "Close"
msgstr "Close"

#: src/share/components/chat/ChatHeader.tsx
msgid "Close chat"
msgstr "Close chat"

#: src/timber/types/models/CuttingState.d.ts
#: src/timber/types/models/ShipmentState.d.ts
msgid "Closed"
msgstr "Closed"

#: src/share/components/layout/Layout/Layout.tsx
msgid "Column"
msgstr "Column"

#: src/timber/components/shipment/ShipmentRegulator/CordwoodListItemForShipment.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogListItemForShipment.tsx
msgid "Commit"
msgstr "Commit"

#: src/timber/components/cordwood/CordwoodDetail/CordwoodDetail.tsx
#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx
#: src/timber/components/cordwood/CordwoodForm/CordwoodUpdateForm.tsx
#: src/timber/components/cordwood/CordwoodList/CordwoodListItem.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryDetail/CordwoodHistoryDetail.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListItem.tsx
#: src/timber/components/log/LogDetail/LogDetail.tsx
#: src/timber/components/log/LogForm/LogAddForm.tsx
#: src/timber/components/log/LogForm/LogUpdateForm.tsx
#: src/timber/components/log/LogList/LogListItem.tsx
#: src/timber/components/logHistory/LogHistoryDetail/LogHistoryDetail.tsx
#: src/timber/components/logHistory/LogHistoryList/LogHistoryListItem.tsx
msgid "Commited"
msgstr "Commited"

#: src/timber/components/shipment/ShipmentRegulator/CordwoodListItemForShipment.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogListItemForShipment.tsx
msgid "Commited / Total"
msgstr "Commited / Total"

#: src/timber/components/history/HistoryList/HistoryListItemRow.tsx
msgid "Committed"
msgstr "Committed"

#: src/share/components/dialog/DeleteDialog/DeleteDialog.tsx
msgid "Confirm"
msgstr "Confirm"

#: src/share/components/dialog/DeleteDialog/DeleteDialog.tsx
msgid "Confirm Delete"
msgstr "Confirm Delete"

#: src/pages/ChangePasswordPage.tsx
msgid "Confirm New Password"
msgstr "Confirm New Password"

#: src/pages/ResetPasswordPage.tsx
#: src/share/components/dialog/PasswordDialog/PasswordDialog.tsx
msgid "Confirm Password"
msgstr "Confirm Password"

#: src/timber/components/history/HistoryList/HistoryListItemRow.tsx
msgid "Context"
msgstr "Context"

#: src/timber/components/cordwoodHistory/CordwoodHistoryDetail/CordwoodHistoryDetail.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryForm/CordwoodHistoryAddForm.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListItem.tsx
#: src/timber/components/logHistory/LogHistoryDetail/LogHistoryDetail.tsx
#: src/timber/components/logHistory/LogHistoryForm/LogHistoryAddForm.tsx
#: src/timber/components/logHistory/LogHistoryList/LogHistoryListItem.tsx
#: src/timber/components/shipmentHistory/ShipmentHistoryDetail/ShipmentHistoryDetail.tsx
#: src/timber/components/shipmentHistory/ShipmentHistoryForm/ShipmentHistoryAddForm.tsx
#: src/timber/components/shipmentHistory/ShipmentHistoryList/ShipmentHistoryListItem.tsx
msgid "Context History"
msgstr "Context History"

#: src/timber/components/contractor/ContractorDetail/ContractorDetail.tsx
#: src/timber/components/contractorUser/ContractorUserDetail/ContractorUserDetail.tsx
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserAddForm.tsx
#: src/timber/components/cutting/CuttingDetail/CuttingDetail.tsx
#: src/timber/components/cutting/CuttingForm/CuttingAddForm.tsx
#: src/timber/components/cutting/CuttingList/CuttingListItem.tsx
#: src/timber/pages/contractor/ContractorEntityPage.tsx
#: src/timber/pages/listItems.tsx
msgid "Contractor"
msgstr "Contractor"

#: src/timber/hooks/useContractor.ts
msgid "Contractor add error: "
msgstr "Contractor add error: "

#: src/timber/hooks/useContractor.ts
msgid "Contractor delete error: "
msgstr "Contractor delete error: "

#: src/timber/hooks/useContractor.ts
msgid "Contractor deleted"
msgstr "Contractor deleted"

#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserAddForm.tsx
#: src/timber/components/cutting/CuttingForm/CuttingAddForm.tsx
#~ msgid "Contractor Id is required"
#~ msgstr "Contractor Id is required"

#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserAddForm.tsx
#: src/timber/components/cutting/CuttingForm/CuttingAddForm.tsx
msgid "Contractor is required"
msgstr "Contractor is required"

#: src/timber/hooks/useContractor.ts
msgid "Contractor update error: "
msgstr "Contractor update error: "

#: src/timber/hooks/useContractor.ts
msgid "Contractor updated"
msgstr "Contractor updated"

#: src/timber/components/contractorUser/ContractorUserDetail/ContractorUserDetail.tsx
#: src/timber/components/shipment/ShipmentDetail/ShipmentDetail.tsx
#: src/timber/components/shipment/ShipmentList/ShipmentListSearch.tsx
#: src/timber/pages/contractorUser/ContractorUserEntityPage.tsx
msgid "Contractor User"
msgstr "Contractor User"

#: src/timber/hooks/useContractorUser.ts
msgid "Contractor User add error: "
msgstr "Contractor User add error: "

#: src/timber/hooks/useContractorUser.ts
msgid "Contractor User delete error: "
msgstr "Contractor User delete error: "

#: src/timber/hooks/useContractorUser.ts
msgid "Contractor User deleted"
msgstr "Contractor User deleted"

#: src/timber/hooks/useContractorUser.ts
msgid "Contractor User update error: "
msgstr "Contractor User update error: "

#: src/timber/hooks/useContractorUser.ts
msgid "Contractor User updated"
msgstr "Contractor User updated"

#: src/timber/types/models/Split.ts
msgid "Contractor users"
msgstr "Contractor users"

#: src/app/mappers.tsx
#: src/auth/components/user/UserDetail/UserTabs.tsx
#: src/timber/components/contractor/ContractorDetail/ContractorTabs.tsx
#: src/timber/components/contractorUser/ContractorUserList/ContractorUserListHeader.tsx
msgid "Contractor Users"
msgstr "Contractor Users"

#: src/app/mappers.tsx
#: src/timber/components/contractor/ContractorList/ContractorListHeader.tsx
#: src/timber/pages/listItems.tsx
#: src/timber/types/models/Split.ts
msgid "Contractors"
msgstr "Contractors"

#: src/share/components/chat/ChatThread.tsx
msgid "Conversation"
msgstr "Conversation"

#: src/share/components/chat/serverErrors.ts
msgid "Conversation not found"
msgstr "Conversation not found"

#: src/share/components/chat/serverErrors.ts
msgid "Conversation storage unavailable"
msgstr "Conversation storage unavailable"

#: src/share/components/chat/Markdown.tsx
msgid "Copied"
msgstr "Copied"

#: src/share/components/chat/Markdown.tsx
msgid "Copy code"
msgstr "Copy code"

#: src/timber/components/cordwood/CordwoodDetail/CordwoodDetail.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryDetail/CordwoodHistoryDetail.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryForm/CordwoodHistoryAddForm.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListItem.tsx
#: src/timber/components/cutting/CuttingList/ActiveCuttings.tsx
#: src/timber/components/generic/report/StorageShipmentPies.tsx
#: src/timber/components/generic/treeMarkings/ReportTreeMarkings.tsx
#: src/timber/components/history/HistoryList/HistoryListSearch.tsx
#: src/timber/pages/cordwood/CordwoodEntityPage.tsx
#: src/timber/types/models/MergedHistory.ts
#: src/timber/types/models/ShipmentType.d.ts
msgid "Cordwood"
msgstr "Cordwood"

#: src/timber/hooks/useCordwood.ts
msgid "Cordwood add error: "
msgstr "Cordwood add error: "

#: src/timber/hooks/useCordwood.ts
msgid "Cordwood delete error: "
msgstr "Cordwood delete error: "

#: src/timber/hooks/useCordwood.ts
msgid "Cordwood deleted"
msgstr "Cordwood deleted"

#: src/app/mappers.tsx
#: src/timber/components/cordwood/CordwoodDetail/CordwoodTabs.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListHeader.tsx
msgid "Cordwood Histories"
msgstr "Cordwood Histories"

#: src/timber/components/cordwoodHistory/CordwoodHistoryDetail/CordwoodHistoryDetail.tsx
#: src/timber/pages/cordwoodHistory/CordwoodHistoryEntityPage.tsx
msgid "Cordwood History"
msgstr "Cordwood History"

#: src/timber/hooks/useCordwoodHistory.ts
msgid "Cordwood History add error: "
msgstr "Cordwood History add error: "

#: src/timber/hooks/useCordwoodHistory.ts
msgid "Cordwood History delete error: "
msgstr "Cordwood History delete error: "

#: src/timber/hooks/useCordwoodHistory.ts
msgid "Cordwood History deleted"
msgstr "Cordwood History deleted"

#: src/timber/components/cordwoodHistory/CordwoodHistoryForm/CordwoodHistoryAddForm.tsx
#~ msgid "Cordwood Id is required"
#~ msgstr "Cordwood Id is required"

#: src/timber/components/cordwoodHistory/CordwoodHistoryForm/CordwoodHistoryAddForm.tsx
msgid "Cordwood is required"
msgstr "Cordwood is required"

#: src/timber/components/shipment/ShipmentRegulator/CordwoodListItem.tsx
#~ msgid "Cordwood Key"
#~ msgstr "Cordwood Key"

#: src/timber/components/generic/report/GenericRootReport.tsx
msgid "Cordwood Shipments"
msgstr "Cordwood Shipments"

#: src/timber/hooks/useCordwood.ts
msgid "Cordwood update error: "
msgstr "Cordwood update error: "

#: src/timber/hooks/useCordwood.ts
msgid "Cordwood updated"
msgstr "Cordwood updated"

#: src/timber/components/provider/ProviderDetail/ProviderSummaryCards.tsx
msgid "Cordwood volume (m³)"
msgstr "Cordwood volume (m³)"

#: src/app/mappers.tsx
#: src/timber/components/cordwood/CordwoodList/CordwoodListHeader.tsx
#: src/timber/components/cutting/CuttingDetail/CuttingTabs.tsx
#: src/timber/components/generic/report/GenericRootShipments.tsx
#: src/timber/components/shipment/ShipmentDetail/ShipmentTabs.tsx
#: src/timber/components/timberStorage/TimberStorageDetail/TimberStorageTabs.tsx
msgid "Cordwoods"
msgstr "Cordwoods"

#: src/share/components/chat/useChat.ts
msgid "Could not download the file."
msgstr "Could not download the file."

#: src/share/components/chat/useChat.ts
msgid "Could not edit: the conversation could not be branched."
msgstr "Could not edit: the conversation could not be branched."

#: src/share/components/chat/useChat.ts
msgid "Could not regenerate: the previous reply could not be discarded."
msgstr "Could not regenerate: the previous reply could not be discarded."

#: src/timber/components/generic/treeMarkings/ReportTreeMarkings.tsx
#: src/timber/components/shipment/ShipmentRegulator/CordwoodListItemForShipment.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogListItemForShipment.tsx
msgid "Count"
msgstr "Count"

#: src/address/components/address/AddressDetail/AddressDetail.tsx
#: src/address/components/address/AddressForm/AddressAddForm.tsx
#: src/address/components/address/AddressForm/AddressUpdateForm.tsx
#: src/location/components/location/LocationDetail/LocationDetail.tsx
#: src/location/components/location/LocationForm/LocationAddForm.tsx
#: src/location/components/location/LocationForm/LocationUpdateForm.tsx
#: src/location/components/location/LocationList/LocationListItem.tsx
msgid "Country"
msgstr "Country"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx
msgid "Create new pricing profile"
msgstr "Create new pricing profile"

#: src/timber/components/history/HistoryList/HistoryListSearch.tsx
#: src/timber/types/models/MergedHistory.ts
msgid "Created"
msgstr "Created"

#: src/auth/components/roleAssignment/RoleAssignmentDetail/RoleAssignmentDetail.tsx
#: src/auth/components/roleAssignment/RoleAssignmentList/RoleAssignmentListItem.tsx
#: src/auth/components/rolePermission/RolePermissionDetail/RolePermissionDetail.tsx
#: src/auth/components/rolePermission/RolePermissionList/RolePermissionListItem.tsx
#: src/auth/components/user/UserDetail/UserDetail.tsx
#: src/auth/components/user/UserList/UserListItem.tsx
#: src/auth/components/userSession/UserSessionDetail/UserSessionDetail.tsx
#: src/auth/components/userSession/UserSessionList/UserSessionListItem.tsx
#: src/timber/components/cordwood/CordwoodDetail/CordwoodDetail.tsx
#: src/timber/components/log/LogDetail/LogDetail.tsx
msgid "Created At"
msgstr "Created At"

#: src/timber/components/generic/report/TimelineRootReport.tsx
#~ msgid "Created At From"
#~ msgstr "Created At From"

#: src/timber/components/generic/report/TimelineRootReport.tsx
#~ msgid "Created At To"
#~ msgstr "Created At To"

#: src/timber/components/cordwood/CordwoodDetail/CordwoodDetail.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryDetail/CordwoodHistoryDetail.tsx
#: src/timber/components/cutting/CuttingDetail/CuttingDetail.tsx
#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx
#: src/timber/components/generic/report/GenericRootReport.tsx
#: src/timber/components/generic/report/GenericRootShipments.tsx
#: src/timber/components/generic/report/TimelineRootReport.tsx
#: src/timber/components/history/HistoryList/HistoryListItemRow.tsx
#: src/timber/components/history/HistoryList/HistoryListSearch.tsx
#: src/timber/components/log/LogDetail/LogDetail.tsx
#: src/timber/components/logHistory/LogHistoryDetail/LogHistoryDetail.tsx
#: src/timber/components/shipment/ShipmentDetail/ShipmentDetail.tsx
#: src/timber/components/shipment/ShipmentList/ShipmentListItem.tsx
#: src/timber/components/shipmentHistory/ShipmentHistoryDetail/ShipmentHistoryDetail.tsx
#: src/timber/components/timberStorage/TimberStorageDetail/TimberStorageDetail.tsx
#: src/timber/components/timberStorage/TimberStorageForm/TimberStorageAddForm.tsx
#: src/timber/components/treeMarking/TreeMarkingDetail/TreeMarkingDetail.tsx
#: src/timber/pages/cutting/CuttingEntityPage.tsx
msgid "Cutting"
msgstr "Cutting"

#: src/timber/hooks/useCutting.ts
msgid "Cutting add error: "
msgstr "Cutting add error: "

#: src/timber/hooks/useCutting.ts
msgid "Cutting delete error: "
msgstr "Cutting delete error: "

#: src/timber/hooks/useCutting.ts
msgid "Cutting deleted"
msgstr "Cutting deleted"

#: src/timber/components/timberStorage/TimberStorageForm/TimberStorageAddForm.tsx
#~ msgid "Cutting Id is required"
#~ msgstr "Cutting Id is required"

#: src/timber/components/timberStorage/TimberStorageForm/TimberStorageAddForm.tsx
msgid "Cutting is required"
msgstr "Cutting is required"

#: src/timber/hooks/useCutting.ts
msgid "Cutting update error: "
msgstr "Cutting update error: "

#: src/timber/hooks/useCutting.ts
msgid "Cutting updated"
msgstr "Cutting updated"

#: src/app/mappers.tsx
#: src/timber/components/contractor/ContractorDetail/ContractorTabs.tsx
#: src/timber/components/cutting/CuttingList/CuttingListHeader.tsx
#: src/timber/components/forestOwner/ForestOwnerDetail/ForestOwnerTabs.tsx
#: src/timber/components/provider/ProviderDetail/ProviderTabs.tsx
#: src/timber/pages/listItems.tsx
msgid "Cuttings"
msgstr "Cuttings"

#: src/timber/components/provider/ProviderDetail/ProviderAttentionList.tsx
msgid "Cuttings that have gone quiet"
msgstr "Cuttings that have gone quiet"

#: src/pages/PreferencesPage.tsx
msgid "Dark"
msgstr "Dark"

#: src/app/App.tsx
#: src/app/mappers.tsx
#: src/pages/DashboardHomePage.tsx
#: src/pages/listItems.tsx
msgid "Dashboard"
msgstr "Dashboard"

#: src/timber/components/generic/report/GenericRootReport.tsx
msgid "Data"
msgstr "Data"

#: src/timber/components/generic/report/TimelineRootReport.tsx
msgid "Date"
msgstr "Date"

#: src/timber/components/history/HistoryList/HistoryListItem.tsx
msgid "Date/Time"
msgstr "Date/Time"

#: src/timber/components/generic/report/TimelineRootReport.tsx
msgid "Day"
msgstr "Day"

#: src/share/components/gdpr/CookieConsent.tsx
msgid "Decline"
msgstr "Decline"

#: src/share/components/form/FormInput/NumberField.tsx
msgid "Decrease"
msgstr "Decrease"

#: src/address/pages/address/AddressDetailPage.tsx
#: src/address/pages/address/AddressEntityPage.tsx
#: src/address/pages/userAddress/UserAddressDetailPage.tsx
#: src/address/pages/userAddress/UserAddressEntityPage.tsx
#: src/auth/pages/membersGroup/MembersGroupDetailPage.tsx
#: src/auth/pages/membersGroup/MembersGroupEntityPage.tsx
#: src/auth/pages/membersGroupUser/MembersGroupUserDetailPage.tsx
#: src/auth/pages/membersGroupUser/MembersGroupUserEntityPage.tsx
#: src/auth/pages/role/RoleDetailPage.tsx
#: src/auth/pages/role/RoleEntityPage.tsx
#: src/auth/pages/roleAssignment/RoleAssignmentDetailPage.tsx
#: src/auth/pages/roleAssignment/RoleAssignmentEntityPage.tsx
#: src/auth/pages/rolePermission/RolePermissionDetailPage.tsx
#: src/auth/pages/rolePermission/RolePermissionEntityPage.tsx
#: src/auth/pages/scopeGroup/ScopeGroupDetailPage.tsx
#: src/auth/pages/scopeGroup/ScopeGroupEntityPage.tsx
#: src/auth/pages/user/UserDetailPage.tsx
#: src/auth/pages/user/UserEntityPage.tsx
#: src/auth/pages/userSession/UserSessionDetailPage.tsx
#: src/auth/pages/userSession/UserSessionEntityPage.tsx
#: src/location/pages/location/LocationDetailPage.tsx
#: src/location/pages/location/LocationEntityPage.tsx
#: src/share/components/chat/ConversationList.tsx
#: src/timber/pages/accountingUser/AccountingUserDetailPage.tsx
#: src/timber/pages/accountingUser/AccountingUserEntityPage.tsx
#: src/timber/pages/buyer/BuyerDetailPage.tsx
#: src/timber/pages/buyer/BuyerEntityPage.tsx
#: src/timber/pages/buyerUser/BuyerUserDetailPage.tsx
#: src/timber/pages/buyerUser/BuyerUserEntityPage.tsx
#: src/timber/pages/contractor/ContractorDetailPage.tsx
#: src/timber/pages/contractor/ContractorEntityPage.tsx
#: src/timber/pages/contractorUser/ContractorUserDetailPage.tsx
#: src/timber/pages/contractorUser/ContractorUserEntityPage.tsx
#: src/timber/pages/cordwood/CordwoodDetailPage.tsx
#: src/timber/pages/cordwood/CordwoodEntityPage.tsx
#: src/timber/pages/cordwoodHistory/CordwoodHistoryDetailPage.tsx
#: src/timber/pages/cordwoodHistory/CordwoodHistoryEntityPage.tsx
#: src/timber/pages/cutting/CuttingDetailPage.tsx
#: src/timber/pages/cutting/CuttingEntityPage.tsx
#: src/timber/pages/forestOwner/ForestOwnerDetailPage.tsx
#: src/timber/pages/forestOwner/ForestOwnerEntityPage.tsx
#: src/timber/pages/log/LogDetailPage.tsx
#: src/timber/pages/log/LogEntityPage.tsx
#: src/timber/pages/logHistory/LogHistoryDetailPage.tsx
#: src/timber/pages/logHistory/LogHistoryEntityPage.tsx
#: src/timber/pages/price/PriceDetailPage.tsx
#: src/timber/pages/price/PriceEntityPage.tsx
#: src/timber/pages/pricingProfile/PricingProfileDetailPage.tsx
#: src/timber/pages/pricingProfile/PricingProfileEntityPage.tsx
#: src/timber/pages/provider/ProviderDetailPage.tsx
#: src/timber/pages/provider/ProviderEntityPage.tsx
#: src/timber/pages/providerUser/ProviderUserDetailPage.tsx
#: src/timber/pages/providerUser/ProviderUserEntityPage.tsx
#: src/timber/pages/roadCarrier/RoadCarrierDetailPage.tsx
#: src/timber/pages/roadCarrier/RoadCarrierEntityPage.tsx
#: src/timber/pages/shipment/ShipmentDetailPage.tsx
#: src/timber/pages/shipment/ShipmentEntityPage.tsx
#: src/timber/pages/shipmentHistory/ShipmentHistoryDetailPage.tsx
#: src/timber/pages/shipmentHistory/ShipmentHistoryEntityPage.tsx
#: src/timber/pages/thicknessClass/ThicknessClassDetailPage.tsx
#: src/timber/pages/thicknessClass/ThicknessClassEntityPage.tsx
#: src/timber/pages/timberClass/TimberClassDetailPage.tsx
#: src/timber/pages/timberClass/TimberClassEntityPage.tsx
#: src/timber/pages/timberStorage/TimberStorageDetailPage.tsx
#: src/timber/pages/timberStorage/TimberStorageEntityPage.tsx
#: src/timber/pages/timberType/TimberTypeDetailPage.tsx
#: src/timber/pages/timberType/TimberTypeEntityPage.tsx
#: src/timber/pages/treeMarking/TreeMarkingDetailPage.tsx
#: src/timber/pages/treeMarking/TreeMarkingEntityPage.tsx
msgid "Delete"
msgstr "Delete"

#. placeholder {0}: conv.title || t`New conversation`
#: src/share/components/chat/ConversationList.tsx
msgid "Delete {0}"
msgstr "Delete {0}"

#: src/share/components/chat/ChatHeader.tsx
msgid "Delete conversation"
msgstr "Delete conversation"

#: src/address/hooks/useAddress.ts
#: src/address/hooks/useUserAddress.ts
#: src/auth/hooks/useMembersGroup.ts
#: src/auth/hooks/useMembersGroupUser.ts
#: src/auth/hooks/useRole.ts
#: src/auth/hooks/useRoleAssignment.ts
#: src/auth/hooks/useRolePermission.ts
#: src/auth/hooks/useScopeGroup.ts
#: src/auth/hooks/useUser.ts
#: src/auth/hooks/useUserSession.ts
#: src/location/hooks/useLocation.ts
#: src/timber/hooks/useAccountingUser.ts
#: src/timber/hooks/useBuyer.ts
#: src/timber/hooks/useBuyerUser.ts
#: src/timber/hooks/useContractor.ts
#: src/timber/hooks/useContractorUser.ts
#: src/timber/hooks/useCordwood.ts
#: src/timber/hooks/useCordwoodHistory.ts
#: src/timber/hooks/useCutting.ts
#: src/timber/hooks/useForestOwner.ts
#: src/timber/hooks/useLog.ts
#: src/timber/hooks/useLogHistory.ts
#: src/timber/hooks/usePrice.ts
#: src/timber/hooks/usePricingProfile.ts
#: src/timber/hooks/useProvider.ts
#: src/timber/hooks/useProviderUser.ts
#: src/timber/hooks/useRoadCarrier.ts
#: src/timber/hooks/useShipment.ts
#: src/timber/hooks/useShipmentHistory.ts
#: src/timber/hooks/useThicknessClass.ts
#: src/timber/hooks/useTimberClass.ts
#: src/timber/hooks/useTimberStorage.ts
#: src/timber/hooks/useTimberType.ts
#: src/timber/hooks/useTreeMarking.ts
msgid "Delete error: "
msgstr "Delete error: "

#: src/timber/components/history/HistoryList/HistoryListSearch.tsx
#: src/timber/types/models/MergedHistory.ts
msgid "Deleted"
msgstr "Deleted"

#: src/address/components/address/AddressDetail/AddressDetail.tsx
#: src/address/components/address/AddressForm/AddressAddForm.tsx
#: src/address/components/address/AddressForm/AddressUpdateForm.tsx
#: src/auth/components/membersGroup/MembersGroupDetail/MembersGroupDetail.tsx
#: src/auth/components/membersGroup/MembersGroupForm/MembersGroupAddForm.tsx
#: src/auth/components/membersGroup/MembersGroupForm/MembersGroupUpdateForm.tsx
#: src/auth/components/role/RoleDetail/RoleDetail.tsx
#: src/auth/components/role/RoleForm/RoleAddForm.tsx
#: src/auth/components/role/RoleForm/RoleUpdateForm.tsx
#: src/auth/components/role/RoleList/RoleListItem.tsx
#: src/auth/components/scopeGroup/ScopeGroupDetail/ScopeGroupDetail.tsx
#: src/auth/components/scopeGroup/ScopeGroupForm/ScopeGroupAddForm.tsx
#: src/auth/components/scopeGroup/ScopeGroupForm/ScopeGroupUpdateForm.tsx
#: src/location/components/location/LocationDetail/LocationDetail.tsx
#: src/location/components/location/LocationForm/LocationAddForm.tsx
#: src/location/components/location/LocationForm/LocationUpdateForm.tsx
#: src/timber/components/accountingUser/AccountingUserDetail/AccountingUserDetail.tsx
#: src/timber/components/accountingUser/AccountingUserForm/AccountingUserAddForm.tsx
#: src/timber/components/accountingUser/AccountingUserForm/AccountingUserUpdateForm.tsx
#: src/timber/components/buyer/BuyerDetail/BuyerDetail.tsx
#: src/timber/components/buyer/BuyerForm/BuyerAddForm.tsx
#: src/timber/components/buyer/BuyerForm/BuyerUpdateForm.tsx
#: src/timber/components/buyer/BuyerList/BuyerListItem.tsx
#: src/timber/components/buyerUser/BuyerUserDetail/BuyerUserDetail.tsx
#: src/timber/components/buyerUser/BuyerUserForm/BuyerUserAddForm.tsx
#: src/timber/components/buyerUser/BuyerUserForm/BuyerUserUpdateForm.tsx
#: src/timber/components/contractor/ContractorDetail/ContractorDetail.tsx
#: src/timber/components/contractor/ContractorForm/ContractorAddForm.tsx
#: src/timber/components/contractor/ContractorForm/ContractorUpdateForm.tsx
#: src/timber/components/contractorUser/ContractorUserDetail/ContractorUserDetail.tsx
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserAddForm.tsx
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserUpdateForm.tsx
#: src/timber/components/cordwood/CordwoodDetail/CordwoodDetail.tsx
#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx
#: src/timber/components/cordwood/CordwoodForm/CordwoodUpdateForm.tsx
#: src/timber/components/forestOwner/ForestOwnerDetail/ForestOwnerDetail.tsx
#: src/timber/components/forestOwner/ForestOwnerForm/ForestOwnerAddForm.tsx
#: src/timber/components/forestOwner/ForestOwnerForm/ForestOwnerUpdateForm.tsx
#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx
#: src/timber/components/log/LogDetail/LogDetail.tsx
#: src/timber/components/log/LogForm/LogAddForm.tsx
#: src/timber/components/log/LogForm/LogUpdateForm.tsx
#: src/timber/components/pricingProfile/PricingProfileDetail/PricingProfileDetail.tsx
#: src/timber/components/pricingProfile/PricingProfileForm/PricingProfileAddForm.tsx
#: src/timber/components/pricingProfile/PricingProfileForm/PricingProfileUpdateForm.tsx
#: src/timber/components/provider/ProviderDetail/ProviderDetail.tsx
#: src/timber/components/provider/ProviderForm/ProviderAddForm.tsx
#: src/timber/components/provider/ProviderForm/ProviderUpdateForm.tsx
#: src/timber/components/providerUser/ProviderUserDetail/ProviderUserDetail.tsx
#: src/timber/components/providerUser/ProviderUserForm/ProviderUserAddForm.tsx
#: src/timber/components/providerUser/ProviderUserForm/ProviderUserUpdateForm.tsx
#: src/timber/components/roadCarrier/RoadCarrierDetail/RoadCarrierDetail.tsx
#: src/timber/components/roadCarrier/RoadCarrierForm/RoadCarrierAddForm.tsx
#: src/timber/components/roadCarrier/RoadCarrierForm/RoadCarrierUpdateForm.tsx
#: src/timber/components/shipment/ShipmentDetail/ShipmentDetail.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx
#: src/timber/components/shipment/ShipmentRegulator/CordwoodDetail.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogDetail.tsx
#: src/timber/components/thicknessClass/ThicknessClassDetail/ThicknessClassDetail.tsx
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassAddForm.tsx
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassUpdateForm.tsx
#: src/timber/components/timberClass/TimberClassDetail/TimberClassDetail.tsx
#: src/timber/components/timberClass/TimberClassForm/TimberClassAddForm.tsx
#: src/timber/components/timberClass/TimberClassForm/TimberClassUpdateForm.tsx
#: src/timber/components/timberType/TimberTypeDetail/TimberTypeDetail.tsx
#: src/timber/components/timberType/TimberTypeForm/TimberTypeAddForm.tsx
#: src/timber/components/timberType/TimberTypeForm/TimberTypeUpdateForm.tsx
msgid "Description"
msgstr "Description"

#: src/timber/pages/accountingUser/AccountingUserDetailPage.tsx
msgid "Details Accounting User"
msgstr "Details Accounting User"

#: src/address/pages/address/AddressDetailPage.tsx
msgid "Details Address"
msgstr "Details Address"

#: src/timber/pages/buyer/BuyerDetailPage.tsx
msgid "Details Buyer"
msgstr "Details Buyer"

#: src/timber/pages/buyerUser/BuyerUserDetailPage.tsx
msgid "Details Buyer User"
msgstr "Details Buyer User"

#: src/timber/pages/contractor/ContractorDetailPage.tsx
msgid "Details Contractor"
msgstr "Details Contractor"

#: src/timber/pages/contractorUser/ContractorUserDetailPage.tsx
msgid "Details Contractor User"
msgstr "Details Contractor User"

#: src/timber/pages/cordwood/CordwoodDetailPage.tsx
msgid "Details Cordwood"
msgstr "Details Cordwood"

#: src/timber/pages/cordwoodHistory/CordwoodHistoryDetailPage.tsx
msgid "Details Cordwood History"
msgstr "Details Cordwood History"

#: src/timber/pages/cutting/CuttingDetailPage.tsx
msgid "Details Cutting"
msgstr "Details Cutting"

#: src/timber/pages/driver/DriverDetailPage.tsx
#~ msgid "Details Driver"
#~ msgstr "Details Driver"

#: src/timber/pages/forestOwner/ForestOwnerDetailPage.tsx
msgid "Details Forest Owner"
msgstr "Details Forest Owner"

#: src/location/pages/location/LocationDetailPage.tsx
msgid "Details Location"
msgstr "Details Location"

#: src/timber/pages/log/LogDetailPage.tsx
msgid "Details Log"
msgstr "Details Log"

#: src/timber/pages/logHistory/LogHistoryDetailPage.tsx
msgid "Details Log History"
msgstr "Details Log History"

#: src/auth/pages/membersGroup/MembersGroupDetailPage.tsx
msgid "Details Members Group"
msgstr "Details Members Group"

#: src/auth/pages/membersGroupUser/MembersGroupUserDetailPage.tsx
msgid "Details Members Group User"
msgstr "Details Members Group User"

#: src/timber/pages/price/PriceDetailPage.tsx
msgid "Details Price"
msgstr "Details Price"

#: src/timber/pages/pricingProfile/PricingProfileDetailPage.tsx
msgid "Details Pricing Profile"
msgstr "Details Pricing Profile"

#: src/timber/pages/provider/ProviderDetailPage.tsx
msgid "Details Provider"
msgstr "Details Provider"

#: src/timber/pages/providerUser/ProviderUserDetailPage.tsx
msgid "Details Provider User"
msgstr "Details Provider User"

#: src/timber/pages/roadCarrier/RoadCarrierDetailPage.tsx
msgid "Details Road Carrier"
msgstr "Details Road Carrier"

#: src/auth/pages/role/RoleDetailPage.tsx
msgid "Details Role"
msgstr "Details Role"

#: src/auth/pages/roleAssignment/RoleAssignmentDetailPage.tsx
msgid "Details Role Assignment"
msgstr "Details Role Assignment"

#: src/auth/pages/rolePermission/RolePermissionDetailPage.tsx
msgid "Details Role Permission"
msgstr "Details Role Permission"

#: src/auth/pages/scopeGroup/ScopeGroupDetailPage.tsx
msgid "Details Scope Group"
msgstr "Details Scope Group"

#: src/timber/pages/shipment/ShipmentDetailPage.tsx
msgid "Details Shipment"
msgstr "Details Shipment"

#: src/timber/pages/shipmentHistory/ShipmentHistoryDetailPage.tsx
msgid "Details Shipment History"
msgstr "Details Shipment History"

#: src/timber/pages/thicknessClass/ThicknessClassDetailPage.tsx
msgid "Details Thickness Class"
msgstr "Details Thickness Class"

#: src/timber/pages/timberClass/TimberClassDetailPage.tsx
msgid "Details Timber Class"
msgstr "Details Timber Class"

#: src/timber/pages/timberStorage/TimberStorageDetailPage.tsx
msgid "Details Timber Storage"
msgstr "Details Timber Storage"

#: src/timber/pages/timberType/TimberTypeDetailPage.tsx
msgid "Details Timber Type"
msgstr "Details Timber Type"

#: src/timber/pages/treeMarking/TreeMarkingDetailPage.tsx
msgid "Details Tree Marking"
msgstr "Details Tree Marking"

#: src/auth/pages/user/UserDetailPage.tsx
msgid "Details User"
msgstr "Details User"

#: src/address/pages/userAddress/UserAddressDetailPage.tsx
msgid "Details User Address"
msgstr "Details User Address"

#: src/auth/pages/userSession/UserSessionDetailPage.tsx
msgid "Details User Session"
msgstr "Details User Session"

#: src/auth/components/userSession/UserSessionDetail/UserSessionDetail.tsx
#: src/auth/components/userSession/UserSessionForm/UserSessionAddForm.tsx
#: src/auth/components/userSession/UserSessionForm/UserSessionUpdateForm.tsx
#: src/auth/components/userSession/UserSessionList/UserSessionListItem.tsx
msgid "Device"
msgstr "Device"

#: src/timber/components/history/HistoryList/HistoryListItemRow.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogDetail.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogListItemForShipment.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogListItemFromHistory.tsx
msgid "Diameter"
msgstr "Diameter"

#: src/timber/components/log/LogDetail/LogDetail.tsx
#: src/timber/components/log/LogForm/LogAddForm.tsx
#: src/timber/components/log/LogForm/LogUpdateForm.tsx
#: src/timber/components/log/LogList/LogListItem.tsx
#: src/timber/components/logHistory/LogHistoryDetail/LogHistoryDetail.tsx
#: src/timber/components/logHistory/LogHistoryList/LogHistoryListItem.tsx
msgid "Diameter (cm)"
msgstr "Diameter (cm)"

#: src/timber/components/log/LogList/LogListSearch.tsx
msgid "Diameter (cm) From"
msgstr "Diameter (cm) From"

#: src/timber/components/log/LogList/LogListSearch.tsx
msgid "Diameter (cm) To"
msgstr "Diameter (cm) To"

#: src/share/components/chat/ChatFileList.tsx
msgid "Download"
msgstr "Download"

#. placeholder {0}: file.filename
#: src/share/components/chat/ChatFileList.tsx
msgid "Download {0}"
msgstr "Download {0}"

#: src/share/components/footer/Footer.tsx
msgid "Download Mobile App"
msgstr "Download Mobile App"

#: src/timber/components/driver/DriverDetail/DriverDetail.tsx
#: src/timber/components/shipment/ShipmentDetail/ShipmentDetail.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx
#: src/timber/pages/driver/DriverEntityPage.tsx
#~ msgid "Driver"
#~ msgstr "Driver"

#: src/timber/hooks/useDriver.ts
#~ msgid "Driver add error: "
#~ msgstr "Driver add error: "

#: src/timber/hooks/useDriver.ts
#~ msgid "Driver delete error: "
#~ msgstr "Driver delete error: "

#: src/timber/hooks/useDriver.ts
#~ msgid "Driver deleted"
#~ msgstr "Driver deleted"

#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx
#~ msgid "Driver Id is required"
#~ msgstr "Driver Id is required"

#: src/timber/components/shipment/ShipmentDetail/ShipmentDetail.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx
#~ msgid "Driver Name"
#~ msgstr "Driver Name"

#: src/timber/components/shipment/ShipmentDetail/ShipmentDetail.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx
#~ msgid "Driver Registration Number"
#~ msgstr "Driver Registration Number"

#: src/timber/hooks/useDriver.ts
#~ msgid "Driver update error: "
#~ msgstr "Driver update error: "

#: src/timber/hooks/useDriver.ts
#~ msgid "Driver updated"
#~ msgstr "Driver updated"

#: src/app/mappers.tsx
#: src/timber/components/driver/DriverList/DriverListHeader.tsx
#: src/timber/pages/listItems.tsx
#~ msgid "Drivers"
#~ msgstr "Drivers"

#: src/share/components/layout/Layout/Trash.tsx
msgid "Drop here to delete"
msgstr "Drop here to delete"

#: src/address/components/address/AddressList/AddressListItemTools.tsx
#: src/address/components/userAddress/UserAddressList/UserAddressListItemTools.tsx
#: src/address/pages/address/AddressDetailPage.tsx
#: src/address/pages/address/AddressEntityPage.tsx
#: src/auth/components/membersGroup/MembersGroupList/MembersGroupListItemTools.tsx
#: src/auth/components/membersGroupUser/MembersGroupUserList/MembersGroupUserListItemTools.tsx
#: src/auth/components/role/RoleList/RoleListItemTools.tsx
#: src/auth/components/roleAssignment/RoleAssignmentList/RoleAssignmentListItemTools.tsx
#: src/auth/components/rolePermission/RolePermissionList/RolePermissionListItemTools.tsx
#: src/auth/components/scopeGroup/ScopeGroupList/ScopeGroupListItemTools.tsx
#: src/auth/components/user/UserList/UserListItemTools.tsx
#: src/auth/components/userSession/UserSessionList/UserSessionListItemTools.tsx
#: src/auth/pages/membersGroup/MembersGroupDetailPage.tsx
#: src/auth/pages/membersGroup/MembersGroupEntityPage.tsx
#: src/auth/pages/role/RoleDetailPage.tsx
#: src/auth/pages/role/RoleEntityPage.tsx
#: src/auth/pages/scopeGroup/ScopeGroupDetailPage.tsx
#: src/auth/pages/scopeGroup/ScopeGroupEntityPage.tsx
#: src/auth/pages/user/UserDetailPage.tsx
#: src/auth/pages/user/UserEntityPage.tsx
#: src/auth/pages/userSession/UserSessionDetailPage.tsx
#: src/auth/pages/userSession/UserSessionEntityPage.tsx
#: src/location/components/location/LocationList/LocationListItemTools.tsx
#: src/location/pages/location/LocationDetailPage.tsx
#: src/location/pages/location/LocationEntityPage.tsx
#: src/share/components/breadcrumbs/RouterBreadcrumbs.tsx
#: src/timber/components/accountingUser/AccountingUserList/AccountingUserListItemTools.tsx
#: src/timber/components/buyer/BuyerList/BuyerListItemTools.tsx
#: src/timber/components/buyerUser/BuyerUserList/BuyerUserListItemTools.tsx
#: src/timber/components/contractor/ContractorList/ContractorListItemTools.tsx
#: src/timber/components/contractorUser/ContractorUserList/ContractorUserListItemTools.tsx
#: src/timber/components/cordwood/CordwoodList/CordwoodListItemTools.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListItemTools.tsx
#: src/timber/components/cutting/CuttingList/CuttingListItemTools.tsx
#: src/timber/components/forestOwner/ForestOwnerList/ForestOwnerListItemTools.tsx
#: src/timber/components/log/LogList/LogListItemTools.tsx
#: src/timber/components/logHistory/LogHistoryList/LogHistoryListItemTools.tsx
#: src/timber/components/price/PriceList/PriceListItemTools.tsx
#: src/timber/components/pricingProfile/PricingProfileList/PricingProfileListItemTools.tsx
#: src/timber/components/provider/ProviderList/ProviderListItemTools.tsx
#: src/timber/components/providerUser/ProviderUserList/ProviderUserListItemTools.tsx
#: src/timber/components/roadCarrier/RoadCarrierList/RoadCarrierListItemTools.tsx
#: src/timber/components/shipment/ShipmentList/ShipmentListItemTools.tsx
#: src/timber/components/shipmentHistory/ShipmentHistoryList/ShipmentHistoryListItemTools.tsx
#: src/timber/components/thicknessClass/ThicknessClassList/ThicknessClassListItemTools.tsx
#: src/timber/components/timberClass/TimberClassList/TimberClassListItemTools.tsx
#: src/timber/components/timberStorage/TimberStorageList/TimberStorageListItemTools.tsx
#: src/timber/components/timberType/TimberTypeList/TimberTypeListItemTools.tsx
#: src/timber/components/treeMarking/TreeMarkingList/TreeMarkingListItemTools.tsx
#: src/timber/pages/accountingUser/AccountingUserDetailPage.tsx
#: src/timber/pages/accountingUser/AccountingUserEntityPage.tsx
#: src/timber/pages/buyer/BuyerDetailPage.tsx
#: src/timber/pages/buyer/BuyerEntityPage.tsx
#: src/timber/pages/buyerUser/BuyerUserDetailPage.tsx
#: src/timber/pages/buyerUser/BuyerUserEntityPage.tsx
#: src/timber/pages/contractor/ContractorDetailPage.tsx
#: src/timber/pages/contractor/ContractorEntityPage.tsx
#: src/timber/pages/contractorUser/ContractorUserDetailPage.tsx
#: src/timber/pages/contractorUser/ContractorUserEntityPage.tsx
#: src/timber/pages/cordwood/CordwoodDetailPage.tsx
#: src/timber/pages/cordwood/CordwoodEntityPage.tsx
#: src/timber/pages/cutting/CuttingDetailPage.tsx
#: src/timber/pages/cutting/CuttingEntityPage.tsx
#: src/timber/pages/forestOwner/ForestOwnerDetailPage.tsx
#: src/timber/pages/forestOwner/ForestOwnerEntityPage.tsx
#: src/timber/pages/log/LogDetailPage.tsx
#: src/timber/pages/log/LogEntityPage.tsx
#: src/timber/pages/price/PriceDetailPage.tsx
#: src/timber/pages/price/PriceEntityPage.tsx
#: src/timber/pages/pricingProfile/PricingProfileDetailPage.tsx
#: src/timber/pages/pricingProfile/PricingProfileEntityPage.tsx
#: src/timber/pages/provider/ProviderDetailPage.tsx
#: src/timber/pages/provider/ProviderEntityPage.tsx
#: src/timber/pages/providerUser/ProviderUserDetailPage.tsx
#: src/timber/pages/providerUser/ProviderUserEntityPage.tsx
#: src/timber/pages/roadCarrier/RoadCarrierDetailPage.tsx
#: src/timber/pages/roadCarrier/RoadCarrierEntityPage.tsx
#: src/timber/pages/shipment/ShipmentDetailPage.tsx
#: src/timber/pages/shipment/ShipmentEntityPage.tsx
#: src/timber/pages/thicknessClass/ThicknessClassDetailPage.tsx
#: src/timber/pages/thicknessClass/ThicknessClassEntityPage.tsx
#: src/timber/pages/timberClass/TimberClassDetailPage.tsx
#: src/timber/pages/timberClass/TimberClassEntityPage.tsx
#: src/timber/pages/timberStorage/TimberStorageDetailPage.tsx
#: src/timber/pages/timberStorage/TimberStorageEntityPage.tsx
#: src/timber/pages/timberType/TimberTypeDetailPage.tsx
#: src/timber/pages/timberType/TimberTypeEntityPage.tsx
#: src/timber/pages/treeMarking/TreeMarkingDetailPage.tsx
#: src/timber/pages/treeMarking/TreeMarkingEntityPage.tsx
msgid "Edit"
msgstr "Edit"

#: src/timber/pages/accountingUser/AccountingUserUpdateEditPage.tsx
msgid "Edit Accounting User"
msgstr "Edit Accounting User"

#: src/address/pages/address/AddressUpdateEditPage.tsx
msgid "Edit Address"
msgstr "Edit Address"

#: src/share/components/chat/ChatMessage.tsx
msgid "Edit and resend"
msgstr "Edit and resend"

#: src/timber/pages/buyer/BuyerUpdateEditPage.tsx
msgid "Edit Buyer"
msgstr "Edit Buyer"

#: src/timber/pages/buyerUser/BuyerUserUpdateEditPage.tsx
msgid "Edit Buyer User"
msgstr "Edit Buyer User"

#: src/timber/pages/contractor/ContractorUpdateEditPage.tsx
msgid "Edit Contractor"
msgstr "Edit Contractor"

#: src/timber/pages/contractorUser/ContractorUserUpdateEditPage.tsx
msgid "Edit Contractor User"
msgstr "Edit Contractor User"

#: src/timber/pages/cordwood/CordwoodUpdateEditPage.tsx
msgid "Edit Cordwood"
msgstr "Edit Cordwood"

#: src/timber/pages/cordwoodHistory/CordwoodHistoryUpdateEditPage.tsx
msgid "Edit Cordwood History"
msgstr "Edit Cordwood History"

#: src/timber/pages/cutting/CuttingUpdateEditPage.tsx
msgid "Edit Cutting"
msgstr "Edit Cutting"

#: src/timber/pages/driver/DriverUpdateEditPage.tsx
#~ msgid "Edit Driver"
#~ msgstr "Edit Driver"

#: src/timber/pages/forestOwner/ForestOwnerUpdateEditPage.tsx
msgid "Edit Forest Owner"
msgstr "Edit Forest Owner"

#: src/location/pages/location/LocationUpdateEditPage.tsx
msgid "Edit Location"
msgstr "Edit Location"

#: src/timber/pages/log/LogUpdateEditPage.tsx
msgid "Edit Log"
msgstr "Edit Log"

#: src/timber/pages/logHistory/LogHistoryUpdateEditPage.tsx
msgid "Edit Log History"
msgstr "Edit Log History"

#: src/auth/pages/membersGroup/MembersGroupUpdateEditPage.tsx
msgid "Edit Members Group"
msgstr "Edit Members Group"

#: src/auth/pages/membersGroupUser/MembersGroupUserUpdateEditPage.tsx
msgid "Edit Members Group User"
msgstr "Edit Members Group User"

#: src/share/components/chat/ChatMessage.tsx
msgid "Edit message"
msgstr "Edit message"

#: src/timber/pages/price/PriceUpdateEditPage.tsx
msgid "Edit Price"
msgstr "Edit Price"

#: src/timber/pages/pricingProfile/PricingProfileUpdateEditPage.tsx
msgid "Edit Pricing Profile"
msgstr "Edit Pricing Profile"

#: src/timber/pages/provider/ProviderUpdateEditPage.tsx
msgid "Edit Provider"
msgstr "Edit Provider"

#: src/timber/pages/providerUser/ProviderUserUpdateEditPage.tsx
msgid "Edit Provider User"
msgstr "Edit Provider User"

#: src/timber/pages/roadCarrier/RoadCarrierUpdateEditPage.tsx
msgid "Edit Road Carrier"
msgstr "Edit Road Carrier"

#: src/auth/pages/role/RoleUpdateEditPage.tsx
msgid "Edit Role"
msgstr "Edit Role"

#: src/auth/pages/roleAssignment/RoleAssignmentUpdateEditPage.tsx
msgid "Edit Role Assignment"
msgstr "Edit Role Assignment"

#: src/auth/pages/rolePermission/RolePermissionUpdateEditPage.tsx
msgid "Edit Role Permission"
msgstr "Edit Role Permission"

#: src/auth/pages/scopeGroup/ScopeGroupUpdateEditPage.tsx
msgid "Edit Scope Group"
msgstr "Edit Scope Group"

#: src/timber/pages/shipment/ShipmentUpdateEditPage.tsx
msgid "Edit Shipment"
msgstr "Edit Shipment"

#: src/timber/pages/shipmentHistory/ShipmentHistoryUpdateEditPage.tsx
msgid "Edit Shipment History"
msgstr "Edit Shipment History"

#: src/timber/pages/thicknessClass/ThicknessClassUpdateEditPage.tsx
msgid "Edit Thickness Class"
msgstr "Edit Thickness Class"

#: src/timber/pages/timberClass/TimberClassUpdateEditPage.tsx
msgid "Edit Timber Class"
msgstr "Edit Timber Class"

#: src/timber/pages/timberStorage/TimberStorageUpdateEditPage.tsx
msgid "Edit Timber Storage"
msgstr "Edit Timber Storage"

#: src/timber/pages/timberType/TimberTypeUpdateEditPage.tsx
msgid "Edit Timber Type"
msgstr "Edit Timber Type"

#: src/timber/pages/treeMarking/TreeMarkingUpdateEditPage.tsx
msgid "Edit Tree Marking"
msgstr "Edit Tree Marking"

#: src/auth/pages/user/UserUpdateEditPage.tsx
msgid "Edit User"
msgstr "Edit User"

#: src/address/pages/userAddress/UserAddressUpdateEditPage.tsx
msgid "Edit User Address"
msgstr "Edit User Address"

#: src/auth/pages/userSession/UserSessionUpdateEditPage.tsx
msgid "Edit User Session"
msgstr "Edit User Session"

#: src/share/components/chat/ChatMessage.tsx
msgid "Edit your question"
msgstr "Edit your question"

#: src/address/components/address/AddressDetail/AddressDetail.tsx
#: src/address/components/address/AddressForm/AddressAddForm.tsx
#: src/address/components/address/AddressForm/AddressUpdateForm.tsx
#: src/address/components/address/AddressList/AddressListItem.tsx
#: src/auth/components/user/UserDetail/UserDetail.tsx
#: src/auth/components/user/UserForm/UserAddForm.tsx
#: src/auth/components/user/UserList/UserListItem.tsx
#: src/timber/components/accountingUser/AccountingUserDetail/AccountingUserDetail.tsx
#: src/timber/components/accountingUser/AccountingUserForm/AccountingUserAddForm.tsx
#: src/timber/components/accountingUser/AccountingUserList/AccountingUserListItem.tsx
#: src/timber/components/buyerUser/BuyerUserDetail/BuyerUserDetail.tsx
#: src/timber/components/buyerUser/BuyerUserForm/BuyerUserAddForm.tsx
#: src/timber/components/buyerUser/BuyerUserList/BuyerUserListItem.tsx
#: src/timber/components/contractorUser/ContractorUserDetail/ContractorUserDetail.tsx
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserAddForm.tsx
#: src/timber/components/contractorUser/ContractorUserList/ContractorUserListItem.tsx
#: src/timber/components/providerUser/ProviderUserDetail/ProviderUserDetail.tsx
#: src/timber/components/providerUser/ProviderUserForm/ProviderUserAddForm.tsx
#: src/timber/components/providerUser/ProviderUserList/ProviderUserListItem.tsx
msgid "Email"
msgstr "Email"

#: src/pages/ForgotPasswordPage.tsx
#: src/pages/LoginPage.tsx
#: src/pages/ProfilePage.tsx
msgid "Email Address"
msgstr "Email Address"

#: src/pages/ForgotPasswordPage.tsx
#: src/pages/LoginPage.tsx
msgid "Email Address is invalid"
msgstr "Email Address is invalid"

#: src/pages/ForgotPasswordPage.tsx
#: src/pages/LoginPage.tsx
msgid "Email address is required"
msgstr "Email address is required"

#: src/auth/components/user/UserForm/UserAddForm.tsx
#: src/timber/components/accountingUser/AccountingUserForm/AccountingUserAddForm.tsx
#: src/timber/components/buyerUser/BuyerUserForm/BuyerUserAddForm.tsx
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserAddForm.tsx
#: src/timber/components/providerUser/ProviderUserForm/ProviderUserAddForm.tsx
msgid "Email is required"
msgstr "Email is required"

#: src/timber/components/cutting/CuttingDetail/CuttingDetail.tsx
#: src/timber/components/cutting/CuttingForm/CuttingAddForm.tsx
#: src/timber/components/cutting/CuttingForm/CuttingUpdateForm.tsx
#: src/timber/components/cutting/CuttingList/CuttingListItem.tsx
msgid "End At"
msgstr "End At"

#: src/timber/components/cutting/CuttingForm/CuttingAddForm.tsx
#: src/timber/components/cutting/CuttingForm/CuttingUpdateForm.tsx
msgid "End At is required"
msgstr "End At is required"

#: src/share/components/form/FormDateTime/FormDateRange.tsx
msgid "End Date"
msgstr "End Date"

#: src/pages/ForgotPasswordPage.tsx
msgid "Enter your email address and we’ll send you a link to reset your password."
msgstr "Enter your email address and we’ll send you a link to reset your password."

#: src/share/components/alert/DescriptionAlert/useDescriptionAlert.ts
msgid "Error"
msgstr "Error"

#: src/timber/components/log/LogDetail/LogDetail.tsx
#: src/timber/components/log/LogForm/LogAddForm.tsx
#: src/timber/components/log/LogForm/LogUpdateForm.tsx
#: src/timber/components/log/LogList/LogListItem.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogListItemForShipment.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogListItemFromHistory.tsx
msgid "External Key"
msgstr "External Key"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx
#: src/timber/components/generic/report/GenericRootTable.tsx
msgid "Failed to load data"
msgstr "Failed to load data"

#: src/share/components/chat/useChat.ts
msgid "Failed to send message"
msgstr "Failed to send message"

#: src/timber/types/models/CuttingState.d.ts
#: src/timber/types/models/ShipmentState.d.ts
msgid "Finished"
msgstr "Finished"

#: src/timber/components/shipment/ShipmentDetail/ShipmentDetail.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx
msgid "For Personal Use"
msgstr "For Personal Use"

#: src/pages/PrivacyPolicyPage.tsx
msgid "For questions, contact: info@iokrono.com."
msgstr "For questions, contact: info@iokrono.com."

#: src/timber/components/cutting/CuttingDetail/CuttingDetail.tsx
#: src/timber/components/cutting/CuttingForm/CuttingAddForm.tsx
#: src/timber/components/cutting/CuttingForm/CuttingUpdateForm.tsx
#: src/timber/components/cutting/CuttingList/CuttingListItem.tsx
#: src/timber/components/cutting/CuttingList/CuttingListSearch.tsx
#: src/timber/components/forestOwner/ForestOwnerDetail/ForestOwnerDetail.tsx
#: src/timber/components/timberStorage/TimberStorageDetail/TimberStorageDetail.tsx
#: src/timber/components/timberStorage/TimberStorageForm/TimberStorageAddForm.tsx
#: src/timber/components/timberStorage/TimberStorageForm/TimberStorageUpdateForm.tsx
#: src/timber/components/timberStorage/TimberStorageList/TimberStorageListItem.tsx
#: src/timber/components/timberStorage/TimberStorageList/TimberStorageListSearch.tsx
#: src/timber/pages/forestOwner/ForestOwnerEntityPage.tsx
msgid "Forest Owner"
msgstr "Forest Owner"

#: src/timber/hooks/useForestOwner.ts
msgid "Forest Owner add error: "
msgstr "Forest Owner add error: "

#: src/timber/hooks/useForestOwner.ts
msgid "Forest Owner delete error: "
msgstr "Forest Owner delete error: "

#: src/timber/hooks/useForestOwner.ts
msgid "Forest Owner deleted"
msgstr "Forest Owner deleted"

#: src/timber/components/cutting/CuttingForm/CuttingAddForm.tsx
#: src/timber/components/cutting/CuttingForm/CuttingUpdateForm.tsx
#: src/timber/components/timberStorage/TimberStorageForm/TimberStorageAddForm.tsx
#: src/timber/components/timberStorage/TimberStorageForm/TimberStorageUpdateForm.tsx
#~ msgid "Forest Owner Id is required"
#~ msgstr "Forest Owner Id is required"

#: src/timber/components/cutting/CuttingForm/CuttingAddForm.tsx
#: src/timber/components/cutting/CuttingForm/CuttingUpdateForm.tsx
#: src/timber/components/timberStorage/TimberStorageForm/TimberStorageAddForm.tsx
#: src/timber/components/timberStorage/TimberStorageForm/TimberStorageUpdateForm.tsx
msgid "Forest Owner is required"
msgstr "Forest Owner is required"

#: src/timber/hooks/useForestOwner.ts
msgid "Forest Owner update error: "
msgstr "Forest Owner update error: "

#: src/timber/hooks/useForestOwner.ts
msgid "Forest Owner updated"
msgstr "Forest Owner updated"

#: src/timber/types/models/Split.ts
msgid "Forest owners"
msgstr "Forest owners"

#: src/app/mappers.tsx
#: src/timber/components/forestOwner/ForestOwnerList/ForestOwnerListHeader.tsx
#: src/timber/pages/listItems.tsx
msgid "Forest Owners"
msgstr "Forest Owners"

#: src/pages/ForgotPasswordPage.tsx
msgid "Forgot Password"
msgstr "Forgot Password"

#: src/pages/LoginPage.tsx
msgid "Forgot Password?"
msgstr "Forgot Password?"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx
#: src/timber/components/generic/report/GenericRootReport.tsx
#: src/timber/components/generic/report/TimelineRootReport.tsx
msgid "From"
msgstr "From"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx
#: src/timber/components/generic/report/GenericRootReport.tsx
#: src/timber/components/generic/report/TimelineRootReport.tsx
#~ msgid "From Input Date"
#~ msgstr "From Input Date"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx
#: src/timber/components/generic/report/GenericRootReport.tsx
#: src/timber/components/generic/report/TimelineRootReport.tsx
#~ msgid "From Shipment Date"
#~ msgstr "From Shipment Date"

#: src/pages/ProfilePage.tsx
msgid "Full Name"
msgstr "Full Name"

#: src/share/components/chat/ChatThread.tsx
msgid "Give me a report for the last month for each active cutting"
msgstr "Give me a report for the last month for each active cutting"

#: src/share/components/chat/ChatThread.tsx
msgid "Give me a report for the last month for each contractor"
msgstr "Give me a report for the last month for each contractor"

#: src/share/components/scope/ScopeSwitcher.tsx
msgid "Global"
msgstr "Global"

#: src/pages/NotFoundPage.tsx
#: src/pages/UnauthorizedPage.tsx
msgid "Go Home"
msgstr "Go Home"

#: src/pages/NotFoundPage.tsx
#: src/pages/UnauthorizedPage.tsx
msgid "Go Login"
msgstr "Go Login"

#: src/pages/DashboardHomePage.tsx
msgid "Go to"
msgstr "Go to"

#: src/timber/components/generic/report/GenericRootReport.tsx
msgid "Graphs"
msgstr "Graphs"

#: src/auth/components/membersGroup/MembersGroupDetail/MembersGroupDetail.tsx
#: src/auth/components/membersGroup/MembersGroupForm/MembersGroupAddForm.tsx
#: src/auth/components/membersGroup/MembersGroupList/MembersGroupListSearch.tsx
msgid "Group Type"
msgstr "Group Type"

#: src/auth/components/membersGroup/MembersGroupForm/MembersGroupAddForm.tsx
msgid "Group Type is required"
msgstr "Group Type is required"

#: src/auth/components/user/UserForm/UserAddForm.tsx
#: src/auth/components/user/UserForm/UserUpdateForm.tsx
msgid "Hash Password"
msgstr "Hash Password"

#: src/auth/components/user/UserForm/UserAddForm.tsx
#: src/auth/components/user/UserForm/UserUpdateForm.tsx
msgid "Hash Password is required"
msgstr "Hash Password is required"

#: src/share/components/chat/ChatWidget.tsx
msgid "Hide history"
msgstr "Hide history"

#: src/auth/components/membersGroup/MembersGroupDetail/MembersGroupDetail.tsx
#: src/auth/components/membersGroup/MembersGroupList/MembersGroupListItem.tsx
#: src/auth/components/membersGroup/MembersGroupList/MembersGroupListSearch.tsx
#: src/auth/components/scopeGroup/ScopeGroupDetail/ScopeGroupDetail.tsx
#: src/auth/components/scopeGroup/ScopeGroupList/ScopeGroupListItem.tsx
#: src/location/components/location/LocationDetail/LocationDetail.tsx
#: src/location/components/location/LocationList/LocationListItem.tsx
#: src/location/components/location/LocationList/LocationListSearch.tsx
msgid "Hierarchy Name"
msgstr "Hierarchy Name"

#: src/app/App.tsx
#: src/pages/listItems.tsx
#: src/timber/components/history/HistoryList/HistoryListHeader.tsx
#: src/timber/pages/history/HistoryListPage.tsx
msgid "History"
msgstr "History"

#: src/app/App.tsx
msgid "Home"
msgstr "Home"

#: src/share/components/chat/ChatThread.tsx
#~ msgid "How many timber storages are there?"
#~ msgstr "How many timber storages are there?"

#: src/share/components/footer/Footer.tsx
msgid "How to Install APK on Android"
msgstr "How to Install APK on Android"

#: src/timber/components/buyer/BuyerDetail/BuyerDetail.tsx
#: src/timber/components/buyer/BuyerForm/BuyerAddForm.tsx
#: src/timber/components/buyer/BuyerForm/BuyerUpdateForm.tsx
#: src/timber/components/contractor/ContractorDetail/ContractorDetail.tsx
#: src/timber/components/contractor/ContractorForm/ContractorAddForm.tsx
#: src/timber/components/contractor/ContractorForm/ContractorUpdateForm.tsx
#: src/timber/components/forestOwner/ForestOwnerDetail/ForestOwnerDetail.tsx
#: src/timber/components/forestOwner/ForestOwnerForm/ForestOwnerAddForm.tsx
#: src/timber/components/forestOwner/ForestOwnerForm/ForestOwnerUpdateForm.tsx
#: src/timber/components/provider/ProviderDetail/ProviderDetail.tsx
#: src/timber/components/provider/ProviderForm/ProviderAddForm.tsx
#: src/timber/components/provider/ProviderForm/ProviderUpdateForm.tsx
msgid "Iban"
msgstr "Iban"

#: src/pages/ProfilePage.tsx
msgid "Id"
msgstr "Id"

#: src/timber/components/cordwood/CordwoodDetail/CordwoodDetail.tsx
#: src/timber/components/cordwood/CordwoodList/CordwoodListItem.tsx
#: src/timber/components/cordwood/CordwoodList/CordwoodListSearch.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryDetail/CordwoodHistoryDetail.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListItem.tsx
#: src/timber/components/log/LogDetail/LogDetail.tsx
#: src/timber/components/log/LogList/LogListItem.tsx
#: src/timber/components/log/LogList/LogListSearch.tsx
#: src/timber/components/logHistory/LogHistoryDetail/LogHistoryDetail.tsx
#: src/timber/components/logHistory/LogHistoryList/LogHistoryListItem.tsx
#: src/timber/components/shipment/ShipmentRegulator/CordwoodListItemForShipment.tsx
#: src/timber/components/shipment/ShipmentRegulator/CordwoodListItemFromHistory.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogListItemForShipment.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogListItemFromHistory.tsx
msgid "IK"
msgstr "IK"

#: src/timber/types/models/CuttingState.d.ts
#: src/timber/types/models/ShipmentState.d.ts
msgid "In progress"
msgstr "In progress"

#: src/timber/components/provider/ProviderDetail/ProviderSummaryCards.tsx
msgid "In storage (m³)"
msgstr "In storage (m³)"

#: src/share/components/form/FormInput/NumberField.tsx
msgid "Increase"
msgstr "Increase"

#: src/timber/components/generic/report/GenericRootShipments.tsx
#: src/timber/components/history/HistoryList/HistoryListItem.tsx
#: src/timber/components/shipment/ShipmentDetail/ShipmentDetail.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx
#: src/timber/components/shipment/ShipmentList/ShipmentListItem.tsx
#: src/timber/components/shipment/ShipmentList/ShipmentListSearch.tsx
#: src/timber/components/shipmentHistory/ShipmentHistoryDetail/ShipmentHistoryDetail.tsx
#: src/timber/components/shipmentHistory/ShipmentHistoryList/ShipmentHistoryListItem.tsx
msgid "Key"
msgstr "Key"

#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx
msgid "Key is required"
msgstr "Key is required"

#: src/share/components/localization/Locale/Locale.tsx
msgid "Language"
msgstr "Language"

#: src/share/components/chat/ConversationList.tsx
msgid "Last 7 days"
msgstr "Last 7 days"

#: src/share/components/form/FormDateTime/FormDateRange.tsx
msgid "Last Month"
msgstr "Last Month"

#: src/pages/PrivacyPolicyPage.tsx
msgid "Last updated:"
msgstr "Last updated:"

#: src/share/components/form/FormDateTime/FormDateRange.tsx
msgid "Last Week"
msgstr "Last Week"

#: src/share/components/form/FormDateTime/FormDateRange.tsx
msgid "Last Year"
msgstr "Last Year"

#: src/timber/components/provider/ProviderDetail/ProviderSummaryCards.tsx
msgid "left the storage"
msgstr "left the storage"

#: src/timber/components/history/HistoryList/HistoryListItemRow.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogDetail.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogListItemForShipment.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogListItemFromHistory.tsx
msgid "Length"
msgstr "Length"

#: src/timber/components/log/LogDetail/LogDetail.tsx
#: src/timber/components/log/LogForm/LogAddForm.tsx
#: src/timber/components/log/LogForm/LogUpdateForm.tsx
#: src/timber/components/log/LogList/LogListItem.tsx
#: src/timber/components/logHistory/LogHistoryDetail/LogHistoryDetail.tsx
#: src/timber/components/logHistory/LogHistoryList/LogHistoryListItem.tsx
msgid "Length (cm)"
msgstr "Length (cm)"

#: src/timber/components/log/LogList/LogListSearch.tsx
msgid "Length (cm) From"
msgstr "Length (cm) From"

#: src/timber/components/log/LogList/LogListSearch.tsx
msgid "Length (cm) To"
msgstr "Length (cm) To"

#: src/pages/PreferencesPage.tsx
msgid "Light"
msgstr "Light"

#: src/timber/components/history/HistoryList/HistoryListItemRow.tsx
#: src/timber/components/log/LogDetail/LogDetail.tsx
#: src/timber/components/log/LogForm/LogAddForm.tsx
#: src/timber/components/log/LogForm/LogUpdateForm.tsx
#: src/timber/components/log/LogList/LogListItem.tsx
#: src/timber/components/logHistory/LogHistoryDetail/LogHistoryDetail.tsx
#: src/timber/components/logHistory/LogHistoryList/LogHistoryListItem.tsx
msgid "Linked"
msgstr "Linked"

#: src/timber/pages/accountingUser/AccountingUserListPage.tsx
msgid "List Accounting User"
msgstr "List Accounting User"

#: src/address/pages/address/AddressListPage.tsx
msgid "List Address"
msgstr "List Address"

#: src/timber/pages/buyer/BuyerListPage.tsx
msgid "List Buyer"
msgstr "List Buyer"

#: src/timber/pages/buyerUser/BuyerUserListPage.tsx
msgid "List Buyer User"
msgstr "List Buyer User"

#: src/timber/pages/contractor/ContractorListPage.tsx
msgid "List Contractor"
msgstr "List Contractor"

#: src/timber/pages/contractorUser/ContractorUserListPage.tsx
msgid "List Contractor User"
msgstr "List Contractor User"

#: src/timber/pages/cordwood/CordwoodListPage.tsx
msgid "List Cordwood"
msgstr "List Cordwood"

#: src/timber/pages/cordwoodHistory/CordwoodHistoryListPage.tsx
msgid "List Cordwood History"
msgstr "List Cordwood History"

#: src/timber/pages/cutting/CuttingListPage.tsx
msgid "List Cutting"
msgstr "List Cutting"

#: src/timber/pages/driver/DriverListPage.tsx
#~ msgid "List Driver"
#~ msgstr "List Driver"

#: src/timber/pages/forestOwner/ForestOwnerListPage.tsx
msgid "List Forest Owner"
msgstr "List Forest Owner"

#: src/location/pages/location/LocationListPage.tsx
msgid "List Location"
msgstr "List Location"

#: src/timber/pages/log/LogListPage.tsx
msgid "List Log"
msgstr "List Log"

#: src/timber/pages/logHistory/LogHistoryListPage.tsx
msgid "List Log History"
msgstr "List Log History"

#: src/auth/pages/membersGroup/MembersGroupListPage.tsx
msgid "List Members Group"
msgstr "List Members Group"

#: src/auth/pages/membersGroupUser/MembersGroupUserListPage.tsx
msgid "List Members Group User"
msgstr "List Members Group User"

#: src/timber/pages/price/PriceListPage.tsx
msgid "List Price"
msgstr "List Price"

#: src/timber/pages/pricingProfile/PricingProfileListPage.tsx
msgid "List Pricing Profile"
msgstr "List Pricing Profile"

#: src/timber/pages/provider/ProviderListPage.tsx
msgid "List Provider"
msgstr "List Provider"

#: src/timber/pages/providerUser/ProviderUserListPage.tsx
msgid "List Provider User"
msgstr "List Provider User"

#: src/timber/pages/roadCarrier/RoadCarrierListPage.tsx
msgid "List Road Carrier"
msgstr "List Road Carrier"

#: src/auth/pages/role/RoleListPage.tsx
msgid "List Role"
msgstr "List Role"

#: src/auth/pages/roleAssignment/RoleAssignmentListPage.tsx
msgid "List Role Assignment"
msgstr "List Role Assignment"

#: src/auth/pages/rolePermission/RolePermissionListPage.tsx
msgid "List Role Permission"
msgstr "List Role Permission"

#: src/auth/pages/scopeGroup/ScopeGroupListPage.tsx
msgid "List Scope Group"
msgstr "List Scope Group"

#: src/timber/pages/shipment/ShipmentListPage.tsx
msgid "List Shipment"
msgstr "List Shipment"

#: src/timber/pages/shipmentHistory/ShipmentHistoryListPage.tsx
msgid "List Shipment History"
msgstr "List Shipment History"

#: src/share/components/chat/ChatThread.tsx
#~ msgid "List the timber classes"
#~ msgstr "List the timber classes"

#: src/timber/pages/thicknessClass/ThicknessClassListPage.tsx
msgid "List Thickness Class"
msgstr "List Thickness Class"

#: src/timber/pages/timberClass/TimberClassListPage.tsx
msgid "List Timber Class"
msgstr "List Timber Class"

#: src/timber/pages/timberStorage/TimberStorageListPage.tsx
msgid "List Timber Storage"
msgstr "List Timber Storage"

#: src/timber/pages/timberType/TimberTypeListPage.tsx
msgid "List Timber Type"
msgstr "List Timber Type"

#: src/timber/pages/treeMarking/TreeMarkingListPage.tsx
msgid "List Tree Marking"
msgstr "List Tree Marking"

#: src/auth/pages/user/UserListPage.tsx
msgid "List User"
msgstr "List User"

#: src/address/pages/userAddress/UserAddressListPage.tsx
msgid "List User Address"
msgstr "List User Address"

#: src/auth/pages/userSession/UserSessionListPage.tsx
msgid "List User Session"
msgstr "List User Session"

#: src/share/components/chat/ConversationList.tsx
msgid "Load more"
msgstr "Load more"

#: src/share/components/chat/ConversationList.tsx
msgid "Loading..."
msgstr "Loading..."

#: src/timber/components/cordwood/CordwoodDetail/CordwoodDetail.tsx
#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryDetail/CordwoodHistoryDetail.tsx
#: src/timber/components/log/LogDetail/LogDetail.tsx
#: src/timber/components/log/LogForm/LogAddForm.tsx
#: src/timber/components/logHistory/LogHistoryDetail/LogHistoryDetail.tsx
#: src/timber/components/shipmentHistory/ShipmentHistoryDetail/ShipmentHistoryDetail.tsx
msgid "Local Created At"
msgstr "Local Created At"

#: src/timber/components/cordwood/CordwoodList/CordwoodListSearch.tsx
#: src/timber/components/log/LogList/LogListSearch.tsx
msgid "Local Created At From"
msgstr "Local Created At From"

#: src/timber/components/cordwood/CordwoodList/CordwoodListSearch.tsx
#: src/timber/components/log/LogList/LogListSearch.tsx
msgid "Local Created At To"
msgstr "Local Created At To"

#: src/timber/components/cordwood/CordwoodDetail/CordwoodDetail.tsx
#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx
#: src/timber/components/cordwood/CordwoodForm/CordwoodUpdateForm.tsx
#: src/timber/components/log/LogDetail/LogDetail.tsx
#: src/timber/components/log/LogForm/LogAddForm.tsx
#: src/timber/components/log/LogForm/LogUpdateForm.tsx
msgid "Local Deleted At"
msgstr "Local Deleted At"

#: src/timber/components/cordwood/CordwoodDetail/CordwoodDetail.tsx
#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx
#: src/timber/components/cordwood/CordwoodForm/CordwoodUpdateForm.tsx
#: src/timber/components/log/LogDetail/LogDetail.tsx
#: src/timber/components/log/LogForm/LogAddForm.tsx
#: src/timber/components/log/LogForm/LogUpdateForm.tsx
msgid "Local Updated At"
msgstr "Local Updated At"

#: src/location/components/location/LocationDetail/LocationDetail.tsx
#: src/location/components/location/LocationList/LocationListSearch.tsx
#: src/location/pages/location/LocationEntityPage.tsx
#: src/timber/components/cordwood/CordwoodDetail/CordwoodDetail.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryDetail/CordwoodHistoryDetail.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListItem.tsx
#: src/timber/components/cutting/CuttingDetail/CuttingDetail.tsx
#: src/timber/components/cutting/CuttingForm/CuttingAddForm.tsx
#: src/timber/components/cutting/CuttingForm/CuttingUpdateForm.tsx
#: src/timber/components/log/LogDetail/LogDetail.tsx
#: src/timber/components/logHistory/LogHistoryDetail/LogHistoryDetail.tsx
#: src/timber/components/logHistory/LogHistoryList/LogHistoryListItem.tsx
#: src/timber/components/shipment/ShipmentDetail/ShipmentDetail.tsx
#: src/timber/components/timberStorage/TimberStorageDetail/TimberStorageDetail.tsx
#: src/timber/components/timberStorage/TimberStorageForm/TimberStorageAddForm.tsx
#: src/timber/components/timberStorage/TimberStorageForm/TimberStorageUpdateForm.tsx
#: src/timber/components/timberStorage/TimberStorageList/TimberStorageListItem.tsx
msgid "Location"
msgstr "Location"

#: src/location/hooks/useLocation.ts
msgid "Location add error: "
msgstr "Location add error: "

#: src/location/hooks/useLocation.ts
msgid "Location delete error: "
msgstr "Location delete error: "

#: src/location/hooks/useLocation.ts
msgid "Location deleted"
msgstr "Location deleted"

#: src/timber/components/cutting/CuttingForm/CuttingAddForm.tsx
#: src/timber/components/cutting/CuttingForm/CuttingUpdateForm.tsx
#: src/timber/components/timberStorage/TimberStorageForm/TimberStorageAddForm.tsx
#: src/timber/components/timberStorage/TimberStorageForm/TimberStorageUpdateForm.tsx
#~ msgid "Location Id is required"
#~ msgstr "Location Id is required"

#: src/timber/components/cutting/CuttingForm/CuttingAddForm.tsx
#: src/timber/components/cutting/CuttingForm/CuttingUpdateForm.tsx
#: src/timber/components/timberStorage/TimberStorageForm/TimberStorageAddForm.tsx
#: src/timber/components/timberStorage/TimberStorageForm/TimberStorageUpdateForm.tsx
msgid "Location is required"
msgstr "Location is required"

#: src/location/hooks/useLocation.ts
msgid "Location update error: "
msgstr "Location update error: "

#: src/location/hooks/useLocation.ts
msgid "Location updated"
msgstr "Location updated"

#: src/app/mappers.tsx
#: src/location/components/location/LocationDetail/LocationTabs.tsx
#: src/location/components/location/LocationList/LocationListHeader.tsx
#: src/location/pages/listItems.tsx
msgid "Locations"
msgstr "Locations"

#: src/timber/components/log/LogDetail/LogDetail.tsx
#: src/timber/components/logHistory/LogHistoryDetail/LogHistoryDetail.tsx
#: src/timber/components/logHistory/LogHistoryForm/LogHistoryAddForm.tsx
#: src/timber/components/logHistory/LogHistoryList/LogHistoryListItem.tsx
#: src/timber/pages/log/LogEntityPage.tsx
#: src/timber/types/models/MergedHistory.ts
msgid "Log"
msgstr "Log"

#: src/timber/hooks/useLog.ts
msgid "Log add error: "
msgstr "Log add error: "

#: src/timber/hooks/useLog.ts
msgid "Log delete error: "
msgstr "Log delete error: "

#: src/timber/hooks/useLog.ts
msgid "Log deleted"
msgstr "Log deleted"

#: src/app/mappers.tsx
#: src/timber/components/log/LogDetail/LogTabs.tsx
#: src/timber/components/logHistory/LogHistoryList/LogHistoryListHeader.tsx
msgid "Log Histories"
msgstr "Log Histories"

#: src/timber/components/logHistory/LogHistoryDetail/LogHistoryDetail.tsx
#: src/timber/pages/logHistory/LogHistoryEntityPage.tsx
msgid "Log History"
msgstr "Log History"

#: src/timber/hooks/useLogHistory.ts
msgid "Log History add error: "
msgstr "Log History add error: "

#: src/timber/hooks/useLogHistory.ts
msgid "Log History delete error: "
msgstr "Log History delete error: "

#: src/timber/hooks/useLogHistory.ts
msgid "Log History deleted"
msgstr "Log History deleted"

#: src/timber/components/logHistory/LogHistoryForm/LogHistoryAddForm.tsx
#~ msgid "Log Id is required"
#~ msgstr "Log Id is required"

#: src/pages/LoginPage.tsx
msgid "Log in with another provider"
msgstr "Log in with another provider"

#: src/pages/LoginPage.tsx
#~ msgid "Log in with another provider:"
#~ msgstr "Log in with another provider:"

#: src/timber/components/logHistory/LogHistoryForm/LogHistoryAddForm.tsx
msgid "Log is required"
msgstr "Log is required"

#: src/timber/components/generic/report/GenericRootReport.tsx
msgid "Log Shipments"
msgstr "Log Shipments"

#: src/timber/hooks/useLog.ts
msgid "Log update error: "
msgstr "Log update error: "

#: src/timber/hooks/useLog.ts
msgid "Log updated"
msgstr "Log updated"

#: src/app/App.tsx
msgid "Login"
msgstr "Login"

#: src/pages/LoginPage.tsx
msgid "Login to have access!"
msgstr "Login to have access!"

#: src/app/App.tsx
msgid "Logout"
msgstr "Logout"

#: src/app/mappers.tsx
#: src/timber/components/cutting/CuttingDetail/CuttingTabs.tsx
#: src/timber/components/cutting/CuttingList/ActiveCuttings.tsx
#: src/timber/components/generic/report/GenericRootShipments.tsx
#: src/timber/components/generic/report/StorageShipmentPies.tsx
#: src/timber/components/generic/treeMarkings/ReportTreeMarkings.tsx
#: src/timber/components/history/HistoryList/HistoryListSearch.tsx
#: src/timber/components/log/LogList/LogListHeader.tsx
#: src/timber/components/provider/ProviderDetail/ProviderSummaryCards.tsx
#: src/timber/components/shipment/ShipmentDetail/ShipmentTabs.tsx
#: src/timber/components/timberStorage/TimberStorageDetail/TimberStorageTabs.tsx
#: src/timber/types/models/ShipmentType.d.ts
msgid "Logs"
msgstr "Logs"

#: src/timber/components/provider/ProviderDetail/ProviderSummaryCards.tsx
msgid "logs and cordwood"
msgstr "logs and cordwood"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx
#: src/timber/components/generic/report/GenericRootShipments.tsx
#: src/timber/components/generic/report/GenericRootTable.tsx
#: src/timber/components/generic/report/TimelineRootReport.tsx
#: src/timber/components/generic/treeMarkings/ReportTreeMarkings.tsx
msgid "Logs Count"
msgstr "Logs Count"

#: src/timber/components/provider/ProviderDetail/ProviderSummaryCards.tsx
msgid "Logs volume (m³)"
msgstr "Logs volume (m³)"

#: src/timber/types/models/CordwoodMeasurementType.d.ts
msgid "m3"
msgstr "m³"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx
msgid "Matched rows"
msgstr "Matched rows"

#: src/timber/components/thicknessClass/ThicknessClassDetail/ThicknessClassDetail.tsx
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassAddForm.tsx
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassUpdateForm.tsx
msgid "Max Diameter"
msgstr "Max Diameter"

#: src/timber/components/shipment/ShipmentRegulator/CordwoodDetail.tsx
msgid "Measurement Type"
msgstr "Measurement Unit"

#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx
#: src/timber/components/cordwood/CordwoodForm/CordwoodUpdateForm.tsx
#~ msgid "Measurement Type is required"
#~ msgstr "Measurement Unit is required"

#: src/auth/components/membersGroupUser/MembersGroupUserForm/MembersGroupUserAddForm.tsx
#: src/auth/components/role/RoleForm/RoleAddForm.tsx
#: src/auth/components/roleAssignment/RoleAssignmentForm/RoleAssignmentAddForm.tsx
#: src/auth/components/scopeGroup/ScopeGroupForm/ScopeGroupAddForm.tsx
msgid "Member Group"
msgstr "Member Group"

#: src/auth/components/membersGroupUser/MembersGroupUserForm/MembersGroupUserAddForm.tsx
#: src/auth/components/role/RoleForm/RoleAddForm.tsx
#: src/auth/components/roleAssignment/RoleAssignmentForm/RoleAssignmentAddForm.tsx
#: src/auth/components/scopeGroup/ScopeGroupForm/ScopeGroupAddForm.tsx
msgid "Member Group is required"
msgstr "Member Group is required"

#: src/auth/components/membersGroup/MembersGroupDetail/MembersGroupDetail.tsx
#: src/auth/components/membersGroup/MembersGroupList/MembersGroupListSearch.tsx
#: src/auth/components/membersGroupUser/MembersGroupUserDetail/MembersGroupUserDetail.tsx
#: src/auth/components/membersGroupUser/MembersGroupUserList/MembersGroupUserListItem.tsx
#: src/auth/components/membersGroupUser/MembersGroupUserList/MembersGroupUserListSearch.tsx
#: src/auth/components/role/RoleDetail/RoleDetail.tsx
#: src/auth/components/role/RoleList/RoleListItem.tsx
#: src/auth/components/role/RoleList/RoleListSearch.tsx
#: src/auth/components/roleAssignment/RoleAssignmentDetail/RoleAssignmentDetail.tsx
#: src/auth/components/roleAssignment/RoleAssignmentList/RoleAssignmentListItem.tsx
#: src/auth/components/roleAssignment/RoleAssignmentList/RoleAssignmentListSearch.tsx
#: src/auth/components/scopeGroup/ScopeGroupDetail/ScopeGroupDetail.tsx
#: src/auth/components/scopeGroup/ScopeGroupList/ScopeGroupListItem.tsx
#: src/auth/components/scopeGroup/ScopeGroupList/ScopeGroupListSearch.tsx
#: src/auth/components/user/UserDetail/UserDetail.tsx
#: src/auth/components/userSession/UserSessionDetail/UserSessionDetail.tsx
#: src/auth/pages/membersGroup/MembersGroupEntityPage.tsx
#: src/auth/types/models/GroupType.d.ts
msgid "Members Group"
msgstr "Members Group"

#: src/auth/hooks/useMembersGroup.ts
msgid "Members Group add error: "
msgstr "Members Group add error: "

#: src/auth/hooks/useMembersGroup.ts
msgid "Members Group delete error: "
msgstr "Members Group delete error: "

#: src/auth/hooks/useMembersGroup.ts
msgid "Members Group deleted"
msgstr "Members Group deleted"

#: src/auth/components/membersGroupUser/MembersGroupUserForm/MembersGroupUserAddForm.tsx
#: src/auth/components/role/RoleForm/RoleAddForm.tsx
#: src/auth/components/roleAssignment/RoleAssignmentForm/RoleAssignmentAddForm.tsx
#: src/auth/components/scopeGroup/ScopeGroupForm/ScopeGroupAddForm.tsx
#~ msgid "Members Group Id is required"
#~ msgstr "Members Group Id is required"

#: src/auth/hooks/useMembersGroup.ts
msgid "Members Group update error: "
msgstr "Members Group update error: "

#: src/auth/hooks/useMembersGroup.ts
msgid "Members Group updated"
msgstr "Members Group updated"

#: src/auth/components/membersGroupUser/MembersGroupUserDetail/MembersGroupUserDetail.tsx
#: src/auth/pages/membersGroupUser/MembersGroupUserEntityPage.tsx
msgid "Members Group User"
msgstr "Members Group User"

#: src/auth/hooks/useMembersGroupUser.ts
msgid "Members Group User add error: "
msgstr "Members Group User add error: "

#: src/auth/hooks/useMembersGroupUser.ts
msgid "Members Group User delete error: "
msgstr "Members Group User delete error: "

#: src/auth/hooks/useMembersGroupUser.ts
msgid "Members Group User deleted"
msgstr "Members Group User deleted"

#: src/app/mappers.tsx
#: src/auth/components/membersGroup/MembersGroupDetail/MembersGroupTabs.tsx
#: src/auth/components/membersGroupUser/MembersGroupUserList/MembersGroupUserListHeader.tsx
#: src/auth/components/user/UserDetail/UserTabs.tsx
msgid "Members Group Users"
msgstr "Members Group Users"

#: src/app/mappers.tsx
#: src/auth/components/membersGroup/MembersGroupDetail/MembersGroupTabs.tsx
#: src/auth/components/membersGroup/MembersGroupList/MembersGroupListHeader.tsx
#: src/auth/pages/listItems.tsx
msgid "Members Groups"
msgstr "Members Groups"

#: src/timber/components/thicknessClass/ThicknessClassDetail/ThicknessClassDetail.tsx
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassAddForm.tsx
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassUpdateForm.tsx
msgid "Min Diameter"
msgstr "Min Diameter"

#: src/address/components/address/AddressDetail/AddressDetail.tsx
#: src/address/components/address/AddressForm/AddressAddForm.tsx
#: src/address/components/address/AddressForm/AddressUpdateForm.tsx
#: src/address/components/address/AddressList/AddressListItem.tsx
msgid "Mobile Phone"
msgstr "Mobile Phone"

#: src/timber/components/generic/report/TimelineRootReport.tsx
msgid "Month"
msgstr "Month"

#: src/timber/components/shipment/ShipmentRegulator/CordwoodDetail.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogDetail.tsx
msgid "Move to this shipment"
msgstr "Move to this shipment"

#: src/timber/components/cordwood/CordwoodDetail/CordwoodDetail.tsx
#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx
#: src/timber/components/cordwood/CordwoodForm/CordwoodUpdateForm.tsx
#: src/timber/components/cordwood/CordwoodList/CordwoodListItem.tsx
#: src/timber/components/cordwood/CordwoodList/CordwoodListSearch.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryDetail/CordwoodHistoryDetail.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListItem.tsx
msgid "MU"
msgstr "MU"

#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx
#: src/timber/components/cordwood/CordwoodForm/CordwoodUpdateForm.tsx
msgid "MU is required"
msgstr "MU is required"

#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx
#: src/timber/components/cordwood/CordwoodForm/CordwoodUpdateForm.tsx
#: src/timber/components/log/LogForm/LogAddForm.tsx
#: src/timber/components/log/LogForm/LogUpdateForm.tsx
#: src/timber/components/price/PriceForm/PriceAddForm.tsx
#: src/timber/components/price/PriceForm/PriceUpdateForm.tsx
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassAddForm.tsx
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassUpdateForm.tsx
#: src/timber/components/treeMarking/TreeMarkingForm/TreeMarkingAddForm.tsx
#: src/timber/components/treeMarking/TreeMarkingForm/TreeMarkingUpdateForm.tsx
msgid "must be a number."
msgstr "must be a number."

#: src/pages/DashboardHomePage.tsx
msgid "My provider"
msgstr "My provider"

#: src/auth/components/membersGroup/MembersGroupDetail/MembersGroupDetail.tsx
#: src/auth/components/membersGroup/MembersGroupForm/MembersGroupAddForm.tsx
#: src/auth/components/membersGroup/MembersGroupForm/MembersGroupUpdateForm.tsx
#: src/auth/components/membersGroup/MembersGroupList/MembersGroupListItem.tsx
#: src/auth/components/membersGroup/MembersGroupList/MembersGroupListSearch.tsx
#: src/auth/components/role/RoleDetail/RoleDetail.tsx
#: src/auth/components/role/RoleForm/RoleAddForm.tsx
#: src/auth/components/role/RoleForm/RoleUpdateForm.tsx
#: src/auth/components/role/RoleList/RoleListItem.tsx
#: src/auth/components/role/RoleList/RoleListSearch.tsx
#: src/auth/components/scopeGroup/ScopeGroupDetail/ScopeGroupDetail.tsx
#: src/auth/components/scopeGroup/ScopeGroupForm/ScopeGroupAddForm.tsx
#: src/auth/components/scopeGroup/ScopeGroupForm/ScopeGroupUpdateForm.tsx
#: src/auth/components/scopeGroup/ScopeGroupList/ScopeGroupListItem.tsx
#: src/auth/components/scopeGroup/ScopeGroupList/ScopeGroupListSearch.tsx
#: src/location/components/location/LocationDetail/LocationDetail.tsx
#: src/location/components/location/LocationForm/LocationAddForm.tsx
#: src/location/components/location/LocationForm/LocationUpdateForm.tsx
#: src/location/components/location/LocationList/LocationListSearch.tsx
#: src/timber/components/accountingUser/AccountingUserDetail/AccountingUserDetail.tsx
#: src/timber/components/accountingUser/AccountingUserForm/AccountingUserAddForm.tsx
#: src/timber/components/accountingUser/AccountingUserForm/AccountingUserUpdateForm.tsx
#: src/timber/components/accountingUser/AccountingUserList/AccountingUserListItem.tsx
#: src/timber/components/buyer/BuyerDetail/BuyerDetail.tsx
#: src/timber/components/buyer/BuyerForm/BuyerAddForm.tsx
#: src/timber/components/buyer/BuyerForm/BuyerUpdateForm.tsx
#: src/timber/components/buyer/BuyerList/BuyerListItem.tsx
#: src/timber/components/buyerUser/BuyerUserDetail/BuyerUserDetail.tsx
#: src/timber/components/buyerUser/BuyerUserForm/BuyerUserAddForm.tsx
#: src/timber/components/buyerUser/BuyerUserForm/BuyerUserUpdateForm.tsx
#: src/timber/components/buyerUser/BuyerUserList/BuyerUserListItem.tsx
#: src/timber/components/contractor/ContractorDetail/ContractorDetail.tsx
#: src/timber/components/contractor/ContractorForm/ContractorAddForm.tsx
#: src/timber/components/contractor/ContractorForm/ContractorUpdateForm.tsx
#: src/timber/components/contractor/ContractorList/ContractorListItem.tsx
#: src/timber/components/contractorUser/ContractorUserDetail/ContractorUserDetail.tsx
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserAddForm.tsx
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserUpdateForm.tsx
#: src/timber/components/contractorUser/ContractorUserList/ContractorUserListItem.tsx
#: src/timber/components/cutting/CuttingDetail/CuttingDetail.tsx
#: src/timber/components/cutting/CuttingForm/CuttingAddForm.tsx
#: src/timber/components/cutting/CuttingForm/CuttingUpdateForm.tsx
#: src/timber/components/cutting/CuttingList/CuttingListItem.tsx
#: src/timber/components/cutting/CuttingList/CuttingListSearch.tsx
#: src/timber/components/forestOwner/ForestOwnerDetail/ForestOwnerDetail.tsx
#: src/timber/components/forestOwner/ForestOwnerForm/ForestOwnerAddForm.tsx
#: src/timber/components/forestOwner/ForestOwnerForm/ForestOwnerUpdateForm.tsx
#: src/timber/components/forestOwner/ForestOwnerList/ForestOwnerListItem.tsx
#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx
#: src/timber/components/pricingProfile/PricingProfileDetail/PricingProfileDetail.tsx
#: src/timber/components/pricingProfile/PricingProfileForm/PricingProfileAddForm.tsx
#: src/timber/components/pricingProfile/PricingProfileForm/PricingProfileUpdateForm.tsx
#: src/timber/components/pricingProfile/PricingProfileList/PricingProfileListItem.tsx
#: src/timber/components/provider/ProviderDetail/ProviderDetail.tsx
#: src/timber/components/provider/ProviderDetail/ProviderSplitTab.tsx
#: src/timber/components/provider/ProviderForm/ProviderAddForm.tsx
#: src/timber/components/provider/ProviderForm/ProviderUpdateForm.tsx
#: src/timber/components/provider/ProviderList/ProviderListItem.tsx
#: src/timber/components/providerUser/ProviderUserDetail/ProviderUserDetail.tsx
#: src/timber/components/providerUser/ProviderUserForm/ProviderUserAddForm.tsx
#: src/timber/components/providerUser/ProviderUserForm/ProviderUserUpdateForm.tsx
#: src/timber/components/providerUser/ProviderUserList/ProviderUserListItem.tsx
#: src/timber/components/roadCarrier/RoadCarrierDetail/RoadCarrierDetail.tsx
#: src/timber/components/roadCarrier/RoadCarrierForm/RoadCarrierAddForm.tsx
#: src/timber/components/roadCarrier/RoadCarrierForm/RoadCarrierUpdateForm.tsx
#: src/timber/components/roadCarrier/RoadCarrierList/RoadCarrierListItem.tsx
#: src/timber/components/thicknessClass/ThicknessClassDetail/ThicknessClassDetail.tsx
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassAddForm.tsx
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassUpdateForm.tsx
#: src/timber/components/thicknessClass/ThicknessClassList/ThicknessClassListItem.tsx
#: src/timber/components/timberClass/TimberClassDetail/TimberClassDetail.tsx
#: src/timber/components/timberClass/TimberClassForm/TimberClassAddForm.tsx
#: src/timber/components/timberClass/TimberClassForm/TimberClassUpdateForm.tsx
#: src/timber/components/timberClass/TimberClassList/TimberClassListItem.tsx
#: src/timber/components/timberStorage/TimberStorageDetail/TimberStorageDetail.tsx
#: src/timber/components/timberStorage/TimberStorageForm/TimberStorageAddForm.tsx
#: src/timber/components/timberStorage/TimberStorageForm/TimberStorageUpdateForm.tsx
#: src/timber/components/timberStorage/TimberStorageList/TimberStorageListItem.tsx
#: src/timber/components/timberStorage/TimberStorageList/TimberStorageListSearch.tsx
#: src/timber/components/timberType/TimberTypeDetail/TimberTypeDetail.tsx
#: src/timber/components/timberType/TimberTypeForm/TimberTypeAddForm.tsx
#: src/timber/components/timberType/TimberTypeForm/TimberTypeUpdateForm.tsx
#: src/timber/components/timberType/TimberTypeList/TimberTypeListItem.tsx
msgid "Name"
msgstr "Name"

#: src/auth/components/membersGroup/MembersGroupForm/MembersGroupAddForm.tsx
#: src/auth/components/membersGroup/MembersGroupForm/MembersGroupUpdateForm.tsx
#: src/auth/components/role/RoleForm/RoleAddForm.tsx
#: src/auth/components/role/RoleForm/RoleUpdateForm.tsx
#: src/auth/components/scopeGroup/ScopeGroupForm/ScopeGroupAddForm.tsx
#: src/auth/components/scopeGroup/ScopeGroupForm/ScopeGroupUpdateForm.tsx
#: src/location/components/location/LocationForm/LocationAddForm.tsx
#: src/location/components/location/LocationForm/LocationUpdateForm.tsx
#: src/timber/components/accountingUser/AccountingUserForm/AccountingUserAddForm.tsx
#: src/timber/components/accountingUser/AccountingUserForm/AccountingUserUpdateForm.tsx
#: src/timber/components/buyer/BuyerForm/BuyerAddForm.tsx
#: src/timber/components/buyer/BuyerForm/BuyerUpdateForm.tsx
#: src/timber/components/buyerUser/BuyerUserForm/BuyerUserAddForm.tsx
#: src/timber/components/buyerUser/BuyerUserForm/BuyerUserUpdateForm.tsx
#: src/timber/components/contractor/ContractorForm/ContractorAddForm.tsx
#: src/timber/components/contractor/ContractorForm/ContractorUpdateForm.tsx
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserAddForm.tsx
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserUpdateForm.tsx
#: src/timber/components/cutting/CuttingForm/CuttingAddForm.tsx
#: src/timber/components/cutting/CuttingForm/CuttingUpdateForm.tsx
#: src/timber/components/forestOwner/ForestOwnerForm/ForestOwnerAddForm.tsx
#: src/timber/components/forestOwner/ForestOwnerForm/ForestOwnerUpdateForm.tsx
#: src/timber/components/pricingProfile/PricingProfileForm/PricingProfileAddForm.tsx
#: src/timber/components/pricingProfile/PricingProfileForm/PricingProfileUpdateForm.tsx
#: src/timber/components/provider/ProviderForm/ProviderAddForm.tsx
#: src/timber/components/provider/ProviderForm/ProviderUpdateForm.tsx
#: src/timber/components/providerUser/ProviderUserForm/ProviderUserAddForm.tsx
#: src/timber/components/providerUser/ProviderUserForm/ProviderUserUpdateForm.tsx
#: src/timber/components/roadCarrier/RoadCarrierForm/RoadCarrierAddForm.tsx
#: src/timber/components/roadCarrier/RoadCarrierForm/RoadCarrierUpdateForm.tsx
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassAddForm.tsx
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassUpdateForm.tsx
#: src/timber/components/timberClass/TimberClassForm/TimberClassAddForm.tsx
#: src/timber/components/timberClass/TimberClassForm/TimberClassUpdateForm.tsx
#: src/timber/components/timberStorage/TimberStorageForm/TimberStorageAddForm.tsx
#: src/timber/components/timberStorage/TimberStorageForm/TimberStorageUpdateForm.tsx
#: src/timber/components/timberType/TimberTypeForm/TimberTypeAddForm.tsx
#: src/timber/components/timberType/TimberTypeForm/TimberTypeUpdateForm.tsx
msgid "Name is required"
msgstr "Name is required"

#: src/share/components/chat/ChatHeader.tsx
msgid "Narrow chat"
msgstr "Narrow chat"

#: src/timber/components/provider/ProviderDetail/ProviderAttentionList.tsx
msgid "Needs attention"
msgstr "Needs attention"

#: src/share/components/chat/ChatHeader.tsx
#: src/share/components/chat/ConversationList.tsx
msgid "New conversation"
msgstr "New conversation"

#: src/pages/ChangePasswordPage.tsx
msgid "New Password"
msgstr "New Password"

#: src/pages/ChangePasswordPage.tsx
msgid "New password is required"
msgstr "New password is required"

#: src/pages/ChangePasswordPage.tsx
msgid "New password must be more than 8 characters"
msgstr "New password must be more than 8 characters"

#: src/share/components/chat/ChatToolView.tsx
msgid "no"
msgstr "no"

#: src/timber/components/history/HistoryList/HistoryListItemRow.tsx
#: src/timber/components/shipment/ShipmentRegulator/CordwoodListItemForShipment.tsx
#: src/timber/components/shipment/ShipmentRegulator/CordwoodListItemFromHistory.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogListItemForShipment.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogListItemFromHistory.tsx
msgid "No"
msgstr "No"

#: src/timber/components/accountingUser/AccountingUserList/AccountingUserListItem.tsx
msgid "No Accounting Users"
msgstr "No Accounting Users"

#: src/address/components/address/AddressList/AddressListItem.tsx
msgid "No Addresses"
msgstr "No Addresses"

#: src/timber/components/buyerUser/BuyerUserList/BuyerUserListItem.tsx
msgid "No Buyer Users"
msgstr "No Buyer Users"

#: src/timber/components/buyer/BuyerList/BuyerListItem.tsx
msgid "No Buyers"
msgstr "No Buyers"

#: src/timber/components/contractorUser/ContractorUserList/ContractorUserListItem.tsx
msgid "No Contractor Users"
msgstr "No Contractor Users"

#: src/timber/components/contractor/ContractorList/ContractorListItem.tsx
msgid "No Contractors"
msgstr "No Contractors"

#: src/share/components/chat/ConversationList.tsx
msgid "No conversations match \"{search}\""
msgstr "No conversations match \"{search}\""

#: src/share/components/chat/ConversationList.tsx
msgid "No conversations yet"
msgstr "No conversations yet"

#: src/timber/components/cutting/CuttingList/ActiveCuttings.tsx
msgid "No cordwood data"
msgstr "No cordwood data"

#: src/timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListItem.tsx
msgid "No Cordwood Histories"
msgstr "No Cordwood Histories"

#: src/timber/components/cordwood/CordwoodList/CordwoodListItem.tsx
msgid "No Cordwoods"
msgstr "No Cordwoods"

#: src/timber/components/cutting/CuttingList/CuttingListItem.tsx
msgid "No Cuttings"
msgstr "No Cuttings"

#: src/timber/components/cutting/CuttingList/ActiveCuttings.tsx
#: src/timber/components/generic/report/ParetoChart.tsx
msgid "No data"
msgstr "No data"

#: src/timber/components/driver/DriverList/DriverListItem.tsx
#~ msgid "No Drivers"
#~ msgstr "No Drivers"

#: src/timber/components/forestOwner/ForestOwnerList/ForestOwnerListItem.tsx
msgid "No Forest Owners"
msgstr "No Forest Owners"

#: src/timber/components/history/HistoryList/HistoryListItem.tsx
msgid "No history records found"
msgstr "No history records found"

#: src/location/components/location/LocationList/LocationListItem.tsx
msgid "No Locations"
msgstr "No Locations"

#: src/timber/components/logHistory/LogHistoryList/LogHistoryListItem.tsx
msgid "No Log Histories"
msgstr "No Log Histories"

#: src/timber/components/log/LogList/LogListItem.tsx
msgid "No Logs"
msgstr "No Logs"

#: src/timber/components/cutting/CuttingList/ActiveCuttings.tsx
msgid "No logs data"
msgstr "No logs data"

#: src/auth/components/membersGroupUser/MembersGroupUserList/MembersGroupUserListItem.tsx
msgid "No Members Group Users"
msgstr "No Members Group Users"

#: src/auth/components/membersGroup/MembersGroupList/MembersGroupListItem.tsx
msgid "No Members Groups"
msgstr "No Members Groups"

#: src/timber/components/price/PriceList/PriceListItem.tsx
msgid "No Prices"
msgstr "No Prices"

#: src/timber/components/pricingProfile/PricingProfileList/PricingProfileListItem.tsx
msgid "No Pricing Profiles"
msgstr "No Pricing Profiles"

#: src/timber/components/providerUser/ProviderUserList/ProviderUserListItem.tsx
msgid "No Provider Users"
msgstr "No Provider Users"

#: src/timber/components/provider/ProviderList/ProviderListItem.tsx
msgid "No Providers"
msgstr "No Providers"

#: src/timber/components/roadCarrier/RoadCarrierList/RoadCarrierListItem.tsx
msgid "No Road Carriers"
msgstr "No Road Carriers"

#: src/auth/components/roleAssignment/RoleAssignmentList/RoleAssignmentListItem.tsx
msgid "No Role Assignments"
msgstr "No Role Assignments"

#: src/auth/components/rolePermission/RolePermissionList/RolePermissionListItem.tsx
msgid "No Role Permissions"
msgstr "No Role Permissions"

#: src/auth/components/role/RoleList/RoleListItem.tsx
msgid "No Roles"
msgstr "No Roles"

#: src/auth/components/scopeGroup/ScopeGroupList/ScopeGroupListItem.tsx
msgid "No Scope Groups"
msgstr "No Scope Groups"

#: src/timber/components/shipmentHistory/ShipmentHistoryList/ShipmentHistoryListItem.tsx
msgid "No Shipment Histories"
msgstr "No Shipment Histories"

#: src/timber/components/shipment/ShipmentList/ShipmentListItem.tsx
msgid "No Shipments"
msgstr "No Shipments"

#: src/timber/components/generic/report/GenericRootShipments.tsx
msgid "No shipments found"
msgstr "No shipments found"

#: src/timber/components/thicknessClass/ThicknessClassList/ThicknessClassListItem.tsx
msgid "No Thickness Classes"
msgstr "No Thickness Classes"

#: src/timber/components/timberClass/TimberClassList/TimberClassListItem.tsx
msgid "No Timber Classes"
msgstr "No Timber Classes"

#. placeholder {0}: item.ageDays
#: src/timber/components/provider/ProviderDetail/ProviderAttentionList.tsx
msgid "No timber has gone in for {0} days and the cutting was due before that."
msgstr "No timber has gone in for {0} days and the cutting was due before that."

#. placeholder {0}: item.ageDays
#: src/timber/components/provider/ProviderDetail/ProviderAttentionList.tsx
msgid "No timber has gone in for {0} days."
msgstr "No timber has gone in for {0} days."

#: src/timber/components/timberStorage/TimberStorageList/TimberStorageListItem.tsx
msgid "No Timber Storages"
msgstr "No Timber Storages"

#: src/timber/components/timberType/TimberTypeList/TimberTypeListItem.tsx
msgid "No Timber Types"
msgstr "No Timber Types"

#: src/timber/components/treeMarking/TreeMarkingList/TreeMarkingListItem.tsx
msgid "No Tree Markings"
msgstr "No Tree Markings"

#: src/address/components/userAddress/UserAddressList/UserAddressListItem.tsx
msgid "No User Addresses"
msgstr "No User Addresses"

#: src/auth/components/userSession/UserSessionList/UserSessionListItem.tsx
msgid "No User Sessions"
msgstr "No User Sessions"

#: src/auth/components/user/UserList/UserListItem.tsx
msgid "No Users"
msgstr "No Users"

#: src/timber/types/models/UserType.d.ts
msgid "Normal"
msgstr "Normal"

#: src/pages/NotFoundPage.tsx
msgid "Not Found"
msgstr "Not Found"

#: src/pages/NotFoundPage.tsx
msgid "Not Found Page"
msgstr "Not Found Page"

#: src/timber/components/provider/ProviderDetail/ProviderSummaryCards.tsx
msgid "not shipped yet"
msgstr "not shipped yet"

#: src/location/components/location/LocationDetail/LocationDetail.tsx
#: src/location/components/location/LocationForm/LocationAddForm.tsx
#: src/location/components/location/LocationForm/LocationUpdateForm.tsx
msgid "Note"
msgstr "Note"

#: src/timber/types/models/CordwoodMeasurementType.d.ts
msgid "npm"
msgstr "npm"

#: src/timber/components/generic/report/GenericRootReportPdfDialog.tsx
#: src/timber/components/shipment/ShipmentRegulator/CordwoodListPdfDialog.tsx
#: src/timber/components/shipment/ShipmentRegulator/CordwoodShipmentReportPdfDialog.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogListPdfDialog.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogShipmentReportPdfDialog.tsx
msgid "Number of copies"
msgstr "Number of copies"

#: src/timber/components/provider/ProviderDetail/ProviderSummaryCards.tsx
msgid "of {totalCuttings} total"
msgstr "of {totalCuttings} total"

#: src/timber/components/provider/ProviderDetail/ProviderSummaryCards.tsx
msgid "of the produced volume"
msgstr "of the produced volume"

#: src/share/components/dialog/PasswordDialog/PasswordDialog.tsx
#~ msgid "Ok"
#~ msgstr "Ok"

#: src/share/components/dialog/PasswordDialog/PasswordDialog.tsx
#: src/share/components/form/FormDateTime/FormDate.tsx
#: src/share/components/form/FormDateTime/FormDateTime.tsx
msgid "OK"
msgstr "OK"

#: src/pages/ChangePasswordPage.tsx
msgid "Old Password"
msgstr "Old Password"

#: src/pages/ChangePasswordPage.tsx
msgid "Old password is required"
msgstr "Old password is required"

#: src/pages/ChangePasswordPage.tsx
msgid "Old password must be more than 8 characters"
msgstr "Old password must be more than 8 characters"

#: src/share/components/chat/ConversationList.tsx
msgid "Older"
msgstr "Older"

#: src/share/components/chat/ChatWidget.tsx
msgid "Open AI chat"
msgstr "Open AI chat"

#: src/app/App.tsx
msgid "Open settings"
msgstr "Open settings"

#: src/timber/components/provider/ProviderDetail/ProviderAttentionList.tsx
msgid "Overdue"
msgstr "Overdue"

#: src/timber/components/provider/ProviderDetail/ProviderTabs.tsx
msgid "Overview"
msgstr "Overview"

#: src/auth/components/membersGroupUser/MembersGroupUserForm/MembersGroupUserAddForm.tsx
#~ msgid "Owned Members Group Id is required"
#~ msgstr "Owned Members Group Id is required"

#: src/auth/components/membersGroupUser/MembersGroupUserForm/MembersGroupUserAddForm.tsx
msgid "Owner Member Group"
msgstr "Owner Member Group"

#: src/auth/components/membersGroupUser/MembersGroupUserForm/MembersGroupUserAddForm.tsx
msgid "Owner Member Group is required"
msgstr "Owner Member Group is required"

#: src/auth/components/membersGroup/MembersGroupForm/MembersGroupAddForm.tsx
#: src/location/components/location/LocationForm/LocationAddForm.tsx
msgid "Parent"
msgstr "Parent"

#: src/auth/components/membersGroup/MembersGroupForm/MembersGroupAddForm.tsx
#: src/location/components/location/LocationForm/LocationAddForm.tsx
#~ msgid "Parent Id is required"
#~ msgstr "Parent Id is required"

#: src/auth/components/membersGroup/MembersGroupForm/MembersGroupAddForm.tsx
#: src/location/components/location/LocationForm/LocationAddForm.tsx
msgid "Parent is required"
msgstr "Parent is required"

#: src/auth/components/scopeGroup/ScopeGroupForm/ScopeGroupAddForm.tsx
msgid "Parent Scope Group"
msgstr "Parent Scope Group"

#: src/auth/components/scopeGroup/ScopeGroupForm/ScopeGroupAddForm.tsx
#~ msgid "Parent Scope Group Id is required"
#~ msgstr "Parent Scope Group Id is required"

#: src/auth/components/scopeGroup/ScopeGroupForm/ScopeGroupAddForm.tsx
msgid "Parent Scope Group is required"
msgstr "Parent Scope Group is required"

#: src/pages/LoginPage.tsx
#: src/pages/ResetPasswordPage.tsx
msgid "Password"
msgstr "Password"

#: src/pages/LoginPage.tsx
#: src/pages/ResetPasswordPage.tsx
msgid "Password is required"
msgstr "Password is required"

#: src/pages/LoginPage.tsx
msgid "Password must be less than 32 characters"
msgstr "Password must be less than 32 characters"

#: src/pages/LoginPage.tsx
#: src/pages/ResetPasswordPage.tsx
msgid "Password must be more than 8 characters"
msgstr "Password must be more than 8 characters"

#: src/pages/ChangePasswordPage.tsx
#: src/pages/ResetPasswordPage.tsx
msgid "Password updated successfully, login"
msgstr "Password updated successfully, login"

#: src/pages/ChangePasswordPage.tsx
#: src/pages/ResetPasswordPage.tsx
msgid "Passwords do not match"
msgstr "Passwords do not match"

#: src/auth/components/rolePermission/RolePermissionDetail/RolePermissionDetail.tsx
#: src/auth/components/rolePermission/RolePermissionForm/RolePermissionAddForm.tsx
#: src/auth/components/rolePermission/RolePermissionList/RolePermissionListItem.tsx
#: src/auth/components/rolePermission/RolePermissionList/RolePermissionListSearch.tsx
msgid "Permission"
msgstr "Permission"

#: src/auth/components/rolePermission/RolePermissionForm/RolePermissionAddForm.tsx
msgid "Permission is required"
msgstr "Permission is required"

#: src/address/components/address/AddressDetail/AddressDetail.tsx
#: src/address/components/address/AddressForm/AddressAddForm.tsx
#: src/address/components/address/AddressForm/AddressUpdateForm.tsx
#: src/address/components/address/AddressList/AddressListItem.tsx
msgid "Phone"
msgstr "Phone"

#: src/timber/components/provider/ProviderDetail/ProviderSummaryCards.tsx
msgid "pieces"
msgstr "pieces"

#: src/share/components/dialog/DeleteDialog/DeleteDialog.tsx
#: src/share/components/dialog/PasswordDialog/PasswordDialog.tsx
msgid "Please confirm delete of the entity."
msgstr "Please confirm delete of the entity."

#: src/pages/ResetPasswordPage.tsx
msgid "Please confirm your password"
msgstr "Please confirm your password"

#: src/pages/ActivationPage.tsx
msgid "Please enter a activation ocode"
msgstr "Please enter a activation ocode"

#: src/pages/ChangePasswordPage.tsx
#: src/pages/ResetPasswordPage.tsx
msgid "Please enter a new password"
msgstr "Please enter a new password"

#: src/app/App.tsx
#: src/pages/PreferencesPage.tsx
msgid "Preferences"
msgstr "Preferences"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx
#: src/timber/components/price/PriceDetail/PriceDetail.tsx
#: src/timber/components/price/PriceForm/PriceAddForm.tsx
#: src/timber/components/price/PriceForm/PriceUpdateForm.tsx
#: src/timber/components/price/PriceList/PriceListItem.tsx
#: src/timber/pages/price/PriceEntityPage.tsx
msgid "Price"
msgstr "Price"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx
msgid "Price [Original: {originalValue}]"
msgstr "Price [Original: {originalValue}]"

#: src/timber/hooks/usePrice.ts
msgid "Price add error: "
msgstr "Price add error: "

#: src/timber/components/buyer/BuyerDetail/BuyerTabs.tsx
#: src/timber/components/cutting/CuttingDetail/CuttingTabs.tsx
#: src/timber/components/forestOwner/ForestOwnerDetail/ForestOwnerTabs.tsx
#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx
#: src/timber/components/provider/ProviderDetail/ProviderTabs.tsx
#: src/timber/components/shipment/ShipmentDetail/ShipmentTabs.tsx
#: src/timber/components/timberStorage/TimberStorageDetail/TimberStorageTabs.tsx
msgid "Price Calculator"
msgstr "Price Calculator"

#: src/timber/hooks/usePrice.ts
msgid "Price delete error: "
msgstr "Price delete error: "

#: src/timber/hooks/usePrice.ts
msgid "Price deleted"
msgstr "Price deleted"

#: src/timber/hooks/usePrice.ts
msgid "Price update error: "
msgstr "Price update error: "

#: src/timber/hooks/usePrice.ts
msgid "Price updated"
msgstr "Price updated"

#: src/app/mappers.tsx
#: src/timber/components/price/PriceList/PriceListHeader.tsx
#: src/timber/components/pricingProfile/PricingProfileDetail/PricingProfileTabs.tsx
msgid "Prices"
msgstr "Prices"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx
#: src/timber/components/price/PriceDetail/PriceDetail.tsx
#: src/timber/components/price/PriceForm/PriceAddForm.tsx
#: src/timber/components/pricingProfile/PricingProfileDetail/PricingProfileDetail.tsx
#: src/timber/pages/pricingProfile/PricingProfileEntityPage.tsx
msgid "Pricing Profile"
msgstr "Pricing Profile"

#: src/timber/hooks/usePricingProfile.ts
msgid "Pricing Profile add error: "
msgstr "Pricing Profile add error: "

#: src/timber/hooks/usePricingProfile.ts
msgid "Pricing Profile delete error: "
msgstr "Pricing Profile delete error: "

#: src/timber/hooks/usePricingProfile.ts
msgid "Pricing Profile deleted"
msgstr "Pricing Profile deleted"

#: src/timber/components/price/PriceForm/PriceAddForm.tsx
#~ msgid "Pricing Profile Id is required"
#~ msgstr "Pricing Profile Id is required"

#: src/timber/components/price/PriceForm/PriceAddForm.tsx
msgid "Pricing Profile is required"
msgstr "Pricing Profile is required"

#: src/timber/hooks/usePricingProfile.ts
msgid "Pricing Profile update error: "
msgstr "Pricing Profile update error: "

#: src/timber/hooks/usePricingProfile.ts
msgid "Pricing Profile updated"
msgstr "Pricing Profile updated"

#: src/app/mappers.tsx
#: src/timber/components/pricingProfile/PricingProfileList/PricingProfileListHeader.tsx
#: src/timber/pages/listItems.tsx
msgid "Pricing Profiles"
msgstr "Pricing Profiles"

#: src/app/App.tsx
#: src/pages/LoginPage.tsx
#: src/pages/PrivacyPolicyPage.tsx
#: src/pages/TermsPage.tsx
#: src/share/components/gdpr/CookieConsent.tsx
msgid "Privacy Policy"
msgstr "Privacy Policy"

#: src/timber/types/models/CordwoodMeasurementType.d.ts
msgid "prm"
msgstr "prm"

#: src/app/App.tsx
#: src/pages/ProfilePage.tsx
msgid "Profile"
msgstr "Profile"

#: src/pages/ProfilePage.tsx
msgid "Profile Page"
msgstr "Profile Page"

#: src/timber/components/cutting/CuttingDetail/CuttingDetail.tsx
#: src/timber/components/cutting/CuttingForm/CuttingAddForm.tsx
#: src/timber/components/provider/ProviderDetail/ProviderDetail.tsx
#: src/timber/components/providerUser/ProviderUserDetail/ProviderUserDetail.tsx
#: src/timber/components/providerUser/ProviderUserForm/ProviderUserAddForm.tsx
#: src/timber/pages/listItems.tsx
#: src/timber/pages/provider/ProviderEntityPage.tsx
msgid "Provider"
msgstr "Provider"

#: src/timber/hooks/useProvider.ts
msgid "Provider add error: "
msgstr "Provider add error: "

#: src/timber/hooks/useProvider.ts
msgid "Provider delete error: "
msgstr "Provider delete error: "

#: src/timber/hooks/useProvider.ts
msgid "Provider deleted"
msgstr "Provider deleted"

#: src/timber/components/cutting/CuttingForm/CuttingAddForm.tsx
#: src/timber/components/providerUser/ProviderUserForm/ProviderUserAddForm.tsx
#~ msgid "Provider Id is required"
#~ msgstr "Provider Id is required"

#: src/timber/components/cutting/CuttingForm/CuttingAddForm.tsx
#: src/timber/components/providerUser/ProviderUserForm/ProviderUserAddForm.tsx
msgid "Provider is required"
msgstr "Provider is required"

#: src/timber/hooks/useProvider.ts
msgid "Provider update error: "
msgstr "Provider update error: "

#: src/timber/hooks/useProvider.ts
msgid "Provider updated"
msgstr "Provider updated"

#: src/timber/components/providerUser/ProviderUserDetail/ProviderUserDetail.tsx
#: src/timber/pages/providerUser/ProviderUserEntityPage.tsx
msgid "Provider User"
msgstr "Provider User"

#: src/timber/hooks/useProviderUser.ts
msgid "Provider User add error: "
msgstr "Provider User add error: "

#: src/timber/hooks/useProviderUser.ts
msgid "Provider User delete error: "
msgstr "Provider User delete error: "

#: src/timber/hooks/useProviderUser.ts
msgid "Provider User deleted"
msgstr "Provider User deleted"

#: src/timber/hooks/useProviderUser.ts
msgid "Provider User update error: "
msgstr "Provider User update error: "

#: src/timber/hooks/useProviderUser.ts
msgid "Provider User updated"
msgstr "Provider User updated"

#: src/app/mappers.tsx
#: src/auth/components/user/UserDetail/UserTabs.tsx
#: src/timber/components/provider/ProviderDetail/ProviderTabs.tsx
#: src/timber/components/providerUser/ProviderUserList/ProviderUserListHeader.tsx
msgid "Provider Users"
msgstr "Provider Users"

#: src/app/mappers.tsx
#: src/timber/components/provider/ProviderList/ProviderListHeader.tsx
#: src/timber/pages/listItems.tsx
msgid "Providers"
msgstr "Providers"

#: src/share/components/form/FormDateTime/FormDateRange.tsx
msgid "Quick Select"
msgstr "Quick Select"

#: src/share/components/chat/serverErrors.ts
msgid "Rate limit exceeded. Please wait before sending more messages."
msgstr "Rate limit exceeded. Please wait before sending more messages."

#: src/auth/components/membersGroup/MembersGroupList/MembersGroupListSearch.tsx
#: src/auth/components/membersGroupUser/MembersGroupUserList/MembersGroupUserListSearch.tsx
#: src/auth/components/role/RoleList/RoleListSearch.tsx
#: src/auth/components/roleAssignment/RoleAssignmentList/RoleAssignmentListSearch.tsx
#: src/auth/components/rolePermission/RolePermissionList/RolePermissionListSearch.tsx
#: src/auth/components/scopeGroup/ScopeGroupList/ScopeGroupListSearch.tsx
#: src/location/components/location/LocationList/LocationListSearch.tsx
#: src/timber/components/cordwood/CordwoodList/CordwoodListSearch.tsx
#: src/timber/components/cutting/CuttingList/CuttingListSearch.tsx
#: src/timber/components/log/LogList/LogListSearch.tsx
#: src/timber/components/price/PriceList/PriceListSearch.tsx
#: src/timber/components/shipment/ShipmentList/ShipmentListSearch.tsx
#: src/timber/components/timberStorage/TimberStorageList/TimberStorageListSearch.tsx
#: src/timber/components/treeMarking/TreeMarkingList/TreeMarkingListSearch.tsx
msgid "Refresh"
msgstr "Refresh"

#: src/auth/components/userSession/UserSessionForm/UserSessionAddForm.tsx
#: src/auth/components/userSession/UserSessionForm/UserSessionUpdateForm.tsx
msgid "Refresh Token"
msgstr "Refresh Token"

#: src/auth/components/userSession/UserSessionForm/UserSessionAddForm.tsx
#: src/auth/components/userSession/UserSessionForm/UserSessionUpdateForm.tsx
msgid "Refresh Token is required"
msgstr "Refresh Token is required"

#: src/share/components/chat/ChatMessage.tsx
msgid "Regenerate reply"
msgstr "Regenerate reply"

#: src/timber/components/shipment/ShipmentRegulator/CordwoodDetail.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogDetail.tsx
msgid "Remove from this shipment"
msgstr "Remove from this shipment"

#: src/timber/components/buyer/BuyerDetail/BuyerTabs.tsx
#: src/timber/components/shipment/ShipmentDetail/ShipmentTabs.tsx
msgid "Report"
msgstr "Report"

#: src/timber/components/contractor/ContractorDetail/ContractorTabs.tsx
#: src/timber/components/cutting/CuttingDetail/CuttingTabs.tsx
#: src/timber/components/forestOwner/ForestOwnerDetail/ForestOwnerTabs.tsx
#: src/timber/components/provider/ProviderDetail/ProviderTabs.tsx
#: src/timber/components/timberStorage/TimberStorageDetail/TimberStorageTabs.tsx
msgid "Report All"
msgstr "Report All"

#: src/timber/components/generic/report/GenericRootShipments.tsx
#: src/timber/components/history/HistoryList/HistoryListItemRow.tsx
#: src/timber/components/shipment/ShipmentDetail/ShipmentDetail.tsx
#: src/timber/components/shipment/ShipmentList/ShipmentListItem.tsx
#: src/timber/components/shipment/ShipmentList/ShipmentListSearch.tsx
msgid "Report Key"
msgstr "Report Key"

#: src/timber/components/thicknessClass/ThicknessClassDetail/ThicknessClassDetail.tsx
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassAddForm.tsx
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassUpdateForm.tsx
#: src/timber/components/timberClass/TimberClassDetail/TimberClassDetail.tsx
#: src/timber/components/timberClass/TimberClassForm/TimberClassAddForm.tsx
#: src/timber/components/timberClass/TimberClassForm/TimberClassUpdateForm.tsx
#: src/timber/components/timberType/TimberTypeDetail/TimberTypeDetail.tsx
#: src/timber/components/timberType/TimberTypeForm/TimberTypeAddForm.tsx
#: src/timber/components/timberType/TimberTypeForm/TimberTypeUpdateForm.tsx
msgid "Report Name Long"
msgstr "Report Name Long"

#: src/timber/components/thicknessClass/ThicknessClassDetail/ThicknessClassDetail.tsx
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassAddForm.tsx
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassUpdateForm.tsx
#: src/timber/components/timberClass/TimberClassDetail/TimberClassDetail.tsx
#: src/timber/components/timberClass/TimberClassForm/TimberClassAddForm.tsx
#: src/timber/components/timberClass/TimberClassForm/TimberClassUpdateForm.tsx
#: src/timber/components/timberType/TimberTypeDetail/TimberTypeDetail.tsx
#: src/timber/components/timberType/TimberTypeForm/TimberTypeAddForm.tsx
#: src/timber/components/timberType/TimberTypeForm/TimberTypeUpdateForm.tsx
msgid "Report Name Short"
msgstr "Report Name Short"

#: src/timber/components/contractor/ContractorDetail/ContractorTabs.tsx
#: src/timber/components/cutting/CuttingDetail/CuttingTabs.tsx
#: src/timber/components/forestOwner/ForestOwnerDetail/ForestOwnerTabs.tsx
#: src/timber/components/provider/ProviderDetail/ProviderTabs.tsx
#: src/timber/components/timberStorage/TimberStorageDetail/TimberStorageTabs.tsx
msgid "Report Not shipt"
msgstr "Report Not shipt"

#: src/timber/components/contractor/ContractorDetail/ContractorTabs.tsx
#: src/timber/components/cutting/CuttingDetail/CuttingTabs.tsx
#: src/timber/components/forestOwner/ForestOwnerDetail/ForestOwnerTabs.tsx
#: src/timber/components/provider/ProviderDetail/ProviderTabs.tsx
#: src/timber/components/timberStorage/TimberStorageDetail/TimberStorageTabs.tsx
msgid "Report Shipt"
msgstr "Report Shipt"

#: src/timber/components/generic/treeMarkings/ReportTreeMarkings.tsx
msgid "Report TreeMarkings"
msgstr "Report TreeMarkings"

#: src/app/App.tsx
#: src/pages/listItems.tsx
#: src/pages/ReportsPage.tsx
msgid "Reports"
msgstr "Reports"

#: src/share/components/gdpr/CookieConsent.tsx
msgid "Reset"
msgstr "Reset"

#: src/auth/pages/scopeGroup/ScopeGroupDetailPage.tsx
msgid "Reset Assign"
msgstr "Reset Assign"

#: src/pages/ResetPasswordPage.tsx
msgid "Reset Password"
msgstr "Reset Password"

#: src/pages/ForgotPasswordPage.tsx
msgid "Retrieve Password"
msgstr "Retrieve Password"

#: src/timber/components/roadCarrier/RoadCarrierDetail/RoadCarrierDetail.tsx
#: src/timber/components/shipment/ShipmentDetail/ShipmentDetail.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx
#: src/timber/pages/roadCarrier/RoadCarrierEntityPage.tsx
msgid "Road Carrier"
msgstr "Road Carrier"

#: src/timber/hooks/useRoadCarrier.ts
msgid "Road Carrier add error: "
msgstr "Road Carrier add error: "

#: src/timber/hooks/useRoadCarrier.ts
msgid "Road Carrier delete error: "
msgstr "Road Carrier delete error: "

#: src/timber/hooks/useRoadCarrier.ts
msgid "Road Carrier deleted"
msgstr "Road Carrier deleted"

#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx
#~ msgid "Road Carrier Id is required"
#~ msgstr "Road Carrier Id is required"

#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx
msgid "Road Carrier is required"
msgstr "Road Carrier is required"

#: src/timber/hooks/useRoadCarrier.ts
msgid "Road Carrier update error: "
msgstr "Road Carrier update error: "

#: src/timber/hooks/useRoadCarrier.ts
msgid "Road Carrier updated"
msgstr "Road Carrier updated"

#: src/app/mappers.tsx
#: src/timber/components/roadCarrier/RoadCarrierList/RoadCarrierListHeader.tsx
#: src/timber/pages/listItems.tsx
msgid "Road Carriers"
msgstr "Road Carriers"

#: src/auth/components/role/RoleDetail/RoleDetail.tsx
#: src/auth/components/roleAssignment/RoleAssignmentDetail/RoleAssignmentDetail.tsx
#: src/auth/components/roleAssignment/RoleAssignmentForm/RoleAssignmentAddForm.tsx
#: src/auth/components/roleAssignment/RoleAssignmentList/RoleAssignmentListItem.tsx
#: src/auth/components/roleAssignment/RoleAssignmentList/RoleAssignmentListSearch.tsx
#: src/auth/components/rolePermission/RolePermissionDetail/RolePermissionDetail.tsx
#: src/auth/components/rolePermission/RolePermissionForm/RolePermissionAddForm.tsx
#: src/auth/components/rolePermission/RolePermissionList/RolePermissionListItem.tsx
#: src/auth/components/rolePermission/RolePermissionList/RolePermissionListSearch.tsx
#: src/auth/pages/role/RoleEntityPage.tsx
msgid "Role"
msgstr "Role"

#: src/auth/hooks/useRole.ts
msgid "Role add error: "
msgstr "Role add error: "

#: src/auth/components/roleAssignment/RoleAssignmentDetail/RoleAssignmentDetail.tsx
#: src/auth/pages/roleAssignment/RoleAssignmentEntityPage.tsx
msgid "Role Assignment"
msgstr "Role Assignment"

#: src/auth/hooks/useRoleAssignment.ts
msgid "Role Assignment add error: "
msgstr "Role Assignment add error: "

#: src/auth/hooks/useRoleAssignment.ts
msgid "Role Assignment delete error: "
msgstr "Role Assignment delete error: "

#: src/auth/hooks/useRoleAssignment.ts
msgid "Role Assignment deleted"
msgstr "Role Assignment deleted"

#: src/app/mappers.tsx
#: src/auth/components/membersGroup/MembersGroupDetail/MembersGroupTabs.tsx
#: src/auth/components/role/RoleDetail/RoleTabs.tsx
#: src/auth/components/roleAssignment/RoleAssignmentList/RoleAssignmentListHeader.tsx
#: src/auth/components/scopeGroup/ScopeGroupDetail/ScopeGroupTabs.tsx
msgid "Role Assignments"
msgstr "Role Assignments"

#: src/auth/hooks/useRole.ts
msgid "Role delete error: "
msgstr "Role delete error: "

#: src/auth/hooks/useRole.ts
msgid "Role deleted"
msgstr "Role deleted"

#: src/auth/components/roleAssignment/RoleAssignmentForm/RoleAssignmentAddForm.tsx
#: src/auth/components/rolePermission/RolePermissionForm/RolePermissionAddForm.tsx
#~ msgid "Role Id is required"
#~ msgstr "Role Id is required"

#: src/auth/components/roleAssignment/RoleAssignmentForm/RoleAssignmentAddForm.tsx
#: src/auth/components/rolePermission/RolePermissionForm/RolePermissionAddForm.tsx
msgid "Role is required"
msgstr "Role is required"

#: src/auth/components/rolePermission/RolePermissionDetail/RolePermissionDetail.tsx
#: src/auth/pages/rolePermission/RolePermissionEntityPage.tsx
msgid "Role Permission"
msgstr "Role Permission"

#: src/auth/hooks/useRolePermission.ts
msgid "Role Permission add error: "
msgstr "Role Permission add error: "

#: src/auth/hooks/useRolePermission.ts
msgid "Role Permission delete error: "
msgstr "Role Permission delete error: "

#: src/auth/hooks/useRolePermission.ts
msgid "Role Permission deleted"
msgstr "Role Permission deleted"

#: src/app/mappers.tsx
#: src/auth/components/role/RoleDetail/RoleTabs.tsx
#: src/auth/components/rolePermission/RolePermissionList/RolePermissionListHeader.tsx
msgid "Role Permissions"
msgstr "Role Permissions"

#: src/auth/hooks/useRole.ts
msgid "Role update error: "
msgstr "Role update error: "

#: src/auth/hooks/useRole.ts
msgid "Role updated"
msgstr "Role updated"

#: src/app/mappers.tsx
#: src/auth/components/membersGroup/MembersGroupDetail/MembersGroupTabs.tsx
#: src/auth/components/role/RoleList/RoleListHeader.tsx
#: src/auth/pages/listItems.tsx
msgid "Roles"
msgstr "Roles"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx
msgid "Row Total"
msgstr "Row Total"

#: src/share/components/chat/ChatToolView.tsx
msgid "row(s)"
msgstr "row(s)"

#: src/address/components/address/AddressList/AddressListPagination.tsx
#: src/address/components/userAddress/UserAddressList/UserAddressListPagination.tsx
#: src/auth/components/membersGroup/MembersGroupList/MembersGroupListPagination.tsx
#: src/auth/components/membersGroupUser/MembersGroupUserList/MembersGroupUserListPagination.tsx
#: src/auth/components/role/RoleList/RoleListPagination.tsx
#: src/auth/components/roleAssignment/RoleAssignmentList/RoleAssignmentListPagination.tsx
#: src/auth/components/rolePermission/RolePermissionList/RolePermissionListPagination.tsx
#: src/auth/components/scopeGroup/ScopeGroupList/ScopeGroupListPagination.tsx
#: src/auth/components/user/UserList/UserListPagination.tsx
#: src/auth/components/userSession/UserSessionList/UserSessionListPagination.tsx
#: src/location/components/location/LocationList/LocationListPagination.tsx
#: src/timber/components/accountingUser/AccountingUserList/AccountingUserListPagination.tsx
#: src/timber/components/buyer/BuyerList/BuyerListPagination.tsx
#: src/timber/components/buyerUser/BuyerUserList/BuyerUserListPagination.tsx
#: src/timber/components/contractor/ContractorList/ContractorListPagination.tsx
#: src/timber/components/contractorUser/ContractorUserList/ContractorUserListPagination.tsx
#: src/timber/components/cordwood/CordwoodList/CordwoodListPagination.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListPagination.tsx
#: src/timber/components/cutting/CuttingList/CuttingListPagination.tsx
#: src/timber/components/forestOwner/ForestOwnerList/ForestOwnerListPagination.tsx
#: src/timber/components/generic/report/GenericRootShipments.tsx
#: src/timber/components/history/HistoryList/HistoryListPagination.tsx
#: src/timber/components/log/LogList/LogListPagination.tsx
#: src/timber/components/logHistory/LogHistoryList/LogHistoryListPagination.tsx
#: src/timber/components/price/PriceList/PriceListPagination.tsx
#: src/timber/components/pricingProfile/PricingProfileList/PricingProfileListPagination.tsx
#: src/timber/components/provider/ProviderList/ProviderListPagination.tsx
#: src/timber/components/providerUser/ProviderUserList/ProviderUserListPagination.tsx
#: src/timber/components/roadCarrier/RoadCarrierList/RoadCarrierListPagination.tsx
#: src/timber/components/shipment/ShipmentList/ShipmentListPagination.tsx
#: src/timber/components/shipmentHistory/ShipmentHistoryList/ShipmentHistoryListPagination.tsx
#: src/timber/components/thicknessClass/ThicknessClassList/ThicknessClassListPagination.tsx
#: src/timber/components/timberClass/TimberClassList/TimberClassListPagination.tsx
#: src/timber/components/timberStorage/TimberStorageList/TimberStorageListPagination.tsx
#: src/timber/components/timberType/TimberTypeList/TimberTypeListPagination.tsx
#: src/timber/components/treeMarking/TreeMarkingList/TreeMarkingListPagination.tsx
msgid "rows per page"
msgstr "rows per page"

#: src/share/components/chat/ChatMessage.tsx
msgid "Running {runningTool}…"
msgstr "Running {runningTool}…"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx
msgid "Save"
msgstr "Save"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx
msgid "Save as new profile"
msgstr "Save as new profile"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx
msgid "Save changes to selected profile"
msgstr "Save changes to selected profile"

#: src/auth/components/role/RoleDetail/RoleDetail.tsx
#: src/auth/components/role/RoleForm/RoleAddForm.tsx
#: src/auth/components/role/RoleForm/RoleUpdateForm.tsx
#: src/auth/components/role/RoleList/RoleListItem.tsx
#: src/auth/components/role/RoleList/RoleListSearch.tsx
msgid "Scope"
msgstr "Scope"

#: src/auth/components/roleAssignment/RoleAssignmentDetail/RoleAssignmentDetail.tsx
#: src/auth/components/roleAssignment/RoleAssignmentForm/RoleAssignmentAddForm.tsx
#: src/auth/components/roleAssignment/RoleAssignmentList/RoleAssignmentListItem.tsx
#: src/auth/components/roleAssignment/RoleAssignmentList/RoleAssignmentListSearch.tsx
#: src/auth/components/scopeGroup/ScopeGroupDetail/ScopeGroupDetail.tsx
#: src/auth/components/scopeGroup/ScopeGroupList/ScopeGroupListItem.tsx
#: src/auth/pages/scopeGroup/ScopeGroupEntityPage.tsx
msgid "Scope Group"
msgstr "Scope Group"

#: src/auth/hooks/useScopeGroup.ts
msgid "Scope Group add error: "
msgstr "Scope Group add error: "

#: src/auth/components/scopeGroup/ScopeGroupDetail/ScopeGroupDetail.tsx
#: src/auth/components/scopeGroup/ScopeGroupForm/ScopeGroupAddForm.tsx
#: src/auth/components/scopeGroup/ScopeGroupForm/ScopeGroupUpdateForm.tsx
#: src/auth/components/scopeGroup/ScopeGroupList/ScopeGroupListItem.tsx
#: src/auth/components/scopeGroup/ScopeGroupList/ScopeGroupListSearch.tsx
msgid "Scope Group Context"
msgstr "Scope Group Context"

#: src/auth/components/scopeGroup/ScopeGroupForm/ScopeGroupAddForm.tsx
#: src/auth/components/scopeGroup/ScopeGroupForm/ScopeGroupUpdateForm.tsx
msgid "Scope Group Context is required"
msgstr "Scope Group Context is required"

#: src/auth/hooks/useScopeGroup.ts
msgid "Scope Group delete error: "
msgstr "Scope Group delete error: "

#: src/auth/hooks/useScopeGroup.ts
msgid "Scope Group deleted"
msgstr "Scope Group deleted"

#: src/auth/components/roleAssignment/RoleAssignmentForm/RoleAssignmentAddForm.tsx
#~ msgid "Scope Group Id is required"
#~ msgstr "Scope Group Id is required"

#: src/auth/components/roleAssignment/RoleAssignmentForm/RoleAssignmentAddForm.tsx
msgid "Scope Group is required"
msgstr "Scope Group is required"

#: src/auth/hooks/useScopeGroup.ts
msgid "Scope Group update error: "
msgstr "Scope Group update error: "

#: src/auth/hooks/useScopeGroup.ts
msgid "Scope Group updated"
msgstr "Scope Group updated"

#: src/app/mappers.tsx
#: src/auth/components/membersGroup/MembersGroupDetail/MembersGroupTabs.tsx
#: src/auth/components/scopeGroup/ScopeGroupList/ScopeGroupListHeader.tsx
#: src/auth/pages/listItems.tsx
msgid "Scope Groups"
msgstr "Scope Groups"

#: src/auth/components/membersGroup/MembersGroupList/MembersGroupListSearch.tsx
#: src/auth/components/membersGroupUser/MembersGroupUserList/MembersGroupUserListSearch.tsx
#: src/auth/components/role/RoleList/RoleListSearch.tsx
#: src/auth/components/roleAssignment/RoleAssignmentList/RoleAssignmentListSearch.tsx
#: src/auth/components/rolePermission/RolePermissionList/RolePermissionListSearch.tsx
#: src/auth/components/scopeGroup/ScopeGroupList/ScopeGroupListSearch.tsx
#: src/location/components/location/LocationList/LocationListSearch.tsx
#: src/timber/components/cordwood/CordwoodList/CordwoodListSearch.tsx
#: src/timber/components/cutting/CuttingList/CuttingListSearch.tsx
#: src/timber/components/log/LogList/LogListSearch.tsx
#: src/timber/components/price/PriceList/PriceListSearch.tsx
#: src/timber/components/shipment/ShipmentList/ShipmentListSearch.tsx
#: src/timber/components/timberStorage/TimberStorageList/TimberStorageListSearch.tsx
#: src/timber/components/treeMarking/TreeMarkingList/TreeMarkingListSearch.tsx
msgid "Search"
msgstr "Search"

#: src/timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListSearch.tsx
#~ msgid "Search (by Cordwood Id, Action)"
#~ msgstr "Search (by Cordwood Id, Action)"

#: src/timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListSearch.tsx
msgid "Search (by Cordwood, Action)"
msgstr "Search (by Cordwood, Action)"

#: src/address/components/address/AddressList/AddressListSearch.tsx
msgid "Search (by Email, Address, City)"
msgstr "Search (by Email, Address, City)"

#: src/timber/components/accountingUser/AccountingUserList/AccountingUserListSearch.tsx
#: src/timber/components/buyerUser/BuyerUserList/BuyerUserListSearch.tsx
#: src/timber/components/contractorUser/ContractorUserList/ContractorUserListSearch.tsx
#: src/timber/components/providerUser/ProviderUserList/ProviderUserListSearch.tsx
msgid "Search (by Email, Name)"
msgstr "Search (by Email, Name)"

#: src/auth/components/user/UserList/UserListSearch.tsx
msgid "Search (by Email)"
msgstr "Search (by Email)"

#: src/auth/components/membersGroup/MembersGroupList/MembersGroupListSearch.tsx
#: src/location/components/location/LocationList/LocationListSearch.tsx
msgid "Search (by Hierarchy Name)"
msgstr "Search (by Hierarchy Name)"

#: src/timber/components/shipment/ShipmentList/ShipmentListSearch.tsx
msgid "Search (by Key, Report Key, Shipment At)"
msgstr "Search (by Key, Report Key, Shipment At)"

#: src/timber/components/logHistory/LogHistoryList/LogHistoryListSearch.tsx
#~ msgid "Search (by Log Id, Action)"
#~ msgstr "Search (by Log Id, Action)"

#: src/timber/components/logHistory/LogHistoryList/LogHistoryListSearch.tsx
msgid "Search (by Log, Action)"
msgstr "Search (by Log, Action)"

#: src/auth/components/membersGroupUser/MembersGroupUserList/MembersGroupUserListSearch.tsx
msgid "Search (by Member Group, Owner Member Group)"
msgstr "Search (by Member Group, Owner Member Group)"

#: src/auth/components/roleAssignment/RoleAssignmentList/RoleAssignmentListSearch.tsx
msgid "Search (by Member Group, Role)"
msgstr "Search (by Member Group, Role)"

#: src/auth/components/membersGroupUser/MembersGroupUserList/MembersGroupUserListSearch.tsx
#~ msgid "Search (by Members Group Id, Owned Members Group Id)"
#~ msgstr "Search (by Members Group Id, Owned Members Group Id)"

#: src/auth/components/roleAssignment/RoleAssignmentList/RoleAssignmentListSearch.tsx
#~ msgid "Search (by Members Group Id, Role Id)"
#~ msgstr "Search (by Members Group Id, Role Id)"

#: src/timber/components/thicknessClass/ThicknessClassList/ThicknessClassListSearch.tsx
#~ msgid "Search (by Name, Class Id)"
#~ msgstr "Search (by Name, Class Id)"

#: src/timber/components/thicknessClass/ThicknessClassList/ThicknessClassListSearch.tsx
msgid "Search (by Name, Timber Class)"
msgstr "Search (by Name, Timber Class)"

#: src/auth/components/role/RoleList/RoleListSearch.tsx
#: src/auth/components/scopeGroup/ScopeGroupList/ScopeGroupListSearch.tsx
#: src/timber/components/buyer/BuyerList/BuyerListSearch.tsx
#: src/timber/components/contractor/ContractorList/ContractorListSearch.tsx
#: src/timber/components/cutting/CuttingList/CuttingListSearch.tsx
#: src/timber/components/forestOwner/ForestOwnerList/ForestOwnerListSearch.tsx
#: src/timber/components/pricingProfile/PricingProfileList/PricingProfileListSearch.tsx
#: src/timber/components/provider/ProviderList/ProviderListSearch.tsx
#: src/timber/components/roadCarrier/RoadCarrierList/RoadCarrierListSearch.tsx
#: src/timber/components/timberClass/TimberClassList/TimberClassListSearch.tsx
#: src/timber/components/timberStorage/TimberStorageList/TimberStorageListSearch.tsx
#: src/timber/components/timberType/TimberTypeList/TimberTypeListSearch.tsx
msgid "Search (by Name)"
msgstr "Search (by Name)"

#: src/auth/components/rolePermission/RolePermissionList/RolePermissionListSearch.tsx
#~ msgid "Search (by Role Id, Permission)"
#~ msgstr "Search (by Role Id, Permission)"

#: src/auth/components/rolePermission/RolePermissionList/RolePermissionListSearch.tsx
msgid "Search (by Role, Permission)"
msgstr "Search (by Role, Permission)"

#: src/timber/components/shipmentHistory/ShipmentHistoryList/ShipmentHistoryListSearch.tsx
#~ msgid "Search (by Shipment Id, Action)"
#~ msgstr "Search (by Shipment Id, Action)"

#: src/timber/components/shipmentHistory/ShipmentHistoryList/ShipmentHistoryListSearch.tsx
msgid "Search (by Shipment, Action)"
msgstr "Search (by Shipment, Action)"

#: src/timber/components/log/LogList/LogListSearch.tsx
msgid "Search (by Timber Key, External Key, IK)"
msgstr "Search (by Timber Key, External Key, IK)"

#: src/timber/components/cordwood/CordwoodList/CordwoodListSearch.tsx
msgid "Search (by Timber Key, IK)"
msgstr "Search (by Timber Key, IK)"

#: src/timber/components/price/PriceList/PriceListSearch.tsx
#~ msgid "Search (by Timber Type Id, Class Id, Thickness Class Id)"
#~ msgstr "Search (by Timber Type Id, Class Id, Thickness Class Id)"

#: src/timber/components/treeMarking/TreeMarkingList/TreeMarkingListSearch.tsx
#~ msgid "Search (by Timber Type Id, Volume (m&#xB3;))"
#~ msgstr "Search (by Timber Type Id, Volume (m&#xB3;))"

#: src/timber/components/price/PriceList/PriceListSearch.tsx
msgid "Search (by Timber Type, Timber Class, Thickness Class)"
msgstr "Search (by Timber Type, Timber Class, Thickness Class)"

#: src/timber/components/treeMarking/TreeMarkingList/TreeMarkingListSearch.tsx
msgid "Search (by Timber Type, Volume (m&#xB3;))"
msgstr "Search (by Timber Type, Volume (m&#xB3;))"

#: src/address/components/userAddress/UserAddressList/UserAddressListSearch.tsx
#~ msgid "Search (by User Id, Address Id)"
#~ msgstr "Search (by User Id, Address Id)"

#: src/auth/components/userSession/UserSessionList/UserSessionListSearch.tsx
#~ msgid "Search (by User Id)"
#~ msgstr "Search (by User Id)"

#: src/address/components/userAddress/UserAddressList/UserAddressListSearch.tsx
msgid "Search (by User, Address)"
msgstr "Search (by User, Address)"

#: src/auth/components/userSession/UserSessionList/UserSessionListSearch.tsx
msgid "Search (by User)"
msgstr "Search (by User)"

#: src/share/components/chat/ConversationList.tsx
msgid "Search history..."
msgstr "Search history..."

#: src/share/components/gdpr/CookieConsent.tsx
msgid "See our"
msgstr "See our"

#: src/timber/components/shipment/ShipmentRegulator/CordwoodListItemForShipment.tsx
msgid "Select cordwood to shipment"
msgstr "Select cordwood to shipment"

#: src/timber/components/shipment/ShipmentRegulator/LogListItemForShipment.tsx
msgid "Select log for shipment"
msgstr "Select log for shipment"

#: src/timber/components/shipment/ShipmentRegulator/LogShipmentUpload.tsx
msgid "Select shipment CSV file"
msgstr "Select shipment CSV file"

#: src/share/components/scope/ScopeSwitcher.tsx
msgid "Selected Group"
msgstr "Selected Group"

#: src/share/components/chat/ChatMessage.tsx
msgid "Send"
msgstr "Send"

#: src/share/components/chat/ChatInput.tsx
msgid "Send message"
msgstr "Send message"

#. placeholder {0}: response.status
#: src/share/components/chat/useChat.ts
msgid "Server error: {0}"
msgstr "Server error: {0}"

#: src/timber/components/provider/ProviderDetail/ProviderSplitTab.tsx
msgid "Share"
msgstr "Share"

#: src/timber/components/cordwood/CordwoodDetail/CordwoodDetail.tsx
#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx
#: src/timber/components/cordwood/CordwoodForm/CordwoodUpdateForm.tsx
#: src/timber/components/cordwood/CordwoodList/CordwoodListItem.tsx
#: src/timber/components/cordwood/CordwoodList/CordwoodListSearch.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryDetail/CordwoodHistoryDetail.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListItem.tsx
#: src/timber/components/history/HistoryList/HistoryListItemRow.tsx
#: src/timber/components/log/LogDetail/LogDetail.tsx
#: src/timber/components/log/LogForm/LogAddForm.tsx
#: src/timber/components/log/LogForm/LogUpdateForm.tsx
#: src/timber/components/log/LogList/LogListItem.tsx
#: src/timber/components/log/LogList/LogListSearch.tsx
#: src/timber/components/logHistory/LogHistoryDetail/LogHistoryDetail.tsx
#: src/timber/components/logHistory/LogHistoryList/LogHistoryListItem.tsx
#: src/timber/components/shipment/ShipmentDetail/ShipmentDetail.tsx
#: src/timber/components/shipment/ShipmentRegulator/CordwoodDetail.tsx
#: src/timber/components/shipment/ShipmentRegulator/CordwoodListItemForShipment.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogDetail.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogListItemForShipment.tsx
#: src/timber/components/shipmentHistory/ShipmentHistoryDetail/ShipmentHistoryDetail.tsx
#: src/timber/components/shipmentHistory/ShipmentHistoryForm/ShipmentHistoryAddForm.tsx
#: src/timber/components/shipmentHistory/ShipmentHistoryList/ShipmentHistoryListItem.tsx
#: src/timber/pages/shipment/ShipmentEntityPage.tsx
#: src/timber/types/models/MergedHistory.ts
msgid "Shipment"
msgstr "Shipment"

#: src/timber/hooks/useShipment.ts
msgid "Shipment add error: "
msgstr "Shipment add error: "

#: src/timber/components/generic/report/GenericRootShipments.tsx
#: src/timber/components/shipment/ShipmentDetail/ShipmentDetail.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx
#: src/timber/components/shipment/ShipmentList/ShipmentListItem.tsx
#: src/timber/components/shipmentHistory/ShipmentHistoryDetail/ShipmentHistoryDetail.tsx
#: src/timber/components/shipmentHistory/ShipmentHistoryList/ShipmentHistoryListItem.tsx
msgid "Shipment At"
msgstr "Shipment At"

#: src/timber/components/shipment/ShipmentList/ShipmentListSearch.tsx
msgid "Shipment At From"
msgstr "Shipment At From"

#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx
msgid "Shipment at is required"
msgstr "Shipment at is required"

#: src/timber/components/shipment/ShipmentList/ShipmentListSearch.tsx
msgid "Shipment At To"
msgstr "Shipment At To"

#: src/timber/components/shipment/ShipmentRegulator/CordwoodListItemForShipment.tsx
msgid "Shipment Cordwood"
msgstr "Shipment Cordwood"

#: src/timber/components/contractorUser/ContractorUserDetail/ContractorUserDetail.tsx
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserAddForm.tsx
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserUpdateForm.tsx
#: src/timber/components/contractorUser/ContractorUserList/ContractorUserListItem.tsx
msgid "Shipment Cordwood Code"
msgstr "Shipment Cordwood Code"

#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserAddForm.tsx
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserUpdateForm.tsx
msgid "Shipment Cordwood Code is required"
msgstr "Shipment Cordwood Code is required"

#: src/timber/components/contractorUser/ContractorUserDetail/ContractorUserDetail.tsx
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserAddForm.tsx
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserUpdateForm.tsx
msgid "Shipment Cordwood Counter"
msgstr "Shipment Cordwood Counter"

#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserAddForm.tsx
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserUpdateForm.tsx
msgid "Shipment Cordwood Counter is required"
msgstr "Shipment Cordwood Counter is required"

#: src/timber/hooks/useShipment.ts
msgid "Shipment delete error: "
msgstr "Shipment delete error: "

#: src/timber/hooks/useShipment.ts
msgid "Shipment deleted"
msgstr "Shipment deleted"

#: src/app/mappers.tsx
#: src/timber/components/shipment/ShipmentDetail/ShipmentTabs.tsx
#: src/timber/components/shipmentHistory/ShipmentHistoryList/ShipmentHistoryListHeader.tsx
msgid "Shipment Histories"
msgstr "Shipment Histories"

#: src/timber/components/shipmentHistory/ShipmentHistoryDetail/ShipmentHistoryDetail.tsx
#: src/timber/pages/shipmentHistory/ShipmentHistoryEntityPage.tsx
msgid "Shipment History"
msgstr "Shipment History"

#: src/timber/hooks/useShipmentHistory.ts
msgid "Shipment History add error: "
msgstr "Shipment History add error: "

#: src/timber/hooks/useShipmentHistory.ts
msgid "Shipment History delete error: "
msgstr "Shipment History delete error: "

#: src/timber/hooks/useShipmentHistory.ts
msgid "Shipment History deleted"
msgstr "Shipment History deleted"

#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx
#: src/timber/components/cordwood/CordwoodForm/CordwoodUpdateForm.tsx
#: src/timber/components/log/LogForm/LogAddForm.tsx
#: src/timber/components/log/LogForm/LogUpdateForm.tsx
#: src/timber/components/shipmentHistory/ShipmentHistoryForm/ShipmentHistoryAddForm.tsx
#~ msgid "Shipment Id is required"
#~ msgstr "Shipment Id is required"

#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx
#: src/timber/components/cordwood/CordwoodForm/CordwoodUpdateForm.tsx
#: src/timber/components/log/LogForm/LogAddForm.tsx
#: src/timber/components/log/LogForm/LogUpdateForm.tsx
#: src/timber/components/shipmentHistory/ShipmentHistoryForm/ShipmentHistoryAddForm.tsx
msgid "Shipment is required"
msgstr "Shipment is required"

#: src/timber/components/contractorUser/ContractorUserDetail/ContractorUserDetail.tsx
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserAddForm.tsx
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserUpdateForm.tsx
#: src/timber/components/contractorUser/ContractorUserList/ContractorUserListItem.tsx
msgid "Shipment Log Code"
msgstr "Shipment Log Code"

#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserAddForm.tsx
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserUpdateForm.tsx
msgid "Shipment Log Code is required"
msgstr "Shipment Log Code is required"

#: src/timber/components/contractorUser/ContractorUserDetail/ContractorUserDetail.tsx
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserAddForm.tsx
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserUpdateForm.tsx
msgid "Shipment Log Counter"
msgstr "Shipment Log Counter"

#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserAddForm.tsx
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserUpdateForm.tsx
msgid "Shipment Log Counter is required"
msgstr "Shipment Log Counter is required"

#: src/timber/components/shipment/ShipmentRegulator/LogListItemForShipment.tsx
msgid "Shipment Logs"
msgstr "Shipment Logs"

#: src/timber/components/shipment/ShipmentDetail/ShipmentDetail.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx
msgid "Shipment Order"
msgstr "Shipment Order"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx
#: src/timber/components/generic/report/GenericRootReport.tsx
#: src/timber/components/generic/report/TimelineRootReport.tsx
#: src/timber/components/shipment/ShipmentDetail/ShipmentDetail.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
#: src/timber/components/shipment/ShipmentList/ShipmentListItem.tsx
#: src/timber/components/shipment/ShipmentList/ShipmentListSearch.tsx
msgid "Shipment Type"
msgstr "Shipment Type"

#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
msgid "Shipment Type is required"
msgstr "Shipment Type is required"

#: src/timber/hooks/useShipment.ts
msgid "Shipment update error: "
msgstr "Shipment update error: "

#: src/timber/hooks/useShipment.ts
msgid "Shipment updated"
msgstr "Shipment updated"

#: src/app/mappers.tsx
#: src/location/components/location/LocationDetail/LocationTabs.tsx
#: src/timber/components/buyer/BuyerDetail/BuyerTabs.tsx
#: src/timber/components/contractorUser/ContractorUserDetail/ContractorUserTabs.tsx
#: src/timber/components/cutting/CuttingDetail/CuttingTabs.tsx
#: src/timber/components/history/HistoryList/HistoryListSearch.tsx
#: src/timber/components/roadCarrier/RoadCarrierDetail/RoadCarrierTabs.tsx
#: src/timber/components/shipment/ShipmentList/ShipmentListHeader.tsx
#: src/timber/components/timberStorage/TimberStorageDetail/TimberStorageTabs.tsx
msgid "Shipments"
msgstr "Shipments"

#: src/timber/components/provider/ProviderDetail/ProviderAttentionList.tsx
msgid "Shipments that should have gone out"
msgstr "Shipments that should have gone out"

#: src/timber/components/provider/ProviderDetail/ProviderSummaryCards.tsx
#: src/timber/components/provider/ProviderList/ProviderListItem.tsx
msgid "Shipped"
msgstr "Shipped"

#. placeholder {0}: fixedFormat(cordwoodShippedVolume)
#. placeholder {0}: fixedFormat(logsShippedVolume)
#: src/timber/components/provider/ProviderDetail/ProviderSummaryCards.tsx
msgid "shipped {0}"
msgstr "shipped {0}"

#: src/timber/components/provider/ProviderDetail/ProviderOverviewTab.tsx
msgid "Shipped and stored volume"
msgstr "Shipped and stored volume"

#: src/timber/components/provider/ProviderDetail/ProviderSummaryCards.tsx
msgid "Shipped volume (m³)"
msgstr "Shipped volume (m³)"

#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
msgid "Shipping Contractor User"
msgstr "Shipping Contractor User"

#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
#~ msgid "Shipping Contractor User Id is required"
#~ msgstr "Shipping Contractor User Id is required"

#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
msgid "Shipping Contractor User is required"
msgstr "Shipping Contractor User is required"

#. placeholder {0}: data.total
#: src/timber/components/provider/ProviderDetail/ProviderAttentionList.tsx
msgid "Show all {0}"
msgstr "Show all {0}"

#: src/share/components/chat/ChatWidget.tsx
msgid "Show history"
msgstr "Show history"

#: src/share/components/chat/ChatThread.tsx
msgid "Show the last 10 logs"
msgstr "Show the last 10 logs"

#: src/share/components/chat/ChatThread.tsx
msgid "Show the last 10 shipments"
msgstr "Show the last 10 shipments"

#: src/share/components/chat/ChatThread.tsx
#~ msgid "Show the latest shipments"
#~ msgstr "Show the latest shipments"

#. placeholder {0}: data.items.length
#. placeholder {1}: data.total
#: src/timber/components/provider/ProviderDetail/ProviderAttentionList.tsx
msgid "showing the {0} worst of {1}"
msgstr "showing the {0} worst of {1}"

#: src/pages/DashboardHomePage.tsx
msgid "Sign in to see the state of the timber."
msgstr "Sign in to see the state of the timber."

#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx
msgid "Source Location"
msgstr "Source Location"

#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx
#~ msgid "Source Location Id is required"
#~ msgstr "Source Location Id is required"

#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx
msgid "Source Location is required"
msgstr "Source Location is required"

#: src/timber/components/shipment/ShipmentDetail/ShipmentDetail.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx
msgid "Source Parcel"
msgstr "Source Parcel"

#: src/timber/components/provider/ProviderDetail/ProviderTabs.tsx
msgid "Split"
msgstr "Split"

#: src/share/components/chat/ChatThread.tsx
msgid "Start a conversation with the AI assistant"
msgstr "Start a conversation with the AI assistant"

#: src/timber/components/cutting/CuttingDetail/CuttingDetail.tsx
#: src/timber/components/cutting/CuttingForm/CuttingAddForm.tsx
#: src/timber/components/cutting/CuttingForm/CuttingUpdateForm.tsx
#: src/timber/components/cutting/CuttingList/CuttingListItem.tsx
msgid "Start At"
msgstr "Start At"

#: src/timber/components/cutting/CuttingList/CuttingListSearch.tsx
msgid "Start At From"
msgstr "Start At From"

#: src/timber/components/cutting/CuttingForm/CuttingAddForm.tsx
#: src/timber/components/cutting/CuttingForm/CuttingUpdateForm.tsx
msgid "Start At is required"
msgstr "Start At is required"

#: src/timber/components/cutting/CuttingList/CuttingListSearch.tsx
msgid "Start At To"
msgstr "Start At To"

#: src/share/components/form/FormDateTime/FormDateRange.tsx
msgid "Start Date"
msgstr "Start Date"

#: src/timber/components/cordwoodHistory/CordwoodHistoryDetail/CordwoodHistoryDetail.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryForm/CordwoodHistoryAddForm.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListItem.tsx
#: src/timber/components/cutting/CuttingDetail/CuttingDetail.tsx
#: src/timber/components/cutting/CuttingForm/CuttingAddForm.tsx
#: src/timber/components/cutting/CuttingForm/CuttingUpdateForm.tsx
#: src/timber/components/cutting/CuttingList/CuttingListItem.tsx
#: src/timber/components/cutting/CuttingList/CuttingListSearch.tsx
#: src/timber/components/generic/report/GenericRootShipments.tsx
#: src/timber/components/history/HistoryList/HistoryListItemRow.tsx
#: src/timber/components/logHistory/LogHistoryDetail/LogHistoryDetail.tsx
#: src/timber/components/logHistory/LogHistoryForm/LogHistoryAddForm.tsx
#: src/timber/components/logHistory/LogHistoryList/LogHistoryListItem.tsx
#: src/timber/components/shipment/ShipmentDetail/ShipmentDetail.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx
#: src/timber/components/shipment/ShipmentList/ShipmentListItem.tsx
#: src/timber/components/shipment/ShipmentList/ShipmentListSearch.tsx
#: src/timber/components/shipmentHistory/ShipmentHistoryDetail/ShipmentHistoryDetail.tsx
#: src/timber/components/shipmentHistory/ShipmentHistoryList/ShipmentHistoryListItem.tsx
msgid "State"
msgstr "State"

#: src/timber/components/cutting/CuttingForm/CuttingAddForm.tsx
#: src/timber/components/cutting/CuttingForm/CuttingUpdateForm.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx
msgid "State is required"
msgstr "State is required"

#: src/share/components/chat/ChatInput.tsx
msgid "Stop generating"
msgstr "Stop generating"

#: src/share/components/chat/ChatMessage.tsx
msgid "stopped"
msgstr "stopped"

#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx
#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx
#: src/timber/components/generic/report/GenericRootReport.tsx
#: src/timber/components/generic/report/GenericRootTable.tsx
#: src/timber/components/generic/report/TimelineRootReport.tsx
#: src/timber/components/generic/treeMarkings/ReportTreeMarkings.tsx
#: src/timber/components/log/LogForm/LogAddForm.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
#: src/timber/components/shipment/ShipmentRegulator/CordwoodDetail.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogDetail.tsx
#: src/timber/components/treeMarking/TreeMarkingForm/TreeMarkingAddForm.tsx
msgid "Storage"
msgstr "Storage"

#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx
#: src/timber/components/log/LogForm/LogAddForm.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
#: src/timber/components/treeMarking/TreeMarkingForm/TreeMarkingAddForm.tsx
#~ msgid "Storage Id is required"
#~ msgstr "Storage Id is required"

#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx
#: src/timber/components/log/LogForm/LogAddForm.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
#: src/timber/components/treeMarking/TreeMarkingForm/TreeMarkingAddForm.tsx
msgid "Storage is required"
msgstr "Storage is required"

#: src/share/components/chat/useChat.ts
msgid "Streaming is not supported by this browser."
msgstr "Streaming is not supported by this browser."

#: src/timber/components/shipment/ShipmentRegulator/LogShipmentUpload.tsx
msgid "Submit"
msgstr "Submit"

#: src/share/components/alert/DescriptionAlert/useDescriptionAlert.ts
msgid "Success"
msgstr "Success"

#: src/app/App.tsx
msgid "Swagger UI"
msgstr "Swagger UI"

#: src/timber/components/buyer/BuyerDetail/BuyerDetail.tsx
#: src/timber/components/buyer/BuyerForm/BuyerAddForm.tsx
#: src/timber/components/buyer/BuyerForm/BuyerUpdateForm.tsx
#: src/timber/components/contractor/ContractorDetail/ContractorDetail.tsx
#: src/timber/components/contractor/ContractorForm/ContractorAddForm.tsx
#: src/timber/components/contractor/ContractorForm/ContractorUpdateForm.tsx
#: src/timber/components/forestOwner/ForestOwnerDetail/ForestOwnerDetail.tsx
#: src/timber/components/forestOwner/ForestOwnerForm/ForestOwnerAddForm.tsx
#: src/timber/components/forestOwner/ForestOwnerForm/ForestOwnerUpdateForm.tsx
#: src/timber/components/provider/ProviderDetail/ProviderDetail.tsx
#: src/timber/components/provider/ProviderForm/ProviderAddForm.tsx
#: src/timber/components/provider/ProviderForm/ProviderUpdateForm.tsx
msgid "Swift"
msgstr "Swift"

#: src/pages/PreferencesPage.tsx
msgid "System"
msgstr "System"

#: src/timber/components/shipment/ShipmentDetail/ShipmentDetail.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx
msgid "Target Address"
msgstr "Target Address"

#: src/timber/components/shipment/ShipmentDetail/ShipmentDetail.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx
msgid "Target City"
msgstr "Target City"

#: src/timber/components/shipment/ShipmentDetail/ShipmentDetail.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx
msgid "Target Country"
msgstr "Target Country"

#: src/timber/components/log/LogList/LogListItem.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogListItemForShipment.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogListItemFromHistory.tsx
msgid "TC"
msgstr "TC"

#: src/app/App.tsx
#: src/pages/LoginPage.tsx
msgid "Terms"
msgstr "Terms"

#: src/pages/PrivacyPolicyPage.tsx
#: src/pages/TermsPage.tsx
msgid "Terms of Service"
msgstr "Terms of Service"

#: src/share/components/chat/serverErrors.ts
msgid "The assistant asked for a tool that does not exist."
msgstr "The assistant asked for a tool that does not exist."

#: src/pages/DashboardHomePage.tsx
msgid "The provider of this account could not be loaded."
msgstr "The provider of this account could not be loaded."

#: src/share/components/chat/serverErrors.ts
msgid "The reply used every available tool call. Please ask a more specific question."
msgstr "The reply used every available tool call. Please ask a more specific question."

#: src/pages/TermsPage.tsx
msgid "The service is provided “as is”. We may modify these terms from time to time. Continued use constitutes acceptance of the updated terms."
msgstr "The service is provided “as is”. We may modify these terms from time to time. Continued use constitutes acceptance of the updated terms."

#. placeholder {0}: item.ageDays
#: src/timber/components/provider/ProviderDetail/ProviderAttentionList.tsx
msgid "The shipment was due {0} days ago."
msgstr "The shipment was due {0} days ago."

#: src/timber/components/provider/ProviderDetail/ProviderSplitTab.tsx
msgid "The split could not be loaded."
msgstr "The split could not be loaded."

#: src/pages/PreferencesPage.tsx
msgid "Theme"
msgstr "Theme"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx
#: src/timber/components/generic/report/GenericRootTable.tsx
#: src/timber/components/log/LogDetail/LogDetail.tsx
#: src/timber/components/log/LogList/LogListItem.tsx
#: src/timber/components/log/LogList/LogListSearch.tsx
#: src/timber/components/logHistory/LogHistoryDetail/LogHistoryDetail.tsx
#: src/timber/components/logHistory/LogHistoryList/LogHistoryListItem.tsx
#: src/timber/components/price/PriceDetail/PriceDetail.tsx
#: src/timber/components/price/PriceForm/PriceAddForm.tsx
#: src/timber/components/price/PriceForm/PriceUpdateForm.tsx
#: src/timber/components/price/PriceList/PriceListItem.tsx
#: src/timber/components/price/PriceList/PriceListSearch.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogDetail.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogListItemForShipment.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogListItemFromHistory.tsx
#: src/timber/components/thicknessClass/ThicknessClassDetail/ThicknessClassDetail.tsx
#: src/timber/pages/thicknessClass/ThicknessClassEntityPage.tsx
msgid "Thickness Class"
msgstr "Thickness Class"

#: src/timber/hooks/useThicknessClass.ts
msgid "Thickness Class add error: "
msgstr "Thickness Class add error: "

#: src/timber/hooks/useThicknessClass.ts
msgid "Thickness Class delete error: "
msgstr "Thickness Class delete error: "

#: src/timber/hooks/useThicknessClass.ts
msgid "Thickness Class deleted"
msgstr "Thickness Class deleted"

#: src/timber/components/price/PriceForm/PriceAddForm.tsx
#: src/timber/components/price/PriceForm/PriceUpdateForm.tsx
#~ msgid "Thickness Class Id is required"
#~ msgstr "Thickness Class Id is required"

#: src/timber/components/price/PriceForm/PriceAddForm.tsx
#: src/timber/components/price/PriceForm/PriceUpdateForm.tsx
msgid "Thickness Class is required"
msgstr "Thickness Class is required"

#: src/timber/hooks/useThicknessClass.ts
msgid "Thickness Class update error: "
msgstr "Thickness Class update error: "

#: src/timber/hooks/useThicknessClass.ts
msgid "Thickness Class updated"
msgstr "Thickness Class updated"

#: src/app/mappers.tsx
#: src/timber/components/thicknessClass/ThicknessClassList/ThicknessClassListHeader.tsx
#: src/timber/pages/listItems.tsx
msgid "Thickness Classes"
msgstr "Thickness Classes"

#: src/share/components/chat/ChatThread.tsx
msgid "Thinking..."
msgstr "Thinking..."

#: src/share/components/chat/ChatMessage.tsx
msgid "Thinking…"
msgstr "Thinking…"

#: src/share/components/form/FormDateTime/FormDateRange.tsx
msgid "This Month"
msgstr "This Month"

#: src/timber/components/provider/ProviderDetail/ProviderOverviewTab.tsx
#~ msgid "This provider has more cuttings than fit on one page, so the volumes below are only a part of the whole."
#~ msgstr "This provider has more cuttings than fit on one page, so the volumes below are only a part of the whole."

#: src/timber/components/provider/ProviderDetail/ProviderOverviewTab.tsx
msgid "This provider has no cuttings yet."
msgstr "This provider has no cuttings yet."

#: src/share/components/chat/ChatMessage.tsx
msgid "This reply was cut short. The text is all that was received."
msgstr "This reply was cut short. The text is all that was received."

#: src/share/components/form/FormDateTime/FormDateRange.tsx
msgid "This Week"
msgstr "This Week"

#: src/share/components/form/FormDateTime/FormDateRange.tsx
msgid "This Year"
msgstr "This Year"

#: src/timber/components/cordwood/CordwoodDetail/CordwoodDetail.tsx
#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx
#: src/timber/components/cordwood/CordwoodForm/CordwoodUpdateForm.tsx
#: src/timber/components/cordwood/CordwoodList/CordwoodListItem.tsx
#: src/timber/components/cordwood/CordwoodList/CordwoodListSearch.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryDetail/CordwoodHistoryDetail.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListItem.tsx
#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx
#: src/timber/components/generic/report/GenericRootReport.tsx
#: src/timber/components/generic/report/TimelineRootReport.tsx
#: src/timber/components/log/LogDetail/LogDetail.tsx
#: src/timber/components/log/LogForm/LogAddForm.tsx
#: src/timber/components/log/LogForm/LogUpdateForm.tsx
#: src/timber/components/log/LogList/LogListItem.tsx
#: src/timber/components/log/LogList/LogListSearch.tsx
#: src/timber/components/logHistory/LogHistoryDetail/LogHistoryDetail.tsx
#: src/timber/components/logHistory/LogHistoryList/LogHistoryListItem.tsx
#: src/timber/components/price/PriceDetail/PriceDetail.tsx
#: src/timber/components/price/PriceForm/PriceAddForm.tsx
#: src/timber/components/price/PriceForm/PriceUpdateForm.tsx
#: src/timber/components/price/PriceList/PriceListItem.tsx
#: src/timber/components/price/PriceList/PriceListSearch.tsx
#: src/timber/components/thicknessClass/ThicknessClassDetail/ThicknessClassDetail.tsx
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassAddForm.tsx
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassUpdateForm.tsx
#: src/timber/components/thicknessClass/ThicknessClassList/ThicknessClassListItem.tsx
#: src/timber/components/timberClass/TimberClassDetail/TimberClassDetail.tsx
#: src/timber/pages/timberClass/TimberClassEntityPage.tsx
msgid "Timber Class"
msgstr "Timber Class"

#: src/timber/hooks/useTimberClass.ts
msgid "Timber Class add error: "
msgstr "Timber Class add error: "

#: src/timber/hooks/useTimberClass.ts
msgid "Timber Class delete error: "
msgstr "Timber Class delete error: "

#: src/timber/hooks/useTimberClass.ts
msgid "Timber Class deleted"
msgstr "Timber Class deleted"

#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx
#: src/timber/components/cordwood/CordwoodForm/CordwoodUpdateForm.tsx
#: src/timber/components/log/LogForm/LogAddForm.tsx
#: src/timber/components/log/LogForm/LogUpdateForm.tsx
#: src/timber/components/price/PriceForm/PriceAddForm.tsx
#: src/timber/components/price/PriceForm/PriceUpdateForm.tsx
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassAddForm.tsx
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassUpdateForm.tsx
msgid "Timber Class is required"
msgstr "Timber Class is required"

#: src/timber/hooks/useTimberClass.ts
msgid "Timber Class update error: "
msgstr "Timber Class update error: "

#: src/timber/hooks/useTimberClass.ts
msgid "Timber Class updated"
msgstr "Timber Class updated"

#: src/app/mappers.tsx
#: src/timber/components/timberClass/TimberClassList/TimberClassListHeader.tsx
#: src/timber/pages/listItems.tsx
msgid "Timber Classes"
msgstr "Timber Classes"

#: src/timber/components/cordwood/CordwoodDetail/CordwoodDetail.tsx
#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx
#: src/timber/components/cordwood/CordwoodList/CordwoodListItem.tsx
#: src/timber/components/cordwood/CordwoodList/CordwoodListSearch.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryDetail/CordwoodHistoryDetail.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListItem.tsx
#: src/timber/components/history/HistoryList/HistoryListItemRow.tsx
#: src/timber/components/log/LogDetail/LogDetail.tsx
#: src/timber/components/log/LogForm/LogAddForm.tsx
#: src/timber/components/log/LogList/LogListItem.tsx
#: src/timber/components/log/LogList/LogListSearch.tsx
#: src/timber/components/logHistory/LogHistoryDetail/LogHistoryDetail.tsx
#: src/timber/components/logHistory/LogHistoryList/LogHistoryListItem.tsx
#: src/timber/components/shipment/ShipmentRegulator/CordwoodListItemForShipment.tsx
#: src/timber/components/shipment/ShipmentRegulator/CordwoodListItemFromHistory.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogListItemForShipment.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogListItemFromHistory.tsx
msgid "Timber Key"
msgstr "Timber Key"

#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx
#: src/timber/components/log/LogForm/LogAddForm.tsx
msgid "Timber Key is required"
msgstr "Timber Key is required"

#: src/timber/components/provider/ProviderDetail/ProviderAttentionList.tsx
msgid "Timber standing in the storages"
msgstr "Timber standing in the storages"

#: src/timber/components/cordwood/CordwoodDetail/CordwoodDetail.tsx
#: src/timber/components/cordwood/CordwoodList/CordwoodListItem.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryDetail/CordwoodHistoryDetail.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListItem.tsx
#: src/timber/components/generic/report/GenericRootShipments.tsx
#: src/timber/components/history/HistoryList/HistoryListItemRow.tsx
#: src/timber/components/history/HistoryList/HistoryListSearch.tsx
#: src/timber/components/log/LogDetail/LogDetail.tsx
#: src/timber/components/log/LogList/LogListItem.tsx
#: src/timber/components/logHistory/LogHistoryDetail/LogHistoryDetail.tsx
#: src/timber/components/logHistory/LogHistoryList/LogHistoryListItem.tsx
#: src/timber/components/shipment/ShipmentDetail/ShipmentDetail.tsx
#: src/timber/components/shipment/ShipmentList/ShipmentListItem.tsx
#: src/timber/components/shipmentHistory/ShipmentHistoryDetail/ShipmentHistoryDetail.tsx
#: src/timber/components/shipmentHistory/ShipmentHistoryList/ShipmentHistoryListItem.tsx
#: src/timber/components/timberStorage/TimberStorageDetail/TimberStorageDetail.tsx
#: src/timber/components/treeMarking/TreeMarkingDetail/TreeMarkingDetail.tsx
#: src/timber/components/treeMarking/TreeMarkingList/TreeMarkingListItem.tsx
#: src/timber/components/treeMarking/TreeMarkingList/TreeMarkingListSearch.tsx
#: src/timber/pages/timberStorage/TimberStorageEntityPage.tsx
msgid "Timber Storage"
msgstr "Timber Storage"

#: src/timber/hooks/useTimberStorage.ts
msgid "Timber Storage add error: "
msgstr "Timber Storage add error: "

#: src/timber/hooks/useTimberStorage.ts
msgid "Timber Storage delete error: "
msgstr "Timber Storage delete error: "

#: src/timber/hooks/useTimberStorage.ts
msgid "Timber Storage deleted"
msgstr "Timber Storage deleted"

#: src/timber/hooks/useTimberStorage.ts
msgid "Timber Storage update error: "
msgstr "Timber Storage update error: "

#: src/timber/hooks/useTimberStorage.ts
msgid "Timber Storage updated"
msgstr "Timber Storage updated"

#: src/app/mappers.tsx
#: src/location/components/location/LocationDetail/LocationTabs.tsx
#: src/timber/components/cutting/CuttingDetail/CuttingTabs.tsx
#: src/timber/components/forestOwner/ForestOwnerDetail/ForestOwnerTabs.tsx
#: src/timber/components/timberStorage/TimberStorageList/TimberStorageListHeader.tsx
msgid "Timber Storages"
msgstr "Timber Storages"

#: src/timber/components/cordwood/CordwoodDetail/CordwoodDetail.tsx
#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx
#: src/timber/components/cordwood/CordwoodForm/CordwoodUpdateForm.tsx
#: src/timber/components/cordwood/CordwoodList/CordwoodListItem.tsx
#: src/timber/components/cordwood/CordwoodList/CordwoodListSearch.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryDetail/CordwoodHistoryDetail.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListItem.tsx
#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx
#: src/timber/components/generic/report/GenericRootReport.tsx
#: src/timber/components/generic/report/TimelineRootReport.tsx
#: src/timber/components/log/LogDetail/LogDetail.tsx
#: src/timber/components/log/LogForm/LogAddForm.tsx
#: src/timber/components/log/LogForm/LogUpdateForm.tsx
#: src/timber/components/log/LogList/LogListItem.tsx
#: src/timber/components/log/LogList/LogListSearch.tsx
#: src/timber/components/logHistory/LogHistoryDetail/LogHistoryDetail.tsx
#: src/timber/components/logHistory/LogHistoryList/LogHistoryListItem.tsx
#: src/timber/components/price/PriceDetail/PriceDetail.tsx
#: src/timber/components/price/PriceForm/PriceAddForm.tsx
#: src/timber/components/price/PriceForm/PriceUpdateForm.tsx
#: src/timber/components/price/PriceList/PriceListItem.tsx
#: src/timber/components/price/PriceList/PriceListSearch.tsx
#: src/timber/components/shipment/ShipmentRegulator/CordwoodDetail.tsx
#: src/timber/components/shipment/ShipmentRegulator/CordwoodListItemForShipment.tsx
#: src/timber/components/shipment/ShipmentRegulator/CordwoodListItemFromHistory.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogDetail.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogListItemForShipment.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogListItemFromHistory.tsx
#: src/timber/components/timberType/TimberTypeDetail/TimberTypeDetail.tsx
#: src/timber/components/treeMarking/TreeMarkingDetail/TreeMarkingDetail.tsx
#: src/timber/components/treeMarking/TreeMarkingForm/TreeMarkingAddForm.tsx
#: src/timber/components/treeMarking/TreeMarkingList/TreeMarkingListItem.tsx
#: src/timber/components/treeMarking/TreeMarkingList/TreeMarkingListSearch.tsx
#: src/timber/pages/timberType/TimberTypeEntityPage.tsx
msgid "Timber Type"
msgstr "Timber Type"

#: src/timber/hooks/useTimberType.ts
msgid "Timber Type add error: "
msgstr "Timber Type add error: "

#: src/timber/hooks/useTimberType.ts
msgid "Timber Type delete error: "
msgstr "Timber Type delete error: "

#: src/timber/hooks/useTimberType.ts
msgid "Timber Type deleted"
msgstr "Timber Type deleted"

#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx
#: src/timber/components/cordwood/CordwoodForm/CordwoodUpdateForm.tsx
#: src/timber/components/log/LogForm/LogAddForm.tsx
#: src/timber/components/log/LogForm/LogUpdateForm.tsx
#: src/timber/components/price/PriceForm/PriceAddForm.tsx
#: src/timber/components/price/PriceForm/PriceUpdateForm.tsx
#: src/timber/components/treeMarking/TreeMarkingForm/TreeMarkingAddForm.tsx
#~ msgid "Timber Type Id is required"
#~ msgstr "Timber Type Id is required"

#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx
#: src/timber/components/cordwood/CordwoodForm/CordwoodUpdateForm.tsx
#: src/timber/components/log/LogForm/LogAddForm.tsx
#: src/timber/components/log/LogForm/LogUpdateForm.tsx
#: src/timber/components/price/PriceForm/PriceAddForm.tsx
#: src/timber/components/price/PriceForm/PriceUpdateForm.tsx
#: src/timber/components/treeMarking/TreeMarkingForm/TreeMarkingAddForm.tsx
msgid "Timber Type is required"
msgstr "Timber Type is required"

#: src/timber/hooks/useTimberType.ts
msgid "Timber Type update error: "
msgstr "Timber Type update error: "

#: src/timber/hooks/useTimberType.ts
msgid "Timber Type updated"
msgstr "Timber Type updated"

#: src/app/mappers.tsx
#: src/timber/components/timberType/TimberTypeList/TimberTypeListHeader.tsx
#: src/timber/pages/listItems.tsx
msgid "Timber Types"
msgstr "Timber Types"

#: src/timber/components/provider/ProviderDetail/ProviderSummaryCards.tsx
msgid "Timber volume (m³)"
msgstr "Timber volume (m³)"

#: src/pages/DashboardHomePage.tsx
#: src/timber/pages/listItems.tsx
msgid "Timberstorage"
msgstr "Timberstorage"

#: src/timber/components/contractor/ContractorDetail/ContractorTabs.tsx
#: src/timber/components/cutting/CuttingDetail/CuttingTabs.tsx
#: src/timber/components/generic/report/TimelineRootReport.tsx
#: src/timber/components/provider/ProviderDetail/ProviderTabs.tsx
#: src/timber/components/timberStorage/TimberStorageDetail/TimberStorageTabs.tsx
msgid "Timeline Report"
msgstr "Timeline Report"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx
#: src/timber/components/generic/report/GenericRootReport.tsx
#: src/timber/components/generic/report/TimelineRootReport.tsx
#~ msgid "To Input Date"
#~ msgstr "To Input Date"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx
#: src/timber/components/generic/report/GenericRootReport.tsx
#: src/timber/components/generic/report/TimelineRootReport.tsx
msgid "To Shipment Date"
msgstr "To Shipment Date"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx
#: src/timber/components/generic/report/GenericRootReport.tsx
#: src/timber/components/generic/report/TimelineRootReport.tsx
msgid "To Timber Input Date"
msgstr "To Timber Input Date"

#: src/share/components/chat/ConversationList.tsx
#: src/share/components/form/FormDateTime/FormDateRange.tsx
msgid "Today"
msgstr "Today"

#: src/share/components/chat/ChatToolView.tsx
msgid "Tool result"
msgstr "Tool result"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx
#: src/timber/components/generic/report/GenericRootTable.tsx
#: src/timber/components/generic/treeMarkings/ReportTreeMarkings.tsx
msgid "Total"
msgstr "Total"

#. placeholder {0}: fixedFormat(data.reduce((acc, row) => acc + row.volume, 0))
#: src/timber/components/generic/report/ParetoChart.tsx
#~ msgid "Total {0} m³"
#~ msgstr "Total {0} m³"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx
#: src/timber/components/generic/report/GenericRootTable.tsx
msgid "Total class and type"
msgstr "Total class and type"

#: src/timber/components/generic/report/GenericRootShipments.tsx
msgid "Total Logs"
msgstr "Total Logs"

#: src/timber/components/generic/report/GenericRootTable.tsx
msgid "Total on cutting"
msgstr "Total on cutting"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx
#: src/timber/components/generic/report/GenericRootTable.tsx
msgid "Total on storage"
msgstr "Total on storage"

#: src/timber/components/generic/report/GenericRootShipments.tsx
msgid "Total Shipments"
msgstr "Total Shipments"

#: src/timber/components/generic/treeMarkings/ReportTreeMarkings.tsx
msgid "Total volume"
msgstr "Total volume"

#: src/timber/components/generic/report/GenericRootShipments.tsx
msgid "Total Volume"
msgstr "Total Volume"

#: src/timber/components/generic/treeMarkings/ReportTreeMarkings.tsx
#: src/timber/components/treeMarking/TreeMarkingDetail/TreeMarkingDetail.tsx
#: src/timber/pages/treeMarking/TreeMarkingEntityPage.tsx
msgid "Tree Marking"
msgstr "Tree Marking"

#: src/timber/hooks/useTreeMarking.ts
msgid "Tree Marking add error: "
msgstr "Tree Marking add error: "

#: src/timber/hooks/useTreeMarking.ts
msgid "Tree Marking delete error: "
msgstr "Tree Marking delete error: "

#: src/timber/hooks/useTreeMarking.ts
msgid "Tree Marking deleted"
msgstr "Tree Marking deleted"

#: src/timber/components/cutting/CuttingDetail/CuttingTabs.tsx
msgid "Tree Marking Report"
msgstr "Tree Marking Report"

#: src/timber/hooks/useTreeMarking.ts
msgid "Tree Marking update error: "
msgstr "Tree Marking update error: "

#: src/timber/hooks/useTreeMarking.ts
msgid "Tree Marking updated"
msgstr "Tree Marking updated"

#: src/timber/components/generic/treeMarkings/ReportTreeMarkings.tsx
msgid "Tree Marking volume"
msgstr "Tree Marking volume"

#: src/app/mappers.tsx
#: src/timber/components/cutting/CuttingDetail/CuttingTabs.tsx
#: src/timber/components/timberStorage/TimberStorageDetail/TimberStorageTabs.tsx
#: src/timber/components/treeMarking/TreeMarkingList/TreeMarkingListHeader.tsx
msgid "Tree Markings"
msgstr "Tree Markings"

#: src/timber/components/timberStorage/TimberStorageDetail/TimberStorageTabs.tsx
msgid "Tree Markings Report"
msgstr "Tree Markings Report"

#: src/timber/components/shipment/ShipmentDetail/ShipmentDetail.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx
msgid "Truck Registration Number"
msgstr "Truck Registration Number"

#: src/timber/components/shipment/ShipmentDetail/ShipmentDetail.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx
msgid "Trucker Name"
msgstr "Trucker Name"

#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx
msgid "Trucker name at is required"
msgstr "Trucker name at is required"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx
#: src/timber/components/generic/report/GenericRootTable.tsx
#: src/timber/components/generic/treeMarkings/ReportTreeMarkings.tsx
#: src/timber/components/history/HistoryList/HistoryListItem.tsx
msgid "Type"
msgstr "Type"

#: src/share/components/chat/ChatInput.tsx
msgid "Type a message..."
msgstr "Type a message..."

#: src/pages/UnauthorizedPage.tsx
msgid "Unauthorized"
msgstr "Unauthorized"

#: src/pages/UnauthorizedPage.tsx
msgid "Unauthorized Page"
msgstr "Unauthorized Page"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx
msgid "Unmatched rows"
msgstr "Unmatched rows"

#: src/timber/types/models/CuttingState.d.ts
#: src/timber/types/models/ShipmentState.d.ts
msgid "Upcoming"
msgstr "Upcoming"

#: src/address/components/address/AddressForm/AddressUpdateFormProvider.tsx
#: src/auth/components/membersGroup/MembersGroupForm/MembersGroupUpdateFormProvider.tsx
#: src/auth/components/role/RoleForm/RoleUpdateFormProvider.tsx
#: src/auth/components/scopeGroup/ScopeGroupForm/ScopeGroupUpdateFormProvider.tsx
#: src/auth/components/user/UserForm/UserUpdateFormProvider.tsx
#: src/auth/components/userSession/UserSessionForm/UserSessionUpdateFormProvider.tsx
#: src/location/components/location/LocationForm/LocationUpdateFormProvider.tsx
#: src/timber/components/accountingUser/AccountingUserForm/AccountingUserUpdateFormProvider.tsx
#: src/timber/components/buyer/BuyerForm/BuyerUpdateFormProvider.tsx
#: src/timber/components/buyerUser/BuyerUserForm/BuyerUserUpdateFormProvider.tsx
#: src/timber/components/contractor/ContractorForm/ContractorUpdateFormProvider.tsx
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserUpdateFormProvider.tsx
#: src/timber/components/cordwood/CordwoodForm/CordwoodUpdateFormProvider.tsx
#: src/timber/components/cutting/CuttingForm/CuttingUpdateFormProvider.tsx
#: src/timber/components/forestOwner/ForestOwnerForm/ForestOwnerUpdateFormProvider.tsx
#: src/timber/components/log/LogForm/LogUpdateFormProvider.tsx
#: src/timber/components/price/PriceForm/PriceUpdateFormProvider.tsx
#: src/timber/components/pricingProfile/PricingProfileForm/PricingProfileUpdateFormProvider.tsx
#: src/timber/components/provider/ProviderForm/ProviderUpdateFormProvider.tsx
#: src/timber/components/providerUser/ProviderUserForm/ProviderUserUpdateFormProvider.tsx
#: src/timber/components/roadCarrier/RoadCarrierForm/RoadCarrierUpdateFormProvider.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateFormProvider.tsx
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassUpdateFormProvider.tsx
#: src/timber/components/timberClass/TimberClassForm/TimberClassUpdateFormProvider.tsx
#: src/timber/components/timberStorage/TimberStorageForm/TimberStorageUpdateFormProvider.tsx
#: src/timber/components/timberType/TimberTypeForm/TimberTypeUpdateFormProvider.tsx
#: src/timber/components/treeMarking/TreeMarkingForm/TreeMarkingUpdateFormProvider.tsx
msgid "Update"
msgstr "Update"

#: src/timber/pages/accountingUser/AccountingUserUpdateEditPage.tsx
msgid "Update Accounting User"
msgstr "Update Accounting User"

#: src/address/pages/address/AddressUpdateEditPage.tsx
msgid "Update Address"
msgstr "Update Address"

#: src/timber/pages/buyer/BuyerUpdateEditPage.tsx
msgid "Update Buyer"
msgstr "Update Buyer"

#: src/timber/pages/buyerUser/BuyerUserUpdateEditPage.tsx
msgid "Update Buyer User"
msgstr "Update Buyer User"

#: src/timber/pages/contractor/ContractorUpdateEditPage.tsx
msgid "Update Contractor"
msgstr "Update Contractor"

#: src/timber/pages/contractorUser/ContractorUserUpdateEditPage.tsx
msgid "Update Contractor User"
msgstr "Update Contractor User"

#: src/timber/pages/cordwood/CordwoodUpdateEditPage.tsx
msgid "Update Cordwood"
msgstr "Update Cordwood"

#: src/timber/pages/cordwoodHistory/CordwoodHistoryUpdateEditPage.tsx
msgid "Update Cordwood History"
msgstr "Update Cordwood History"

#: src/timber/pages/cutting/CuttingUpdateEditPage.tsx
msgid "Update Cutting"
msgstr "Update Cutting"

#: src/timber/pages/driver/DriverUpdateEditPage.tsx
#~ msgid "Update Driver"
#~ msgstr "Update Driver"

#: src/address/hooks/useAddress.ts
#: src/auth/hooks/useMembersGroup.ts
#: src/auth/hooks/useRole.ts
#: src/auth/hooks/useScopeGroup.ts
#: src/auth/hooks/useUser.ts
#: src/auth/hooks/useUserSession.ts
#: src/location/hooks/useLocation.ts
#: src/timber/hooks/useAccountingUser.ts
#: src/timber/hooks/useBuyer.ts
#: src/timber/hooks/useBuyerUser.ts
#: src/timber/hooks/useContractor.ts
#: src/timber/hooks/useContractorUser.ts
#: src/timber/hooks/useCordwood.ts
#: src/timber/hooks/useCutting.ts
#: src/timber/hooks/useForestOwner.ts
#: src/timber/hooks/useLog.ts
#: src/timber/hooks/usePrice.ts
#: src/timber/hooks/usePricingProfile.ts
#: src/timber/hooks/useProvider.ts
#: src/timber/hooks/useProviderUser.ts
#: src/timber/hooks/useRoadCarrier.ts
#: src/timber/hooks/useShipment.ts
#: src/timber/hooks/useThicknessClass.ts
#: src/timber/hooks/useTimberClass.ts
#: src/timber/hooks/useTimberStorage.ts
#: src/timber/hooks/useTimberType.ts
#: src/timber/hooks/useTreeMarking.ts
msgid "Update error: "
msgstr "Update error: "

#: src/timber/pages/forestOwner/ForestOwnerUpdateEditPage.tsx
msgid "Update Forest Owner"
msgstr "Update Forest Owner"

#: src/location/pages/location/LocationUpdateEditPage.tsx
msgid "Update Location"
msgstr "Update Location"

#: src/timber/pages/log/LogUpdateEditPage.tsx
msgid "Update Log"
msgstr "Update Log"

#: src/timber/pages/logHistory/LogHistoryUpdateEditPage.tsx
msgid "Update Log History"
msgstr "Update Log History"

#: src/auth/pages/membersGroup/MembersGroupUpdateEditPage.tsx
msgid "Update Members Group"
msgstr "Update Members Group"

#: src/auth/pages/membersGroupUser/MembersGroupUserUpdateEditPage.tsx
msgid "Update Members Group User"
msgstr "Update Members Group User"

#: src/timber/pages/price/PriceUpdateEditPage.tsx
msgid "Update Price"
msgstr "Update Price"

#: src/timber/pages/pricingProfile/PricingProfileUpdateEditPage.tsx
msgid "Update Pricing Profile"
msgstr "Update Pricing Profile"

#: src/timber/pages/provider/ProviderUpdateEditPage.tsx
msgid "Update Provider"
msgstr "Update Provider"

#: src/timber/pages/providerUser/ProviderUserUpdateEditPage.tsx
msgid "Update Provider User"
msgstr "Update Provider User"

#: src/timber/pages/roadCarrier/RoadCarrierUpdateEditPage.tsx
msgid "Update Road Carrier"
msgstr "Update Road Carrier"

#: src/auth/pages/role/RoleUpdateEditPage.tsx
msgid "Update Role"
msgstr "Update Role"

#: src/auth/pages/roleAssignment/RoleAssignmentUpdateEditPage.tsx
msgid "Update Role Assignment"
msgstr "Update Role Assignment"

#: src/auth/pages/rolePermission/RolePermissionUpdateEditPage.tsx
msgid "Update Role Permission"
msgstr "Update Role Permission"

#: src/auth/pages/scopeGroup/ScopeGroupUpdateEditPage.tsx
msgid "Update Scope Group"
msgstr "Update Scope Group"

#: src/timber/pages/shipment/ShipmentUpdateEditPage.tsx
msgid "Update Shipment"
msgstr "Update Shipment"

#: src/timber/pages/shipmentHistory/ShipmentHistoryUpdateEditPage.tsx
msgid "Update Shipment History"
msgstr "Update Shipment History"

#: src/timber/pages/thicknessClass/ThicknessClassUpdateEditPage.tsx
msgid "Update Thickness Class"
msgstr "Update Thickness Class"

#: src/timber/pages/timberClass/TimberClassUpdateEditPage.tsx
msgid "Update Timber Class"
msgstr "Update Timber Class"

#: src/timber/pages/timberStorage/TimberStorageUpdateEditPage.tsx
msgid "Update Timber Storage"
msgstr "Update Timber Storage"

#: src/timber/pages/timberType/TimberTypeUpdateEditPage.tsx
msgid "Update Timber Type"
msgstr "Update Timber Type"

#: src/timber/pages/treeMarking/TreeMarkingUpdateEditPage.tsx
msgid "Update Tree Marking"
msgstr "Update Tree Marking"

#: src/auth/pages/user/UserUpdateEditPage.tsx
msgid "Update User"
msgstr "Update User"

#: src/address/pages/userAddress/UserAddressUpdateEditPage.tsx
msgid "Update User Address"
msgstr "Update User Address"

#: src/auth/pages/userSession/UserSessionUpdateEditPage.tsx
msgid "Update User Session"
msgstr "Update User Session"

#: src/timber/components/history/HistoryList/HistoryListSearch.tsx
#: src/timber/types/models/MergedHistory.ts
msgid "Updated"
msgstr "Updated"

#: src/auth/components/user/UserDetail/UserDetail.tsx
#: src/auth/components/userSession/UserSessionDetail/UserSessionDetail.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryDetail/CordwoodHistoryDetail.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListItem.tsx
#: src/timber/components/logHistory/LogHistoryDetail/LogHistoryDetail.tsx
#: src/timber/components/logHistory/LogHistoryList/LogHistoryListItem.tsx
#: src/timber/components/shipmentHistory/ShipmentHistoryDetail/ShipmentHistoryDetail.tsx
#: src/timber/components/shipmentHistory/ShipmentHistoryList/ShipmentHistoryListItem.tsx
msgid "Updated At"
msgstr "Updated At"

#: src/timber/components/history/HistoryList/HistoryListSearch.tsx
msgid "Updated From"
msgstr "Updated From"

#: src/timber/components/history/HistoryList/HistoryListSearch.tsx
msgid "Updated To"
msgstr "Updated To"

#: src/timber/components/shipment/ShipmentDetail/ShipmentTabs.tsx
msgid "Upload"
msgstr "Upload"

#: src/timber/components/shipment/ShipmentRegulator/LogShipmentUpload.tsx
msgid "Upload file"
msgstr "Upload file"

#: src/address/components/userAddress/UserAddressDetail/UserAddressDetail.tsx
#: src/address/components/userAddress/UserAddressForm/UserAddressAddForm.tsx
#: src/address/components/userAddress/UserAddressList/UserAddressListItem.tsx
#: src/auth/components/membersGroupUser/MembersGroupUserDetail/MembersGroupUserDetail.tsx
#: src/auth/components/membersGroupUser/MembersGroupUserList/MembersGroupUserListItem.tsx
#: src/auth/components/membersGroupUser/MembersGroupUserList/MembersGroupUserListSearch.tsx
#: src/auth/components/user/UserDetail/UserDetail.tsx
#: src/auth/components/userSession/UserSessionDetail/UserSessionDetail.tsx
#: src/auth/components/userSession/UserSessionForm/UserSessionAddForm.tsx
#: src/auth/components/userSession/UserSessionList/UserSessionListItem.tsx
#: src/auth/pages/user/UserEntityPage.tsx
msgid "User"
msgstr "User"

#: src/auth/hooks/useUser.ts
msgid "User add error: "
msgstr "User add error: "

#: src/address/components/userAddress/UserAddressDetail/UserAddressDetail.tsx
#: src/address/pages/userAddress/UserAddressEntityPage.tsx
msgid "User Address"
msgstr "User Address"

#: src/address/hooks/useUserAddress.ts
msgid "User Address add error: "
msgstr "User Address add error: "

#: src/address/hooks/useUserAddress.ts
msgid "User Address delete error: "
msgstr "User Address delete error: "

#: src/address/hooks/useUserAddress.ts
msgid "User Address deleted"
msgstr "User Address deleted"

#: src/address/components/userAddress/UserAddressList/UserAddressListHeader.tsx
#: src/app/mappers.tsx
#: src/auth/components/user/UserDetail/UserTabs.tsx
msgid "User Addresses"
msgstr "User Addresses"

#: src/auth/hooks/useUser.ts
msgid "User delete error: "
msgstr "User delete error: "

#: src/auth/hooks/useUser.ts
msgid "User deleted"
msgstr "User deleted"

#: src/auth/components/userSession/UserSessionForm/UserSessionAddForm.tsx
#: src/auth/types/models/GroupType.d.ts
msgid "User Group"
msgstr "User Group"

#: src/auth/components/userSession/UserSessionForm/UserSessionAddForm.tsx
#~ msgid "User Group Id is required"
#~ msgstr "User Group Id is required"

#: src/auth/components/userSession/UserSessionForm/UserSessionAddForm.tsx
msgid "User Group is required"
msgstr "User Group is required"

#: src/address/components/userAddress/UserAddressForm/UserAddressAddForm.tsx
#: src/auth/components/userSession/UserSessionForm/UserSessionAddForm.tsx
#~ msgid "User Id is required"
#~ msgstr "User Id is required"

#: src/address/components/userAddress/UserAddressForm/UserAddressAddForm.tsx
#: src/auth/components/userSession/UserSessionForm/UserSessionAddForm.tsx
msgid "User is required"
msgstr "User is required"

#: src/auth/components/userSession/UserSessionDetail/UserSessionDetail.tsx
#: src/auth/pages/userSession/UserSessionEntityPage.tsx
msgid "User Session"
msgstr "User Session"

#: src/auth/hooks/useUserSession.ts
msgid "User Session add error: "
msgstr "User Session add error: "

#: src/auth/hooks/useUserSession.ts
msgid "User Session delete error: "
msgstr "User Session delete error: "

#: src/auth/hooks/useUserSession.ts
msgid "User Session deleted"
msgstr "User Session deleted"

#: src/auth/hooks/useUserSession.ts
msgid "User Session update error: "
msgstr "User Session update error: "

#: src/auth/hooks/useUserSession.ts
msgid "User Session updated"
msgstr "User Session updated"

#: src/app/mappers.tsx
#: src/auth/components/user/UserDetail/UserTabs.tsx
#: src/auth/components/userSession/UserSessionList/UserSessionListHeader.tsx
msgid "User Sessions"
msgstr "User Sessions"

#: src/timber/components/contractorUser/ContractorUserDetail/ContractorUserDetail.tsx
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserAddForm.tsx
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserUpdateForm.tsx
#: src/timber/components/contractorUser/ContractorUserList/ContractorUserListItem.tsx
#: src/timber/components/providerUser/ProviderUserDetail/ProviderUserDetail.tsx
#: src/timber/components/providerUser/ProviderUserForm/ProviderUserAddForm.tsx
#: src/timber/components/providerUser/ProviderUserForm/ProviderUserUpdateForm.tsx
#: src/timber/components/providerUser/ProviderUserList/ProviderUserListItem.tsx
msgid "User Type"
msgstr "User Type"

#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserAddForm.tsx
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserUpdateForm.tsx
#: src/timber/components/providerUser/ProviderUserForm/ProviderUserAddForm.tsx
#: src/timber/components/providerUser/ProviderUserForm/ProviderUserUpdateForm.tsx
msgid "User Type is required"
msgstr "User Type is required"

#: src/auth/hooks/useUser.ts
msgid "User update error: "
msgstr "User update error: "

#: src/auth/hooks/useUser.ts
msgid "User updated"
msgstr "User updated"

#: src/app/mappers.tsx
#: src/auth/components/membersGroup/MembersGroupDetail/MembersGroupTabs.tsx
#: src/auth/components/user/UserList/UserListHeader.tsx
#: src/auth/pages/listItems.tsx
msgid "Users"
msgstr "Users"

#: src/timber/components/buyer/BuyerDetail/BuyerDetail.tsx
#: src/timber/components/buyer/BuyerForm/BuyerAddForm.tsx
#: src/timber/components/buyer/BuyerForm/BuyerUpdateForm.tsx
#: src/timber/components/buyer/BuyerList/BuyerListItem.tsx
#: src/timber/components/contractor/ContractorDetail/ContractorDetail.tsx
#: src/timber/components/contractor/ContractorForm/ContractorAddForm.tsx
#: src/timber/components/contractor/ContractorForm/ContractorUpdateForm.tsx
#: src/timber/components/contractor/ContractorList/ContractorListItem.tsx
#: src/timber/components/forestOwner/ForestOwnerDetail/ForestOwnerDetail.tsx
#: src/timber/components/forestOwner/ForestOwnerForm/ForestOwnerAddForm.tsx
#: src/timber/components/forestOwner/ForestOwnerForm/ForestOwnerUpdateForm.tsx
#: src/timber/components/forestOwner/ForestOwnerList/ForestOwnerListItem.tsx
#: src/timber/components/provider/ProviderDetail/ProviderDetail.tsx
#: src/timber/components/provider/ProviderForm/ProviderAddForm.tsx
#: src/timber/components/provider/ProviderForm/ProviderUpdateForm.tsx
#: src/timber/components/provider/ProviderList/ProviderListItem.tsx
msgid "Vat Id"
msgstr "Vat Id"

#: src/share/components/footer/Copyright.tsx
msgid "Version"
msgstr "Version"

#: src/address/components/address/AddressList/AddressListItemTools.tsx
#: src/address/components/userAddress/UserAddressList/UserAddressListItemTools.tsx
#: src/auth/components/membersGroup/MembersGroupList/MembersGroupListItemTools.tsx
#: src/auth/components/membersGroupUser/MembersGroupUserList/MembersGroupUserListItemTools.tsx
#: src/auth/components/role/RoleList/RoleListItemTools.tsx
#: src/auth/components/roleAssignment/RoleAssignmentList/RoleAssignmentListItemTools.tsx
#: src/auth/components/rolePermission/RolePermissionList/RolePermissionListItemTools.tsx
#: src/auth/components/scopeGroup/ScopeGroupList/ScopeGroupListItemTools.tsx
#: src/auth/components/user/UserList/UserListItemTools.tsx
#: src/auth/components/userSession/UserSessionList/UserSessionListItemTools.tsx
#: src/location/components/location/LocationList/LocationListItemTools.tsx
#: src/timber/components/accountingUser/AccountingUserList/AccountingUserListItemTools.tsx
#: src/timber/components/buyer/BuyerList/BuyerListItemTools.tsx
#: src/timber/components/buyerUser/BuyerUserList/BuyerUserListItemTools.tsx
#: src/timber/components/contractor/ContractorList/ContractorListItemTools.tsx
#: src/timber/components/contractorUser/ContractorUserList/ContractorUserListItemTools.tsx
#: src/timber/components/cordwood/CordwoodList/CordwoodListItemTools.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListItemTools.tsx
#: src/timber/components/cutting/CuttingList/CuttingListItemTools.tsx
#: src/timber/components/forestOwner/ForestOwnerList/ForestOwnerListItemTools.tsx
#: src/timber/components/log/LogList/LogListItemTools.tsx
#: src/timber/components/logHistory/LogHistoryList/LogHistoryListItemTools.tsx
#: src/timber/components/price/PriceList/PriceListItemTools.tsx
#: src/timber/components/pricingProfile/PricingProfileList/PricingProfileListItemTools.tsx
#: src/timber/components/provider/ProviderList/ProviderListItemTools.tsx
#: src/timber/components/providerUser/ProviderUserList/ProviderUserListItemTools.tsx
#: src/timber/components/roadCarrier/RoadCarrierList/RoadCarrierListItemTools.tsx
#: src/timber/components/shipment/ShipmentList/ShipmentListItemTools.tsx
#: src/timber/components/shipmentHistory/ShipmentHistoryList/ShipmentHistoryListItemTools.tsx
#: src/timber/components/thicknessClass/ThicknessClassList/ThicknessClassListItemTools.tsx
#: src/timber/components/timberClass/TimberClassList/TimberClassListItemTools.tsx
#: src/timber/components/timberStorage/TimberStorageList/TimberStorageListItemTools.tsx
#: src/timber/components/timberType/TimberTypeList/TimberTypeListItemTools.tsx
#: src/timber/components/treeMarking/TreeMarkingList/TreeMarkingListItemTools.tsx
#: src/timber/types/models/UserType.d.ts
msgid "View"
msgstr "View"

#: src/timber/components/cordwood/CordwoodDetail/CordwoodDetail.tsx
#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx
#: src/timber/components/cordwood/CordwoodForm/CordwoodUpdateForm.tsx
#: src/timber/components/cordwood/CordwoodList/CordwoodListItem.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryDetail/CordwoodHistoryDetail.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListItem.tsx
#: src/timber/components/generic/treeMarkings/ReportTreeMarkings.tsx
#: src/timber/components/history/HistoryList/HistoryListItemRow.tsx
#: src/timber/components/shipment/ShipmentRegulator/CordwoodDetail.tsx
#: src/timber/components/shipment/ShipmentRegulator/CordwoodListItemForShipment.tsx
#: src/timber/components/shipment/ShipmentRegulator/CordwoodListItemFromHistory.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogDetail.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogListItemForShipment.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogListItemFromHistory.tsx
msgid "Volume"
msgstr "Volume"

#: src/timber/components/shipment/ShipmentRegulator/CordwoodDetail.tsx
#: src/timber/components/treeMarking/TreeMarkingForm/TreeMarkingAddForm.tsx
#: src/timber/components/treeMarking/TreeMarkingForm/TreeMarkingUpdateForm.tsx
msgid "Volume (m&#xB3;)"
msgstr "Volume (m&#xB3;)"

#: src/timber/components/log/LogList/LogListSearch.tsx
#: src/timber/components/treeMarking/TreeMarkingList/TreeMarkingListSearch.tsx
msgid "Volume (m&#xB3;) From"
msgstr "Volume (m&#xB3;) From"

#: src/timber/components/log/LogList/LogListSearch.tsx
#: src/timber/components/treeMarking/TreeMarkingList/TreeMarkingListSearch.tsx
msgid "Volume (m&#xB3;) To"
msgstr "Volume (m&#xB3;) To"

#: src/timber/components/cordwood/CordwoodDetail/CordwoodDetail.tsx
#: src/timber/components/cordwood/CordwoodList/CordwoodListItem.tsx
#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx
#: src/timber/components/generic/report/GenericRootShipments.tsx
#: src/timber/components/generic/report/GenericRootTable.tsx
#: src/timber/components/log/LogDetail/LogDetail.tsx
#: src/timber/components/log/LogList/LogListItem.tsx
#: src/timber/components/logHistory/LogHistoryDetail/LogHistoryDetail.tsx
#: src/timber/components/logHistory/LogHistoryList/LogHistoryListItem.tsx
#: src/timber/components/provider/ProviderDetail/ProviderSplitTab.tsx
#: src/timber/components/provider/ProviderList/ProviderListItem.tsx
#: src/timber/components/shipment/ShipmentRegulator/CordwoodListItemForShipment.tsx
#: src/timber/components/shipment/ShipmentRegulator/CordwoodListItemFromHistory.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogListItemForShipment.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogListItemFromHistory.tsx
#: src/timber/components/treeMarking/TreeMarkingDetail/TreeMarkingDetail.tsx
#: src/timber/components/treeMarking/TreeMarkingList/TreeMarkingListItem.tsx
msgid "Volume (m³)"
msgstr "Volume (m³)"

#: src/timber/components/cordwood/CordwoodList/CordwoodListSearch.tsx
msgid "Volume From"
msgstr "Volume From"

#: src/timber/components/generic/report/ParetoChart.tsx
msgid "Volume of everything that was produced"
msgstr "Volume of everything that was produced"

#: src/timber/components/generic/report/ParetoChart.tsx
msgid "Volume of the timber that left the storage"
msgstr "Volume of the timber that left the storage"

#: src/timber/components/cordwood/CordwoodList/CordwoodListSearch.tsx
msgid "Volume To"
msgstr "Volume To"

#: src/timber/components/history/HistoryList/HistoryListItem.tsx
msgid "Volume/Type"
msgstr "Volume/Type"

#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx
#~ msgid "Warehouse Location Id is required"
#~ msgstr "Warehouse Location Id is required"

#: src/pages/ForgotPasswordPage.tsx
msgid "We have sent you a password recovery email."
msgstr "We have sent you a password recovery email."

#: src/pages/PrivacyPolicyPage.tsx
msgid "We respect your privacy. This application stores only the data necessary to provide the service and your account access. We do not use non-essential cookies or tracking without your consent."
msgstr "We respect your privacy. This application stores only the data necessary to provide the service and your account access. We do not use non-essential cookies or tracking without your consent."

#: src/share/components/gdpr/CookieConsent.tsx
msgid "We use necessary cookies to make this app work. We will not use non-essential cookies without your consent."
msgstr "We use necessary cookies to make this app work. We will not use non-essential cookies without your consent."

#: src/pages/LoginPage.tsx
msgid "Welcome Back!"
msgstr "Welcome Back!"

#: src/share/components/chat/ChatThread.tsx
#~ msgid "Which buyers are active?"
#~ msgstr "Which buyers are active?"

#: src/share/components/chat/ChatHeader.tsx
msgid "Widen chat"
msgstr "Widen chat"

#: src/timber/components/cordwood/CordwoodList/CordwoodListSearch.tsx
msgid "Without shipment"
msgstr "Without shipment"

#: src/timber/components/cutting/CuttingDetail/CuttingDetail.tsx
#: src/timber/components/cutting/CuttingForm/CuttingAddForm.tsx
#: src/timber/components/cutting/CuttingForm/CuttingUpdateForm.tsx
#: src/timber/components/shipment/ShipmentDetail/ShipmentDetail.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx
msgid "Work Order"
msgstr "Work Order"

#: src/share/components/chat/ChatSpinner.tsx
msgid "Working"
msgstr "Working"

#: src/share/components/chat/ChatToolView.tsx
msgid "yes"
msgstr "yes"

#: src/timber/components/history/HistoryList/HistoryListItemRow.tsx
msgid "Yes"
msgstr "Yes"

#: src/share/components/chat/ConversationList.tsx
#: src/share/components/form/FormDateTime/FormDateRange.tsx
msgid "Yesterday"
msgstr "Yesterday"

#: src/share/components/gdpr/CookieConsent.tsx
msgid "You declined the Terms and Policy. You cannot use the app until you accept them. Reset to start over."
msgstr "You declined the Terms and Policy. You cannot use the app until you accept them. Reset to start over."

#: src/pages/PrivacyPolicyPage.tsx
msgid "You may request an export of your personal data or request deletion of your account by visiting your Profile or contacting support."
msgstr "You may request an export of your personal data or request deletion of your account by visiting your Profile or contacting support."

#: src/hooks/useAuth.ts
msgid "You successfully logged in"
msgstr "You successfully logged in"
